// German translations
export const de = {
  // Common
  'common.noData': 'Keine Daten verfügbar',
  'common.name': 'Name',
  // Navigation
  'nav.overview': 'Übersicht',
  'nav.dashboard': 'Dashboard',
  'nav.analytics': 'Analysen',
  'nav.reportingDashboard': 'Reporting-Dashboard',
  'nav.sales': 'Verkauf',
  'nav.salesOrders': 'Verkaufsaufträge',
  'nav.purchase': 'Einkauf',
  'nav.purchaseOrders': 'Einkaufsaufträge',
  'nav.purchaseReview': 'Prüfungs-Workspace',
  'nav.purchase.sprints': 'Sprints',
  'nav.supplierOnboarding': 'Lieferanten-Onboarding',
  'nav.po': 'PO',
  'nav.po.sprints': 'Sprints',
  'nav.po.newSprint': 'Sprint anlegen',
  'nav.scout': 'Scout',
  'nav.scout.wochenplanung': 'Wochenplanung',
  'nav.scout.tagesplanung': 'Tagesplanung',
  'nav.scout.prequal': 'PreQual Calling',
  'nav.scout.wiedervorlagen': 'Wiedervorlagen',
  'nav.scout.missionen': 'Missionen',
  'nav.scout.meineKunden': 'Meine Kunden',
  'nav.scout.praeferenzen': 'Präferenzen',
  'nav.scout.missionControl': 'Einsatzleitung',
  'nav.scout.unternehmenssuche': 'Unternehmenssuche',
  'nav.scout.preferences': 'Einstellungen',
  'nav.scout.hilfe': 'Hilfe',
  'nav.scout.scorecard': 'Auswertung',
  'nav.poSprints': 'PO/Sprints',
  'nav.wiki': 'Wiki',
  'nav.supportVisualization': 'Support Visualisierung',
  'nav.navigationTiles': 'Navigations-Kacheln',
  'nav.styleGuide': 'Styleguide',
  'nav.inventory': 'Lager',
  'nav.items': 'Artikel',
  'nav.warehouse': 'Lagerhaus',
  'nav.picking': 'Kommissionierung',
  'nav.asn': 'ASN',
  'nav.returns': 'Rückgaben',
  'nav.payments': 'Zahlungen',
  'nav.accounting': 'Buchhaltung',
  'nav.accountsReceivable': 'Forderungen',
  'nav.crm': 'CRM',
  'nav.leads': 'Leads',
  'nav.contacts': 'Kontakte',
  'nav.ai': 'KI',
  'nav.commandCenter': 'Befehlszentrale',
  'nav.workflows': 'Workflows',
  'nav.workflowManagement': 'Workflow-Management',
  'nav.projectManagement': 'Projektmanagement',
  'nav.support': 'Support',
  'nav.tickets': 'Tickets',
  'nav.pivotTable': 'Pivot-Tabelle',
  'nav.learning': 'Lernen',
  'nav.curriculumPlanning': 'Lehrplanplanung',
  'nav.learnerDashboard': 'Lernerdashboard',
  'nav.accessibleLearnerDashboard': 'Barrierefreies Lernerdashboard',
  'nav.settings': 'Einstellungen',
  'nav.general': 'Allgemein',
  'nav.company': 'Unternehmen',
  'nav.addressManagement': 'Adressverwaltung',
  'nav.usersRoles': 'Benutzer & Rollen',
  'nav.auditLog': 'Audit-Protokoll',
  'nav.integrations': 'Integrationen',
  'nav.appOverview': 'App-Übersicht',
  'nav.appOverviewDescription': 'Klicken Sie auf eine App, um zu navigieren, oder ziehen Sie die Kacheln, um sie neu anzuordnen',
  'nav.group.operations': 'Operations',
  'nav.group.sales': 'Vertrieb & CRM',
  'nav.group.supplyChain': 'Einkauf & Logistik',
  'nav.group.tools': 'Werkzeuge',
  'nav.group.other': 'Sonstiges',
  'header.help': 'Hilfe',
  'header.bugReport': 'Fehler melden',
  'header.account': 'Konto',
  'header.portalName': 'CLANDA Portal',
  'header.preferences': 'Einstellungen',
  'header.myProfile': 'Mein Profil',
  'header.language': 'Sprache',
  'header.appearance': 'Darstellung',
  'header.lightMode': 'Hell',
  'header.darkMode': 'Dunkel',
  'header.impersonation': 'Vertretung',
  'header.notifications.title': 'Benachrichtigungen',
  'header.notifications.empty': 'Keine neuen Nachrichten',
  'header.notifications.markAllRead': 'Alle als gelesen markieren',
  'header.notifications.enablePrompt': 'Push-Benachrichtigungen aktivieren?',
  'header.notifications.enableCta': 'Aktivieren',

  // Help page

  // Privacy page

  // Form

  // Placeholders
  
  // Status
  
  // Actions
  'action.delete': 'Löschen',
  
  // Messages
  'message.success': 'Erfolgreich',
  'message.error': 'Fehler',
  
  // Common
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.cancel': 'Abbrechen',
  'common.confirm': 'Bestätigen',
  'common.continue': 'Weiter',
  'common.reject': 'Ablehnen',
  'common.save': 'Speichern',
  'common.update': 'Aktualisieren',
  'common.saving': 'Speichern…',
  'common.saveChanges': 'Änderungen speichern',
  'common.close': 'Schließen',
  'common.refresh': 'Aktualisieren',
  'common.reset': 'Zurücksetzen',
  'common.back': 'Zurück',
  'common.loading': 'Lädt...',
  'common.search': 'Suchen',
  'common.search.placeholder': 'Suchen...',
  'common.filter': 'Filter',
  'atc.filterDrawer.title': 'Filter',
  'atc.filterDrawer.apply': 'Anwenden',
  'atc.filterDrawer.reset': 'Zurücksetzen',
  'atc.filterDrawer.activeCount': '{count} aktiv',
  'common.sort': 'Sortieren',
  'common.add': 'Hinzufügen',
  'common.archive': 'Archivieren',
  'common.delete': 'Löschen',
  'common.edit': 'Bearbeiten',
  'common.error': 'Fehler',
  'common.success': 'Erfolg',
  'common.remove': 'Entfernen',
  'common.verified': 'bestätigt',
  'common.unverified': 'unbestätigt',
  'common.minutesShort': '{{value}} Min',
  'common.na': 'k.A.',
  'common.days': 'Tage',
  'common.status.active': 'aktiv',
  'common.status.paused': 'pausiert',
  'common.status.stopped': 'gestoppt',
  'common.status.pending': 'ausstehend',
  'common.status.completed': 'abgeschlossen',
  'common.status.planned': 'Geplant',
  'common.status.inProgress': 'In Bearbeitung',
  'common.status.done': 'Erledigt',
  'common.apply': 'Übernehmen',
  'common.actions.filter': 'Filter',
  'common.actions.export': 'Exportieren',
  'common.actions.search': 'Suchen',
  'common.dialog.defaultTitle': 'Dialog',
  'common.all': 'Alle',
  'common.clear': 'Zurücksetzen',
  'common.total': 'Gesamt',
  'common.pending': 'Ausstehend',
  'common.assigned': 'Zugewiesen',
  'common.inProgress': 'In Bearbeitung',
  'common.active': 'Aktiv',
  'common.archived': 'Archiviert',
  'common.planned': 'Geplant',
  'common.completed': 'Abgeschlossen',
  'common.cancelled': 'Storniert',
  'common.tryAgain': 'Bitte erneut versuchen',
  'common.review': 'Prüfen',
  'common.title': 'Titel',
  'common.status': 'Status',
  'common.date': 'Datum',
  'common.approve': 'Genehmigen',
  'common.approved': 'Genehmigt',
  'common.rejected': 'Abgelehnt',
  'common.processing': 'Verarbeitung',
  'common.overdue': 'Überfällig',
  'common.partial': 'Teilweise',
  'common.highPriority': 'Hohe Priorität',
  'common.tableView': 'Tabellenansicht',
  'common.cardView': 'Kartenansicht',
  'common.switchToTable': 'Zur Tabellenansicht wechseln',
  'common.switchToCard': 'Zur Kartenansicht wechseln',
  'common.openMenu': 'Menü öffnen',
  'common.details': 'Details',
  'common.overview': 'Übersicht',
  'common.new': 'Neu',
  'common.draft': 'Entwurf',
  'common.shipped': 'Versendet',
  'common.delivered': 'Geliefert',
  'common.received': 'Empfangen',
  'common.inTransit': 'Unterwegs',
  'common.itemsPicked': 'Artikel kommissioniert',
  'common.totalRefund': 'Erstattung gesamt',
  'common.totalPrice': 'Gesamtpreis',
  'common.orderSummary': 'Bestellübersicht',
  'common.subtotal': 'Zwischensumme:',
  'common.tax': 'Steuer:',
  'common.discount': 'Rabatt:',
  'common.totalColon': 'Gesamt:',

  // Date Range Filter (canonical component)
  'dateRange.today': 'Heute',
  'dateRange.yesterday': 'Gestern',
  'dateRange.last7Days': 'Letzte 7 Tage',
  'dateRange.last14Days': 'Letzte 14 Tage',
  'dateRange.last30Days': 'Letzte 30 Tage',
  'dateRange.thisMonth': 'Dieser Monat',
  'dateRange.custom': 'Benutzerdefiniert',

  // Dashboard
  'widget.vsLastPeriod': 'vs. letzte Periode',
  'table.showing': 'Zeige',
  'table.of': 'von',
  'table.page': 'Seite',
  'table.previous': 'Zurück',
  'table.next': 'Weiter',
  'table.filterGroups': 'Filtergruppen',
  'table.addFilterGroup': 'Filtergruppe hinzufügen',
  'table.filterGroup': 'Filtergruppe',
  'table.addCondition': 'Bedingung hinzufügen',
  'table.operator': 'Operator',
  'table.field': 'Feld',
  'table.noFilterGroups': 'Keine Filtergruppen vorhanden.',
  'filter.operator.equals': 'ist gleich',
  'filter.operator.not_equals': 'ist nicht gleich',
  'filter.operator.contains': 'enthält',
  'filter.operator.not_contains': 'enthält nicht',
  'filter.operator.starts_with': 'beginnt mit',
  'filter.operator.ends_with': 'endet mit',
  'filter.operator.gt': 'größer als',
  'filter.operator.lt': 'kleiner als',
  'filter.operator.gte': 'mindestens',
  'filter.operator.lte': 'höchstens',
  'filter.operator.between': 'zwischen',
  'filter.operator.in': 'ist eines von',
  'filter.operator.not_in': 'ist keines von',
  'filter.operator.is_set': 'ist gesetzt',
  'filter.operator.is_not_set': 'ist nicht gesetzt',
  'filter.placeholder.value': 'Wert',
  'filter.placeholder.min': 'Min',
  'filter.placeholder.max': 'Max',
  'filter.placeholder.select': 'Auswählen…',
  'filter.placeholder.selectMultiple': 'Werte auswählen…',
  'filter.logic.and': 'UND',
  'filter.logic.or': 'ODER',

  // Documents
  
  // Validation

  // Toasts

  // Reviewer Dashboard

  // Account / Settings
  'settings.title': 'Kontoeinstellungen',

  // Consent
  'consent.title': 'Zustimmung',
  'consent.label': 'Ich stimme den Bedingungen und der Bestellrichtlinie zu',
  'consent.description': 'Ich habe die Bedingungen gelesen und akzeptiere sie.',
  'consent.required': 'Bitte stimmen Sie den Bedingungen zu.',
  'consent.link.terms': 'Bedingungen',

  // Contacts
  'contacts.title': 'Kontakte',
  'contacts.role': 'Rolle',
  'contacts.role.admin': 'Admin',
  'contacts.role.billing': 'Abrechnung',
  'contacts.role.technical': 'Technisch',
  'contacts.role.other': 'Andere',

  // ARIA / Accessibility

  // Auth
  'auth.callback.title': 'Authentifizierung',

  // Debug
  'debug.report.title': 'Fehlerbericht',
  'debug.report.kindLabel': 'Art der Meldung',
  'debug.report.kindBug': 'Fehler melden',
  'debug.report.kindFeature': 'Feature vorschlagen',
  'debug.report.consentMessage': 'Wir sammeln anonymisierte Diagnosedaten, um das Problem zu analysieren.',
  'debug.report.collecting': 'Daten werden gesammelt…',
  'debug.report.previewMessage': 'Bitte prüfen Sie die gesammelten Daten vor dem Senden.',
  'debug.report.sentMessage': 'Fehlerbericht erfolgreich gesendet.',
  'debug.report.errorMessage': 'Fehlerbericht konnte nicht gesendet werden.',
  'debug.report.sent': 'Gesendet',
  'debug.report.collect': 'Daten sammeln',
  'debug.report.send': 'Bericht senden',
  'debug.report.sending': 'Bericht wird gesendet…',
  'debug.report.download': 'Bundle herunterladen',
  'debug.report.screenshotLabel': 'Screenshot',
  'debug.report.screenshotErrorLabel': 'Screenshot fehlgeschlagen',
  'debug.report.consoleLabel': 'Konsole',
  'debug.report.runtimeErrorsLabel': 'Laufzeitfehler & abgelehnte Promises',
  'debug.report.diagnosticsLabel': 'Diagnose',
  'debug.report.commentLabel': 'Kurzer Kommentar (optional)',
  'debug.report.commentPlaceholder': 'Was hast du gerade gemacht, als das Problem auftrat? Welches Verhalten hast du erwartet?',
  'debug.report.refLabel': 'Deine Fehler-Referenz',
  'debug.report.refCopy': 'Kopieren',
  'debug.report.refCopied': 'Kopiert',
  'debug.report.refHint': 'Gib diese Referenz an, wenn du dich an den Support wendest.',
  'debug.report.refCopyFailed': 'Dein Browser hat das Kopieren blockiert — lies die Referenz oben ab.',
  // Offline-/Transient-Fehler-Ergebnis — der Bericht wurde für die automatische
  // Zustellung bei Reconnect eingereiht (niemals stillschweigend verworfen).
  'debug.report.queued': 'Gespeichert — wird online gesendet',
  'debug.report.queuedMessage': 'Du bist offline oder die Verbindung ist abgebrochen — dein Bericht ist auf diesem Gerät gespeichert und wird automatisch gesendet, sobald du wieder online bist.',
  // Feature-request-Modus-Overrides (FR-FE-BUG-TOOL-FEATURE-REQUEST-FLOW-2026-05-24).
  // tk() in DebugReport.tsx / DebugReport.bugRefPanel.tsx greift zuerst auf diese
  // Schlüssel zu, wenn kind === 'feature', und fällt sonst auf `debug.report.*` zurück.
  'debug.report.feature.title': 'Feature-Wunsch',
  'debug.report.feature.consentMessage': 'Wir sammeln anonymisierte Diagnosedaten, um deinen Wunsch besser zu verstehen.',
  'debug.report.feature.previewMessage': 'Bitte prüfe den erfassten Kontext, bevor du deinen Wunsch sendest.',
  'debug.report.feature.sentMessage': 'Feature-Wunsch erfolgreich gesendet.',
  'debug.report.feature.errorMessage': 'Feature-Wunsch konnte nicht gesendet werden.',
  'debug.report.feature.collect': 'Wunsch starten',
  'debug.report.feature.commentLabel': 'Beschreibe deine Idee (optional)',
  'debug.report.feature.commentPlaceholder': 'Was möchtest du tun können? Welches Problem würde es lösen?',
  'debug.report.feature.refLabel': 'Deine Wunsch-Referenz',
  'debug.report.feature.refHint': 'Gib diese Referenz an, wenn du dich zu deinem Wunsch meldest.',
  'debug.report.feature.queuedMessage': 'Du bist offline oder die Verbindung ist abgebrochen — dein Wunsch ist auf diesem Gerät gespeichert und wird automatisch gesendet, sobald du wieder online bist.',
  'realtime.connectionLost.title': 'Live-Aktualisierung pausiert',
  'realtime.connectionLost.description': 'Die Live-Verbindung für automatische Aktualisierungen ist unterbrochen. Speichern ist davon nicht betroffen; die Daten werden neu geladen, sobald die Verbindung zurück ist.',
  'realtime.connectionRestored.title': 'Live-Aktualisierung wieder aktiv – Daten werden neu geladen',

  // Deliveries

  // SKU Mappings

  // PO List

  // PO Sprints

  // Terms page


  // Common UI Elements

  // Dashboard

  // AI Command Center

  // Helpdesk

  // Scout PreQual
  'scout.dailyPlanning.reportPending': 'Bericht ausstehend',

  // UI Components
  'ui.dependency.none': 'Keine Abhängigkeiten',
  'ui.dependency.add': 'Abhängigkeit hinzufügen',
  'ui.dependency.remove': 'Abhängigkeit entfernen',
  'ui.detailPanel.close': 'Schließen',
  'ui.kanban.noEntries': 'Keine Einträge',
  'ui.kanban.add': 'Hinzufügen',
  'ui.pdfViewer.openNewTab': 'In neuem Tab öffnen',
  'ui.viewTabs.addView': 'Ansicht hinzufügen',

  // Common UI strings
  'common.noEntries': 'Keine Einträge',
  'common.noTasks': 'Keine Aufgaben',
  'common.noContent': 'Kein Inhalt verfügbar. Dokument hat nur Metadaten.',
  'common.selectFromSidebar': 'Dokument aus der Seitenleiste auswählen',
  'common.changeOrder': 'Reihenfolge ändern',
  'common.overdue30d': 'Überfällig (>30T)',
  'common.noOrders': 'Keine Aufträge',
  'common.onlyUnresolved': 'Nur ungeklärt',
  'common.unresolved': 'Ungeklärt',
  'common.priority': 'Priorität',
  'common.assignee': 'Zuständig',
  'common.due': 'Fällig',
  'common.noTasksWithDueDate': 'Keine Aufgaben mit Fälligkeitsdatum',
  'common.noActivities': 'Keine Aktivitäten vorhanden.',
  'common.noDependencies': 'Keine Abhängigkeiten',
  'common.addDependency': 'Abhängigkeit hinzufügen',
  'common.removeDependency': 'Abhängigkeit entfernen',
  'common.addView': 'Ansicht hinzufügen',
  'common.openInNewTab': 'In neuem Tab öffnen',
  'common.sidebar': 'Seitenleiste',

  // Rich text editor
  'editor.heading1': 'Überschrift 1',
  'editor.heading2': 'Überschrift 2',
  'editor.heading3': 'Überschrift 3',
  'editor.bulletList': 'Aufzählung',
  'editor.undo': 'Rückgängig (Cmd+Z)',



  // Learning & Development
  'learning.curriculum.actions.exportJson': 'JSON exportieren',
  'learning.curriculum.actions.exportYaml': 'YAML exportieren',
  'learning.curriculum.actions.import': 'Importieren',
  'learning.curriculum.import.ariaLabel': 'Lehrplan-JSON-Datei importieren',
  'learning.curriculum.tabs.planning': 'Planung',
  'learning.curriculum.tabs.formats': 'Formate',
  'learning.curriculum.tabs.modules': 'Module',
  'learning.curriculum.tabs.weekPlan': 'Wochenplan',
  'learning.curriculum.tabs.statistics': 'Statistiken',
  'learning.curriculum.weekPlan.title': 'Wochenplan',
  'learning.curriculum.weekPlan.placeholder': 'Die Wochenplan-Funktionalität wird hier implementiert.',
  'learning.feed.greeting': 'Hallo {{name}}!',
  'learning.feed.levelInfo': 'Level {{level}} • {{xp}} XP',
  'learning.feed.offline': 'Offline',
  'learning.feed.streakLabel': 'Tage Streak',
  'learning.feed.dailyGoal': 'Tagesziel',
  'learning.feed.recommendedLessons': 'Empfohlene Lektionen',
  'learning.feed.priority.high': 'Hoch',
  'learning.feed.priority.medium': 'Mittel',
  'learning.feed.priority.low': 'Niedrig',
  'learning.feed.difficulty.easy': 'Einfach',
  'learning.feed.difficulty.medium': 'Mittel',
  'learning.feed.difficulty.hard': 'Schwer',
  'learning.feed.aiRecommendation': 'KI-Empfehlung',
  'learning.feed.actions.start': 'Starten',
  'learning.feed.actions.skip': 'Überspringen',
  'learning.feed.actions.reload': 'Neu laden',
  'learning.feed.empty.title': 'Alle Lektionen abgeschlossen!',

  // Helpdesk / Tickets
  'learning.feed.empty.description': 'Du hast alle verfügbaren Lektionen für heute abgeschlossen. Komm morgen wieder!',
  'learning.quiz.title': 'Quiz',
  'learning.quiz.questionCounter': 'Frage {{current}} von {{total}}',
  'learning.quiz.options.true': 'Wahr',
  'learning.quiz.options.false': 'Falsch',
  'learning.quiz.actions.next': 'Weiter',
  'learning.quiz.actions.finish': 'Beenden',
  'learning.quiz.actions.retry': 'Erneut versuchen',
  'learning.quiz.badge.xp': '{{xp}} XP',
  'learning.quiz.badge.time': '{{seconds}}s',
  'learning.quiz.result.passedTitle': 'Quiz bestanden!',
  'learning.quiz.result.failedTitle': 'Quiz nicht bestanden',
  'learning.quiz.result.scoreSummary': '{{correct}} von {{total}} richtig',
  'learning.quiz.result.xpEarned': '+{{xp}} XP erhalten',
  'learning.quiz.result.answersHeading': 'Antworten im Detail',
  'learning.quiz.result.questionLabel': 'Frage {{index}}',
  'learning.quiz.result.yourAnswer': 'Deine Antwort',
  'learning.quiz.result.correctAnswer': 'Richtige Antwort',
  'learning.lehrplan.tabs.planner': 'Curriculum-Planer',
  'learning.lehrplan.tabs.modules': 'Modul-Editor',
  'learning.lessonCard.difficulty.easy': 'Einfach',
  'learning.lessonCard.difficulty.medium': 'Mittel',
  'learning.lessonCard.difficulty.hard': 'Schwierig',
  'learning.lessonCard.status.completed': 'Abgeschlossen',
  'learning.lessonCard.reward': 'Belohnung',
  'learning.lessonCard.progress': 'Fortschritt',
  'learning.lessonCard.selectFormat': 'Format wählen',
  'learning.lessonCard.prerequisites': 'Voraussetzungen',
  'learning.lessonCard.actions.start': 'Starten',
  'learning.lessonCard.actions.repeat': 'Wiederholen',
  'learning.lessonCard.actions.pause': 'Pausieren',
  'learning.lessonCard.actions.complete': 'Abschließen',
  'learning.lessonCard.actions.bookmark': 'Merken',
  'learning.lessonCard.actions.unbookmark': 'Nicht mehr merken',
  'learning.lessonCard.actions.collapse': 'Einklappen',
  'learning.lessonCard.actions.expand': 'Ausklappen',
  'learning.lessonCard.goalLabel': 'Ziel',
  'learning.lessonCard.formats.video': 'Video ansehen',
  'learning.lessonCard.formats.text': 'Text lesen',
  'learning.lessonCard.formats.audio': 'Audio anhören',
  'learning.lessonCard.formats.cheatSheet': 'Spickzettel',
  'learning.lessonCard.formatUnknown': 'Unbekannt',
  'learning.dashboard.title': 'Lerner-Dashboard',
  'learning.dashboard.tabs.feed': 'Lernen',
  'learning.dashboard.tabs.lessons': 'Lektionen',
  'learning.dashboard.tabs.quizzes': 'Quizzes',
  'learning.dashboard.tabs.knowledge': 'Wissen',
  'learning.dashboard.tabs.progress': 'Fortschritt',
  'learning.accessible.title': 'Lern-Dashboard',
  'learning.accessible.welcome': 'Willkommen zurück, {{name}}',
  'learning.accessible.voice.start': 'Sprache',
  'learning.accessible.voice.stop': 'Sprachsteuerung beenden',
  'learning.accessible.voice.listening': 'Hört zu...',
  'learning.accessible.level': 'Level',
  'learning.accessible.xpToNext': '{{value}} XP bis zum nächsten Level',
  'learning.accessible.streak': 'Serie',
  'learning.accessible.days': '{{value}} Tage',
  'learning.accessible.keepItUp': 'Weiter so!',
  'learning.accessible.badges': 'Abzeichen',
  'learning.accessible.achievementsEarned': 'Errungenschaften',
  'learning.accessible.tabs.overview': 'Übersicht',
  'learning.accessible.tabs.lessons': 'Lektionen',
  'learning.accessible.tabs.progress': 'Fortschritt',
  'learning.accessible.tabs.achievements': 'Erfolge',
  'learning.accessible.recentActivity': 'Letzte Aktivitäten',
  'learning.accessible.noRecentActivity': 'Keine Aktivitäten vorhanden',
  'learning.accessible.start': 'Starten',
  'learning.accessible.learningProgress': 'Lernfortschritt',
  'learning.accessible.overallProgress': 'Gesamtfortschritt',
  'learning.accessible.achievements': 'Erfolge',
  'learning.accessible.startingLesson': 'Starte Lektion {{id}}',
  'learning.accessible.difficulty.beginner': 'Einsteiger',
  'learning.accessible.difficulty.intermediate': 'Mittel',
  'learning.accessible.difficulty.advanced': 'Fortgeschritten',

  // Gamification & XP Toast
  'gamification.xpToast.xpLabel': 'XP',
  'gamification.xpToast.streakProgress': 'Streak-Fortschritt',
  'gamification.xpToast.streakProgressValue': '{{current}} / {{target}}',
  'gamification.xpToast.source.lesson': 'Lektion',
  'gamification.xpToast.source.quiz': 'Quiz',
  'gamification.xpToast.source.streak': 'Streak',
  'gamification.xpToast.source.badge': 'Abzeichen',
  'gamification.xpToast.source.bonus': 'Bonus',
  'gamification.xpToast.levelUp.title': 'Level-Aufstieg!',
  'gamification.xpToast.levelUp.description': 'Du hast Level {{level}} erreicht!',
  'gamification.xpToast.levelUp.xpEarned': '+{{xp}} XP erhalten',
  'gamification.xpToast.button.continue': 'Weiter',
  'gamification.xpToast.streakMilestone.title': 'Streak-Meilenstein!',
  'gamification.xpToast.streakMilestone.description': '{{count}}-Tage-Streak erreicht!',
  'gamification.xpToast.streakMilestone.bonus': '+{{xp}} XP Bonus erhalten',
  'gamification.close': 'Schließen',

  // Wissensdatenbank
  'knowledgeBase.back': 'Zurück',
  'knowledgeBase.article.view': 'Anzeigen',
  'knowledgeBase.article.views': '{{count}} Aufrufe',
  'knowledgeBase.article.helpful': '{{count}} hilfreich',
  'knowledgeBase.article.notHelpful': '{{count}} nicht hilfreich',
  'knowledgeBase.article.byAuthor': 'Von {{author}}',
  'knowledgeBase.header.title': 'Wissensdatenbank',
  'knowledgeBase.header.subtitle': 'Finde Antworten auf deine Fragen',
  'knowledgeBase.actions.filter': 'Filter',
  'knowledgeBase.actions.sort': 'Sortieren',
  'knowledgeBase.search.placeholder': 'Suche in der Wissensdatenbank...',
  'knowledgeBase.tabs.all': 'Alle',
  'knowledgeBase.stats.popular': 'Beliebteste Artikel',
  'knowledgeBase.stats.viewsCount': '{{count}} Aufrufe',
  'knowledgeBase.stats.helpful': 'Hilfreichste Artikel',
  'knowledgeBase.stats.ratingsCount': '{{count}} Bewertungen',
  'knowledgeBase.stats.total': 'Gesamt Artikel',
  'knowledgeBase.stats.totalCount': '{{count}} Artikel',
  'knowledgeBase.empty.title': 'Keine Artikel gefunden',
  'knowledgeBase.empty.searching': 'Versuche andere Suchbegriffe oder schaue in den Kategorien.',
  'knowledgeBase.empty.default': 'Es sind noch keine Artikel in dieser Kategorie verfügbar.',
  'knowledgeBase.difficulty.beginner': 'Einsteiger',
  'knowledgeBase.difficulty.intermediate': 'Fortgeschritten',
  'knowledgeBase.difficulty.advanced': 'Experte',
  'knowledgeBase.categories.odoo-basics': 'Odoo Grundlagen',
  'knowledgeBase.categories.crm': 'CRM & Verkauf',
  'knowledgeBase.categories.inventory': 'Lager & Einkauf',
  'knowledgeBase.categories.accounting': 'Buchhaltung',
  'knowledgeBase.categories.projects': 'Projektmanagement',
  'knowledgeBase.categories.troubleshooting': 'Problemlösung',

  // Accounting

  // Curriculum Planning
  'curriculum.video': 'Video',
  'curriculum.videoDescription': 'Bildschirmaufnahme oder Praxis-Video',
  'curriculum.cheatSheet': 'Spickzettel',
  'curriculum.cheatSheetDescription': 'Druckfertig, QR-Codes',
  'curriculum.test': 'Test/Quiz',
  'curriculum.testDescription': 'Odoo Umfrage, 10 Fragen, 80%',
  'curriculum.checklist': 'Checkliste',
  'curriculum.checklistDescription': 'Odoo Aufgaben, anklickbar',
  'curriculum.textLesson': 'Text/Lektion',
  'curriculum.textLessonDescription': 'Odoo Kurs-Lektion',
  'curriculum.roleplay': 'Rollenspiel',
  'curriculum.roleplayDescription': 'Live mit Pate/Benno',
  'curriculum.practice': 'Praxisaufgabe',
  'curriculum.practiceDescription': 'Beim Kunden durchführen',

  // UI Components
  // Common Actions

  // Purchase Onboarding (wizard)

  // SCOUT - Wochenplanung
  'scout.wochenplanung.title': 'Wochenübersicht',
  'scout.wochenplanung.previousWeek': 'Vorherige Woche',
  'scout.wochenplanung.nextWeek': 'Nächste Woche',
  'scout.wochenplanung.toast.appointmentAdded': 'Termin hinzugefügt',
  'scout.wochenplanung.toast.appointmentAddedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentUpdated': 'Termin aktualisiert',
  'scout.wochenplanung.toast.appointmentUpdatedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentDeleted': 'Termin gelöscht',
  'scout.wochenplanung.toast.syncFailed': 'Sync fehlgeschlagen',
  'scout.wochenplanung.toast.syncFailedDesc': '"{{title}}" wird automatisch erneut synchronisiert.',
  'scout.wochenplanung.toast.queueFailed': 'Konnte nicht offline gespeichert werden',
  'scout.wochenplanung.toast.queueFailedDesc': '"{{title}}" konnte nicht in die Offline-Warteschlange geschrieben werden – bitte erneut versuchen.',
  'scout.wochenplanung.toast.deleteSyncFailed': 'Löschung nicht synchronisiert',
  'scout.wochenplanung.toast.deleteSyncFailedDesc': '"{{title}}" wird automatisch erneut gelöscht.',
  'scout.wochenplanung.toast.slotUpdated': 'Slot aktualisiert',
  'scout.wochenplanung.toast.slotUpdatedDesc': 'Mission gelöst oder Slot entfernt.',
  // Shown once after the 2026-04-25 fix migrates localStorage from
  // weekday-keyed (`Montag`/…) to ISO-keyed (`2026-04-28`/…) appointments.
  // Legacy entries never successfully synced to SL so dropping is safe.
  'scout.wochenplanung.toast.legacyAppointmentsDropped': 'Termine zurückgesetzt',
  'scout.wochenplanung.toast.legacyAppointmentsDroppedDesc': '{{count}} alte Einträge wurden wegen eines Bug-Fixes entfernt. Bitte bei Bedarf neu eintragen.',
  
  // Planning legend
  'scout.wochenplanung.legend.completed': 'Erledigt',
  'scout.wochenplanung.legend.planned': 'Geplant',
  'scout.wochenplanung.legend.partial': 'Teilweise geplant',
  'scout.wochenplanung.legend.unplanned': 'Zu planen',
  'scout.wochenplanung.legend.holiday': 'Feiertag/Urlaub',
  
  // Missions section
  
  // Map section
  'scout.wochenplanung.dialog.deleteAppointment.title': 'Termin löschen',
  'scout.wochenplanung.dialog.deleteAppointment.description': 'Möchten Sie diesen Termin wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
  'scout.wochenplanung.dialog.editAppointment.title': 'Termin bearbeiten',
  'scout.wochenplanung.dialog.editAppointment.description': 'Möchten Sie die Änderungen an diesem Termin übernehmen?',
  'scout.wochenplanung.employee': 'Mitarbeiter',
  'scout.wochenplanung.selectEmployee': 'Mitarbeiter auswählen',
  'scout.wochenplanung.allEmployees': 'Alle Mitarbeiter',
  'scout.wochenplanung.error.loading': 'Fehler beim Laden der Wochenplanung',
  'scout.wochenplanung.error.retry': 'Erneut versuchen',
  'scout.wochenplanung.greeting.morning': 'Guten Morgen',
  'scout.wochenplanung.greeting.afternoon': 'Guten Tag',
  'scout.wochenplanung.greeting.evening': 'Guten Abend',
  'scout.wochenplanung.greeting.subtitle': 'Hier ist deine Woche auf einen Blick.',
  'scout.wochenplanung.greeting.planned': 'geplant',
  'scout.wochenplanung.greeting.done': 'erledigt',

  // Quiz
  'quiz.title': 'Produktwissen Quiz',
  'quiz.noQuizzes': 'Keine Quizze verfügbar.',
  'quiz.correct': 'richtig',
  'quiz.points': 'Punkte',
  'quiz.check': 'Prüfen',
  'quiz.next': 'Weiter',
  'quiz.finish': 'Ergebnis',
  'quiz.restart': 'Nochmal',

  // Scan Order
  'scan.title': 'Bestellblock scannen',
  'scan.capture': 'Bestellblock fotografieren',
  'scan.capture.description': 'Fotografiere den ausgefüllten Bestellblock. Die Bestellung wird automatisch erkannt.',
  'scan.customer': 'Kunde',
  'scan.takePhoto': 'Foto aufnehmen',
  'scan.preview': 'Scan-Vorschau',
  'scan.processing': 'Wird verarbeitet...',
  'scan.confidence': 'Erkennungsqualität',
  'scan.lineItems': 'Positionen',
  'scan.noItems': 'Keine Positionen erkannt.',
  'scan.product': 'Produkt',
  'scan.quantity': 'Menge',
  'scan.unit': 'Einheit',
  'scan.unit.placeholder': 'Stk/L/kg',
  'scan.price': 'Einzelpreis',
  'scan.sku': 'Artikelnr.',
  'scan.notes': 'Notiz',
  'scan.reject': 'Verwerfen',
  'scan.confirm': 'Bestätigen',
  'scan.confirmed': 'Bestellung bestätigt',
  'scan.confirmed.description': 'Die Bestellung wird an Odoo übertragen.',
  'scan.queued': 'Gespeichert – wird synchronisiert',
  'scan.queued.description': 'Die Bestellung ist sicher gespeichert und wird automatisch an Odoo übertragen, sobald die Verbindung steht.',
  'scan.rejected': 'Scan verworfen',
  'scan.newScan': 'Neuen Scan',
  'scan.retry': 'Erneut versuchen',
  'scan.error.title': 'Fehler beim Scannen',
  'scan.error.unknown': 'Unbekannter Fehler',
  'scan.error.upload': 'Upload fehlgeschlagen',
  'scan.error.confirm': 'Bestätigung fehlgeschlagen',
  'scan.error.reject': 'Ablehnung fehlgeschlagen',

  // SCAN — WhatsApp Bestellschein review (MO-BESTELLSCHEIN-WA S-WA-03,
  // /scan/review/:scanId?token=…). Rep arrives via WA link, signed
  // token = auth, no login.
  'scan.review.title': 'Bestellung prüfen',
  'scan.review.error.tokenMissing': 'Link ungültig — bitte neuen Link per WhatsApp anfordern.',
  'scan.review.error.expired': 'Link abgelaufen — bitte neuen Link per WhatsApp anfordern.',
  'scan.review.error.invalid': 'Link ungültig oder nicht mehr berechtigt — bitte neuen Link per WhatsApp anfordern.',
  'scan.review.error.confirmTitle': 'Bestätigung fehlgeschlagen',
  'scan.review.error.confirmFailed': 'Die Bestätigung konnte nicht übermittelt werden. Bitte erneut versuchen.',
  'scan.review.rejectAcknowledged': 'Bestellung verworfen — du kannst das Fenster schließen.',

  // SCOUT - Mission list empty state & actions
  'scout.missions.industries.placeholder': 'Branchen auswählen',
  'scout.missions.industries.search': 'Branchen suchen...',
  'scout.missions.industries.empty': 'Keine Branchen gefunden',
  'scout.missions.products.placeholder': 'Produktfamilien auswählen',
  'scout.missions.products.search': 'Produktfamilien suchen...',
  'scout.missions.products.empty': 'Keine Produktfamilien gefunden',
  'scout.missionControl.tabs.team': 'Teamübersicht',
  'scout.missionControl.teamMembers': 'Teammitglieder',
  'scout.missionControl.table.employee': 'Mitarbeiter',
  'scout.missionControl.table.team': 'Team',
  'scout.missionControl.table.plzAreas': 'PLZ-Bereiche',

  // SCOUT - Mission Preferences

  // SCOUT - Missionen
  'scout.missionen.bestandskunden.loadError': 'Fehler beim Laden der Bestandskunden',
  'scout.missionen.bestandskunden.empty': 'Keine Bestandskunden gefunden',
  'scout.missionen.bestandskunden.company': 'Firma',
  'scout.missionen.bestandskunden.lastContact': 'Letzter Kontakt',
  'scout.missionen.bestandskunden.revenue': 'Umsatz (EUR)',
  'scout.missionen.bestandskunden.products': 'Produkte',
  'scout.missionen.bestandskunden.singular': 'Bestandskunde',
  'scout.missionen.bestandskunden.plural': 'Bestandskunden',
  'scout.missionen.bestandskunden.selected': 'ausgewählt',
  'scout.missionen.bestandskunden.markForNextWeek': 'für nächste Woche markieren',
  'scout.missionen.bestandskunden.search': 'Bestandskunden suchen...',
  'scout.missionen.bestandskunden.filteredCount': '{{filtered}} von {{total}} Bestandskunden',
  'scout.missionen.wunschliste.industriesTitle': 'Bevorzugte Branchen',
  'scout.missionen.wunschliste.productsTitle': 'Bevorzugte Produkte',
  'scout.missionen.wunschliste.plzTitle': 'Bevorzugte PLZ-Regionen',
  'scout.missionen.wunschliste.saveButton': 'Speichern',
  'scout.missionen.wunschliste.saved': 'Gespeichert',
  'scout.missionen.wunschliste.savedDesc': 'Deine Präferenzen wurden gespeichert.',
  'scout.missionen.wunschliste.saveError': 'Fehler',
  'scout.missionen.wunschliste.saveErrorDesc': 'Präferenzen konnten nicht gespeichert werden.',
  'scout.missionen.wunschliste.loadError': 'Fehler beim Laden der Präferenzen',
  'scout.praeferenzen.title': 'Präferenzen',
  'scout.praeferenzen.subtitle': 'Wunsch / Präferenzen für weitere Missionen',
  'scout.tagesplanung.title': 'Tagesplanung',
  'scout.tagesplanung.addressUnknown': 'Adresse unbekannt',
  'scout.tagesplanung.routeMapLabel': 'Routenkarte',
  'scout.tagesplanung.addAppointment': 'Termin hinzufügen',
  'scout.tagesplanung.daySchedule': 'Tagesplan',
  'scout.tagesplanung.noScheduleItems': 'Keine Termine oder VIP-Stops für diesen Tag',
  'scout.tagesplanung.routePlanning': 'Routenplanung',
  'scout.tagesplanung.traffic': 'Verkehr',
  'scout.tagesplanung.showTraffic': 'Verkehr ein-/ausblenden',
  'scout.tagesplanung.optimizeRoute': 'Route optimieren',
  'scout.tagesplanung.computeRoute': 'Route berechnen',
  'scout.tagesplanung.optimizingRoute': 'Wird berechnet…',
  'scout.tagesplanung.routeNotComputed': 'Route noch nicht berechnet.',
  'scout.tagesplanung.missingCoords': '{{missing}} von {{total}} Stops ohne Koordinaten — Tower benachrichtigen.',
  'scout.tagesplanung.reoptimizeRoute': 'Route optimieren',
  'scout.tagesplanung.routeOptimized': 'Route wurde optimiert',
  'scout.tagesplanung.routeOptimizeFailed': 'Route konnte nicht optimiert werden',
  'scout.tagesplanung.error': 'Aktion fehlgeschlagen',
  'scout.tagesplanung.reorderFailed': 'Reihenfolge konnte nicht geändert werden',
  'scout.tagesplanung.pinFailed': 'Anker konnte nicht gesetzt werden',
  'scout.tagesplanung.deferNotPossible': 'Zurückstellen nicht möglich',
  'scout.tagesplanung.deferMaxReached': 'Maximale Anzahl an Zurückstellungen für heute erreicht (3/3).',
  'scout.tagesplanung.deferAlreadyDeferred': 'Dieser Lead wurde heute bereits zurückgestellt.',
  'scout.tagesplanung.dayCannotClose': 'Tag kann nicht geschlossen werden',
  'scout.tagesplanung.outstandingReports': 'Es gibt noch {{count}} ausstehende Besuchsberichte. Bitte fülle alle aus, bevor du den Tag schließt.',
  'scout.tagesplanung.andMore': '... und {{count}} weitere',
  'scout.tagesplanung.nextVisit': 'Nächster Besuch',
  'scout.tagesplanung.fillLater': 'Später ausfüllen',
  // WU-0..5 governed field-day LIVE flow (gated behind the `governed_day`
  // feature flag / `?preview=governed`). Rep-facing German copy for the
  // per-stop LiveStopFlow ladder + its pure-FE refinements.
  'scout.liveSession.stop.anfahren': 'Anfahren',
  'scout.liveSession.stop.skip': 'Skip',
  'scout.liveSession.stop.pause': 'Pause',
  'scout.liveSession.stop.noCompany': 'Unbenannter Stopp',
  'scout.liveSession.stop.noAddress': 'Keine Adresse hinterlegt',
  'scout.liveSession.enroute.arrived': 'Ich bin angekommen',
  'scout.liveSession.enroute.openMaps': 'In Google Maps öffnen',
  'scout.liveSession.enroute.noMaps': 'Keine Navigations-Adresse verfügbar',
  'scout.liveSession.enroute.noCompany': 'Unbenannter Stopp',
  'scout.liveSession.atVisit.besuchBeenden': 'Besuch beenden',
  'scout.liveSession.atVisit.briefing': 'Briefing öffnen',
  'scout.liveSession.atVisit.company': 'Webseite öffnen',
  'scout.liveSession.atVisit.noCompany': 'Unbenannter Stopp',
  'scout.liveSession.atVisit.confirmTitle': 'Besuch beenden?',
  'scout.liveSession.atVisit.confirmDescription': 'Der Besuch wird beendet und der Besuchsbericht geöffnet.',
  'scout.liveSession.atVisit.confirmCta': 'Ja, beenden',
  'scout.liveSession.atVisit.confirmCancel': 'Abbrechen',
  'scout.liveSession.atVisit.notesLabel': 'Sonstige Notizen',
  'scout.liveSession.atVisit.notesPlaceholder': 'Notizen zum Besuch …',
  'scout.tagesplanung.noMissions': 'Keine Missionen',
  'scout.tagesplanung.noMissionsLabel': 'Missionen',
  'scout.tagesplanung.noMissionsDesc': 'Für diesen Tag sind keine Missionen geplant.',
  'scout.tagesplanung.tabs.planning': 'Tagesplan',
  'scout.tagesplanung.tasks.tabLabel': 'Aufgaben',
  'scout.tagesplanung.tasks.empty': 'Keine Aufgaben',
  // Unsynced-reports surface (FR-FE-VISIT-REPORT-SILENT-SYNC-LOSS): queued +
  // failed visit reports the rep must see + re-trigger. Never silently lost.
  'scout.unsyncedReports.title': 'Nicht synchronisierte Berichte',
  'scout.unsyncedReports.queuedHeading': 'Wird synchronisiert',
  'scout.unsyncedReports.queuedHint': 'Offline gespeichert – wird automatisch gesendet, sobald du wieder online bist.',
  'scout.unsyncedReports.failedHeading': 'Senden fehlgeschlagen',
  'scout.unsyncedReports.failedHint': 'Diese Berichte konnten nicht gesendet werden. Deine Eingaben sind sicher gespeichert – bitte erneut synchronisieren.',
  'scout.unsyncedReports.conflictHeading': 'Konflikt',
  'scout.unsyncedReports.conflictHint': 'Auf dem Server liegen neuere Daten. Beim erneuten Synchronisieren wird dein Bericht erneut gesendet.',
  'scout.unsyncedReports.statusQueued': 'In Warteschlange',
  'scout.unsyncedReports.statusFailed': 'Fehlgeschlagen',
  'scout.unsyncedReports.statusConflict': 'Konflikt',
  'scout.unsyncedReports.resync': 'Jetzt synchronisieren',
  'scout.unsyncedReports.resyncing': 'Wird synchronisiert …',
  'scout.unsyncedReports.finalHeading': 'Vom Server abgelehnt',
  'scout.unsyncedReports.finalHint': 'Der Server hat diese Berichte endgültig abgelehnt – sie werden nicht erneut gesendet. Bitte das Büro kontaktieren oder den Bericht verwerfen.',
  'scout.unsyncedReports.statusFinal': 'Abgelehnt',
  'scout.unsyncedReports.finalCode': 'Fehlercode: {{code}}',
  'scout.tagesplanung.tasks.loading': 'Aufgaben werden geladen',
  'scout.tagesplanung.tasks.error': 'Aufgaben konnten nicht geladen werden',
  'scout.tagesplanung.tasks.filterFieldStatus': 'Status',
  'scout.tagesplanung.tasks.filterStatusTodo': 'Offen',
  'scout.tagesplanung.tasks.filterStatusInProgress': 'In Bearbeitung',
  'scout.tagesplanung.tasks.filterStatusDone': 'Erledigt',
  'scout.tagesplanung.tasks.priorityLabel': 'Priorität',
  'scout.tagesplanung.tasks.priorityValue': '{{value}}',
  'scout.tagesplanung.tasks.priorityUnknown': '—',
  'scout.tagesplanung.tasks.dueLabel': 'Fällig',
  'scout.tagesplanung.tasks.dueNone': 'Keine Fälligkeit',
  'scout.lead.neukunde': 'Neukunde — Nischenprodukt als Türöffner',
  'scout.lead.bestandskunde': 'Bestandskunde',
  'scout.metrics.besuche': 'Besuche',
  'scout.metrics.demos': 'Demos',
  'scout.metrics.auftraege': 'Aufträge',
  'scout.metrics.umsatz': 'Umsatz',
  'scout.metrics.demoRate': 'Demo-Rate',
  'scout.composition.title': 'Mission-Zusammensetzung',
  'scout.composition.minBestandskunden': 'Min. Bestandskunden',
  'scout.composition.minQualifiziert': 'Min. Qualifizierte Leads',
  'scout.composition.maxKaltbesuche': 'Max. Kaltbesuche',

  // Scout daily planning
  'scout.dailyPlanning.addAppointment': 'Termin hinzufügen',
  'scout.dailyPlanning.appointments': 'Termine',
  'scout.dailyPlanning.noAppointmentsPlanned': 'Keine Termine für diesen Tag geplant',
  'scout.dailyPlanning.leadsByPriority': 'Leads (nach Priorität)',
  'scout.dailyPlanning.noLeadsPlanned': 'Keine Leads für diesen Tag geplant',
  'scout.dailyPlanning.skipLead': 'Lead überspringen',
  'scout.dailyPlanning.skipLeadConfirmation': 'Möchtest du diesen Lead wirklich überspringen? Er wird auf den nächsten Tag verschoben.',
  'scout.dailyPlanning.skip': 'Überspringen',
  // P21: Pre-visit skip/remove flow
  'scout.skipFlow.title': 'Warum überspringen?',
  'scout.skipFlow.group.address': 'Adresse / Standort',
  'scout.skipFlow.reason.wrongLocation': 'Richtige Firma, falscher Standort',
  'scout.skipFlow.reason.addressNotFound': 'Firma nicht an dieser Adresse',
  'scout.skipFlow.reason.addressInvalid': 'Adresse existiert nicht',
  'scout.skipFlow.group.businessGone': 'Geschäft existiert nicht mehr',
  'scout.skipFlow.reason.businessClosed': 'Geschlossen',
  'scout.skipFlow.reason.businessDissolved': 'Firma aufgelöst / insolvent',
  'scout.skipFlow.group.known': 'Kenne ich bereits',
  'scout.skipFlow.reason.existingCustomer': 'Ist Bestandskunde (bereits unser Kunde)',
  'scout.skipFlow.reason.recentlyVisited': 'Kürzlich besucht (von mir oder Kollege)',
  'scout.skipFlow.reason.duplicate': 'Duplikat (gleiche Firma wie anderer Lead)',
  'scout.skipFlow.group.timing': 'Termin / Timing',
  'scout.skipFlow.reason.appointmentRejected': 'Termin abgelehnt (telefonisch)',
  'scout.skipFlow.reason.visitLater': 'Später besuchen',
  'scout.skipFlow.reason.dmNotAvailable': 'Entscheider gerade nicht erreichbar',
  'scout.skipFlow.reason.outOfTerritory': 'Außerhalb meines Gebiets',
  'scout.skipFlow.reason.other': 'Sonstiges',
  'scout.skipFlow.timeframeTitle': 'Wann wieder besuchen?',
  'scout.skipFlow.timeframe.nextWeek': 'Nächste Woche',
  'scout.skipFlow.timeframe.in2Weeks': 'In 2 Wochen',
  'scout.skipFlow.timeframe.in1Month': 'In einem Monat',
  'scout.skipFlow.timeframe.in3Months': 'In 3 Monaten',
  'scout.skipFlow.freeTextTitle': 'Was ist der Grund?',
  'scout.skipFlow.freeTextPlaceholder': 'Beschreibe den Grund...',
  'scout.skipFlow.next': 'Weiter',
  'scout.skipFlow.confirmTitle': 'Zusammenfassung',
  'scout.skipFlow.confirmCategory': 'Kategorie',
  'scout.skipFlow.confirmReason': 'Grund',
  'scout.skipFlow.confirmTimeframe': 'Erneut besuchen',
  'scout.skipFlow.confirmNote': 'Anmerkung',
  'scout.skipFlow.submitButton': 'Lead überspringen',
  'scout.skipFlow.submitted': 'Lead übersprungen',
  'scout.skipFlow.error': 'Lead konnte nicht übersprungen werden',
  'scout.dailyPlanning.removeLead': 'Lead entfernen',
  'scout.dailyPlanning.removeLeadConfirmation': 'Möchtest du diesen Lead wirklich entfernen? Er wird aus der Rotation komplett entfernt.',
  'scout.dailyPlanning.selectMissionToViewLeads': 'Wähle eine Mission zum Anzeigen der Leads',
  'scout.dailyPlanning.noMissionForDay': 'Keine Mission für diesen Tag',
  'scout.dailyPlanning.selectDate': 'Datum auswählen',
  'scout.dailyPlanning.nextDay': 'Nächster Tag',
  'scout.dailyPlanning.closeDay': 'Tag abschließen',
  'scout.dailyPlanning.startHomeReturn': 'Heimfahrt',
  'scout.dailyPlanning.homeReturnActive': 'Auf Heimfahrt',
  'scout.dailyPlanning.reopenDay': 'Tag wieder öffnen',
  'scout.dailyPlanning.noAcceptedLeads': 'Keine akzeptierten Leads für diesen Tag.',
  'scout.dailyPlanning.statusSkipped': 'Übersprungen',
  'scout.dailyPlanning.selectAll': 'Alle auswählen',
  'scout.dailyPlanning.selectAllLeads': 'Alle Leads auswählen',
  'scout.dailyPlanning.noSuggestions': 'Keine Vorschläge.',
  'scout.dailyPlanning.previousDay': 'Vorheriger Tag',
  'scout.dailyPlanning.calendarWeek': 'Kalenderwoche {{weekNumber}}',
  'scout.dailyPlanning.visit': 'Besuch',
  'scout.dailyPlanning.details': 'Details',
  'scout.dailyPlanning.missionsLoading': 'Missionen werden geladen…',
  'scout.dailyPlanning.leadsLoading': 'Leads werden geladen…',
  'scout.dailyPlanning.noLeadsFound': 'Keine Leads gefunden',
  'scout.dailyPlanning.moreLeads': 'weitere',
  'scout.dailyPlanning.dailyList': 'Tagesliste',
  'scout.dailyPlanning.unknown': 'Unbekannt',
  'scout.dailyPlanning.suggestedLeads': 'Vorgeschlagene Leads',
  'scout.dailyPlanning.error': 'Fehler: {{error}}',
  'scout.dailyPlanning.help': 'Hilfe',
  'scout.dailyPlanning.bulkActions': 'Bulk-Aktionen',
  'scout.dailyPlanning.actionsCount': 'Aktionen ({{count}})',
  'scout.dailyPlanning.accept': 'Akzeptieren',
  'scout.dailyPlanning.reject': 'Ablehnen',
  'scout.dailyPlanning.selectLead': 'Lead {{name}} auswählen',
  'scout.dailyPlanning.openLeadDetails': 'Details zu {{name}} öffnen',
  'scout.dailyPlanning.score': 'Score: {{score}}',
  'scout.dailyPlanning.loading': 'Tagesplanung wird geladen',
  // Scout weekly planning
  // Scout scorecard
  'scout.scorecard.selectHeatmapMetric': 'Metrik für Heatmap auswählen',
  'scout.scorecard.orders': 'Aufträge',
  'scout.scorecard.annualTargetOrders': 'Jahresziel Aufträge',
  'scout.scorecard.comingSoon': 'Demnächst verfügbar',
  'scout.scorecard.kpiOverview': 'KPI-Übersicht, Aktivitäten und Top-Branchen',
  'scout.scorecard.activityByDay': 'Aktivität nach Tagen',
  'scout.scorecard.title': 'Auswertung',
  'scout.scorecard.period.tag': 'Tag',
  'scout.scorecard.period.woche': 'Woche',
  'scout.scorecard.period.monat': 'Monat',
  'scout.scorecard.period.jahr': 'Jahr',
  'scout.scorecard.kpiTilesHeading': 'KPI-Kacheln',
  'scout.scorecard.topBranchenProdukteHeading': 'Top Branchen und Top Produkte',
  'scout.scorecard.soll': 'Soll',
  'scout.scorecard.forecast': 'Forecast',
  'scout.scorecard.gapToGo': 'Gap-to-Go',
  'scout.scorecard.csvExport': 'CSV Export',
  'scout.scorecard.pdfExport': 'PDF Export',
  'scout.scorecard.table.date': 'Datum',
  'scout.scorecard.table.visits': 'Besuche',
  'scout.scorecard.table.demos': 'Demos',
  'scout.scorecard.table.orders': 'Aufträge',
  'scout.scorecard.table.60l': '60L',
  'scout.scorecard.table.25l': '25L',
  'scout.scorecard.table.10l': '10L',
  'scout.scorecard.table.netRevenue': 'Nettoumsatz',
  'scout.scorecard.table.total': 'Summe',
  'scout.scorecard.topBranchen': 'Top Branchen',
  'scout.scorecard.topProdukte': 'Top Produkte',
  'scout.scorecard.table.industry': 'Branche',
  'scout.scorecard.table.quantity': 'Menge (Gebinde)',
  'scout.scorecard.table.revenue': 'Umsatz (€)',
  'scout.scorecard.table.product': 'Produkt',
  'scout.scorecard.table.salesVolume': 'Absatzmenge',
  'scout.scorecard.table.customers': 'Kunden',
  'scout.scorecard.kpi.visits': 'Besuche',
  'scout.scorecard.kpi.demos': 'Demos',
  'scout.scorecard.kpi.orders': 'Aufträge',
  'scout.scorecard.kpi.netRevenue': 'Nettoumsatz',
  'scout.scorecard.kpi.gebinde60l': 'Gebinde 60L',
  'scout.scorecard.kpi.gebinde25l': 'Gebinde 25L',
  'scout.scorecard.kpi.gebinde10l': 'Gebinde 10L',
  'scout.scorecard.emptyTitle': 'Keine Daten',
  'scout.scorecard.emptyDescription': 'Keine KPI-Daten für den gewählten Zeitraum.',
  'scout.scorecard.missionPerformanceTitle': 'Mission Performance',
  'scout.scorecard.missionMissionsCompleted': 'Abgeschlossene Missionen',
  'scout.scorecard.missionConversionRate': 'Conversion-Rate',
  'scout.scorecard.missionTerritoryCoverage': 'Gebietsabdeckung',
  'scout.scorecard.viewMissionDetails': 'Details anzeigen',
  'scout.scorecard.adjustTargets': 'Zielwerte anpassen',
  'scout.scorecard.annualTarget': 'Jahresziel',
  'scout.scorecard.annualTargetVisits': 'Jahresziel Besuche',
  'scout.scorecard.annualTargetDemos': 'Jahresziel Demos',
  'scout.scorecard.annualTargetNetRevenue': 'Nettoumsatz (€)',
  'scout.scorecard.annualTargetNetRevenueA11y': 'Jahresziel Nettoumsatz in Euro',
  'scout.scorecard.monthlyOverrides': 'Monatliche Abweichungen',
  'scout.scorecard.table.month': 'Monat',
  'scout.scorecard.table.reason': 'Grund',
  'scout.scorecard.derivedTargets': 'Abgeleitete Ziele',
  'scout.scorecard.dailyTargetLabel': 'Tagesziel: {{count}} Besuche',
  'scout.scorecard.weeklyTargetLabel': 'Wochenziel: {{count}} Besuche',
  'scout.scorecard.save': 'Speichern',
  'scout.scorecard.heatmap.visits': 'Besuche',
  'scout.scorecard.heatmap.demos': 'Demos',
  'scout.scorecard.heatmap.revenue': 'Umsatz',
  'scout.scorecard.heatmap.low': 'Wenig',
  'scout.scorecard.heatmap.high': 'Viel',
  'scout.scorecard.heatmap.scaleA11y': 'Farbskala von wenig bis viel',
  'scout.scorecard.heatmap.loading': 'Karte wird geladen…',
  // Scout mission control
  'scout.missionControl.teamOverview': 'Dein Team und deren PLZ-Gebiete',
  'scout.missionControl.jokerLimitPerDay': 'Joker-Limit / Tag',
  'scout.missionControl.jokerLimitUpdated': 'Joker-Limit wurde aktualisiert.',
  'scout.missionControl.jokerLimitSaveFailed': 'Joker-Limit konnte nicht gespeichert werden.',
  'scout.missionControl.selectTeam': 'Team auswählen',
  'scout.missionControl.allTeams': 'Alle Teams',
  'scout.missionControl.missionParameters': 'Missionsparameter',
  'scout.missionControl.minLeads': 'Min Leads pro Mission',
  'scout.missionControl.maxLeads': 'Max Leads pro Mission',
  'scout.missionControl.maxKilometer': 'Max Kilometer',
  'scout.missionControl.missionsPerDay': 'Missionen pro Tag',
  'scout.missionControl.dailyKpiGoals': 'Tages-KPI Ziele',
  'scout.missionControl.visits': 'Besuche',
  'scout.missionControl.demos': 'Demos',
  'scout.missionControl.revenueEur': 'Umsatz EUR',
  'scout.missionControl.none': 'Keine',
  'scout.missionControl.addPlzAreaFor': 'PLZ-Bereich hinzufügen für',
  'scout.missionControl.addPlzArea': 'PLZ-Bereich hinzufügen',
  'scout.missionControl.noTeamMembersFound': 'Keine Teammitglieder gefunden.',
  'scout.missionControl.orders': 'Aufträge',
  'scout.missionControl.resetSettings': 'Einstellungen zurücksetzen',
  'scout.missionControl.saveSettings': 'Einstellungen speichern',
  'scout.missionControl.territorySaturation': 'Territory-Sättigung (PLZ)',
  'scout.missionControl.day': 'Tag',
  'scout.missionControl.selectDay': 'Tag auswählen',
  'scout.missionControl.week': 'Woche',
  'scout.missionControl.selectWeek': 'Woche auswählen',
  'scout.missionControl.month': 'Monat',
  'scout.missionControl.selectMonth': 'Monat auswählen',
  'scout.missionControl.planFulfillment': 'Planungserfüllung',
  'scout.missionControl.plzPrefixPlaceholder': 'PLZ-Präfix (z.B. 70)',
  'scout.missionControl.plzPrefix': 'PLZ-Präfix',
  'scout.missionControl.addPlzToWhitelist': 'PLZ-Präfix zur Whitelist hinzufügen',
  'scout.missionControl.addPlzToGreylist': 'PLZ-Präfix zur Grey-Liste hinzufügen',
  'scout.missionControl.addPlzToYellowlist': 'PLZ-Präfix zur Yellow-Liste hinzufügen',
  'scout.missionControl.addNewTeamMember': 'Neues Teammitglied hinzufügen',
  'scout.missionControl.lastModified': 'Zuletzt geändert',
  'scout.missionControl.diagnostics.team': 'Team',
  'scout.missionControl.diagnostics.target': 'Ziel',
  'scout.missionControl.diagnostics.visitsToConversion': 'Besuche bis Conversion',
  'scout.missionControl.diagnostics.systemVsManual': 'System vs. Manuell',
  'scout.missionControl.diagnostics.conversionSystemRoute': 'Conversion bei Systemroute',
  'scout.missionControl.diagnostics.repeatVisits': 'Wiederholungsbesuche',
  'scout.missionControl.diagnostics.company': 'Firma',
  'scout.missionControl.diagnostics.visitsCount': 'Besuche',
  'scout.missionControl.diagnostics.lastVisit': 'Letzter Besuch',
  'scout.missionControl.diagnostics.status': 'Status',
  'scout.missionControl.territory.enterName': 'Name eingeben',
  'scout.missionControl.territory.memberName': 'Name des Teammitglieds',
  'scout.missionControl.territory.corePlz': 'Kerngebiet PLZ',
  'scout.missionControl.territory.plzExample': 'z.B. 10115',
  'scout.missionControl.territory.assignedPlz': 'Zugewiesene PLZ',
  'scout.missionControl.territory.plzRangeExample': 'z.B. 10115-10178',
  'scout.missionControl.territory.teamMember': 'Teammitglied',
  'scout.missionControl.territory.plzArea': 'PLZ-Gebiet',
  'scout.missionControl.territory.assignedAt': 'Zugewiesen am',
  'scout.missionControl.territory.approval': 'Genehmigung',
  'scout.missionControl.territory.actions': 'Aktionen',
  'scout.missionControl.territory.editCorePlz': 'Kerngebiet PLZ bearbeiten',
  'scout.missionControl.outsideAreaRules': 'Regeln außerhalb Gebiet',
  'scout.missionControl.outsidePlzPolicy': 'Policy für PLZ außerhalb der Listen',
  'scout.missionControl.enableOutsideWarning': 'Warnung für PLZ außerhalb des Gebiets aktivieren',
  'scout.missionControl.requireOutsideApproval': 'Genehmigung für PLZ außerhalb des Gebiets erforderlich',
  'scout.missionControl.rejectOutsidePlz': 'PLZ außerhalb des Gebiets ablehnen',
  'scout.missionControl.checkPlz': 'PLZ oder PLZ-Präfix prüfen',
  'scout.missionControl.check': 'Prüfen',
  'scout.missionControl.error': 'Fehler',
  'scout.missionControl.success': 'Erfolg',
  'scout.missionControl.userProfileNotFound': 'Benutzerprofil nicht gefunden',
  'scout.missionControl.plzAreasUpdated': 'PLZ-Bereiche aktualisiert',
  'scout.missionControl.plzAreasSaveFailed': 'PLZ-Bereiche konnten nicht gespeichert werden',

  // Mission Control → Config → KPI Target Configuration (MC-004)

  // Scout Mission Control — Rep Config (T13)
  'scout.missionControl.repConfig.title': 'Vertreter-Konfiguration',
  'scout.missionControl.repConfig.repName': 'Name / E-Mail',
  'scout.missionControl.repConfig.industries': 'Branchen',
  'scout.missionControl.repConfig.products': 'Produkte',
  'scout.missionControl.repConfig.plz': 'PLZ',
  'scout.missionControl.repConfig.loadError': 'Vertreter-Konfiguration konnte nicht geladen werden',
  'scout.missionControl.repConfig.saveError': 'Speichern fehlgeschlagen',
  'scout.missionControl.repConfig.savedTitle': 'Gespeichert',
  'scout.missionControl.repConfig.savedDesc': 'Vertreter-Konfiguration wurde aktualisiert',

  // Scout Mission Control — Joker Limit (T16)
  'scout.missionControl.jokerConfig.title': 'Joker-Limit pro Tag',
  'scout.missionControl.jokerConfig.description': 'Maximale Anzahl Joker-Einsätze pro Vertreter und Tag.',
  'scout.missionControl.jokerConfig.maxPerDay': 'Max. pro Tag',
  'scout.missionControl.jokerConfig.loadError': 'Joker-Konfiguration konnte nicht geladen werden',
  'scout.missionControl.jokerConfig.saveError': 'Speichern fehlgeschlagen',
  'scout.missionControl.jokerConfig.savedTitle': 'Gespeichert',
  'scout.missionControl.jokerConfig.savedDesc': 'Joker-Limit wurde aktualisiert',

  // Scout Mission Control — live dashboard
  'scout.missionControl.live.reconnecting': 'Verbinde...',
  'scout.missionControl.live.teamToday': 'Team heute',
  'scout.missionControl.live.employee': 'Mitarbeiter',
  'scout.missionControl.live.visits': 'Besuche',
  'scout.missionControl.live.demos': 'Demos',
  'scout.missionControl.live.sales': 'Abschlüsse',
  'scout.missionControl.live.sale': 'Abschluss',
  'scout.missionControl.live.revenue': 'Umsatz',
  'scout.missionControl.live.lastActivity': 'Letzte Aktivität',
  'scout.missionControl.live.justNow': 'Gerade eben',
  'scout.missionControl.live.secondsAgo': 'vor {{seconds}} Sek',
  'scout.missionControl.live.minutesAgo': 'vor {{minutes}} Min.',
  'scout.missionControl.live.hoursAgo': 'vor {{hours}} Std.',
  'scout.missionControl.live.notOnScout': 'Nicht im Einsatz',
  'scout.missionControl.live.noTeamMembers': 'Keine Teammitglieder',
  'scout.missionControl.live.noTeamMembersDesc': 'Es wurden keine Außendienstmitarbeiter gefunden.',
  'scout.missionControl.live.noReportsThisWeek': 'Keine Besuche in der gewählten Woche',
  'scout.missionControl.live.noReportsThisWeekHint': 'Für die angezeigten Mitarbeiter wurden in dieser Woche keine Besuche erfasst. Zuordnung erfolgt über die E-Mail-Adresse.',
  'scout.missionControl.live.unmatchedVisits': '{{count}} Besuche dieser Woche keinem angezeigten Mitarbeiter zugeordnet (E-Mail nicht im Team).',
  'scout.missionControl.live.notAvailableHint': 'Wird im aktuellen Besuchsbericht nicht erfasst.',
  'scout.missionControl.reps.loadError': 'Außendienst-Roster konnte nicht geladen werden',
  'scout.missionControl.live.weekLabel': 'KW {{week}}',
  'scout.missionControl.live.rep': 'Mitarbeiter',
  'scout.missionControl.live.totalVisits': 'Σ Besuche',
  'scout.missionControl.live.totalSales': 'Σ Abschlüsse',
  'scout.missionControl.live.recentActivities': 'Letzte Aktivitäten',
  'scout.missionControl.live.activity.sale': 'Sale bei',
  'scout.missionControl.live.activity.demo': 'Demo bei',
  'scout.missionControl.live.activity.noAccess': 'Kein Zugang bei',
  'scout.missionControl.live.activity.noDecisionMaker': 'Kein Entscheider bei',
  'scout.missionControl.live.activity.conversation': 'Gespräch bei',
  'scout.missionControl.live.activity.rejected': 'Abgelehnt bei',
  'scout.missionControl.live.activity.visit': 'Besuch bei',
  // Mission Control funnel + reasons + visit-report popup (hotfix 2026-10-27)
  'scout.missionControl.live.unknownCompany': 'Unbekannt',
  'scout.missionControl.live.entered': 'Zutritt',
  'scout.missionControl.live.apReached': 'Ansprechpartner erreicht',
  'scout.missionControl.live.apReachedShort': 'AP erreicht',
  'scout.missionControl.live.demoRate': 'Demo-Quote',
  'scout.missionControl.live.demoRateHint': 'Demos ÷ Ansprechpartner erreicht. „–“, wenn kein Ansprechpartner erreicht wurde.',
  'scout.missionControl.live.revenueNotAvailableHint': 'Kein Umsatzbetrag in CORE erfasst – der Auftragswert wird nicht übertragen.',
  'scout.missionControl.live.totalDemos': 'Σ Demos',
  'scout.missionControl.live.unreportedVisits': '{{count}} Besuche heute ohne Besuchsbericht – Zutritt, Ansprechpartner und Demo dort nicht erfasst.',
  'scout.missionControl.live.ambiguousReports': 'Datenfehler: {{count}} Besuche lassen sich keinem Besuchsbericht eindeutig zuordnen und werden im Funnel nicht gezählt.',
  'scout.missionControl.live.reasons.title': 'Gründe heute',
  'scout.missionControl.live.reasons.none': 'Keine Gründe erfasst',
  'scout.missionControl.live.reasons.noEntry': 'Kein Zutritt',
  'scout.missionControl.live.reasons.noAp': 'Ansprechpartner nicht erreicht',
  'scout.missionControl.live.reasons.noSale': 'Kein Abschluss',
  'scout.missionControl.live.reasons.precheckable': 'vorab prüfbar',
  'scout.missionControl.live.reasons.precheckableHint': 'Hätte vor dem Besuch geprüft werden können (Lead-Daten).',
  'scout.missionControl.live.reason.noEntry.firma_geschlossen_dauerhaft': 'Firma dauerhaft geschlossen',
  'scout.missionControl.live.reason.noEntry.falsche_oeffnungszeiten': 'Falsche Öffnungszeiten',
  'scout.missionControl.live.reason.noEntry.kein_zutritt': 'Kein Zutritt',
  'scout.missionControl.live.reason.noEntry.falsche_firma_adresse': 'Falsche Firma / Adresse',
  'scout.missionControl.live.reason.noEntry.nicht_icp': 'Kein Zielkunde',
  'scout.missionControl.live.reason.noEntry.sonstiges': 'Sonstiges',
  'scout.missionControl.live.reason.noAp.ap_nicht_da': 'AP nicht da',
  'scout.missionControl.live.reason.noAp.abgewimmelt': 'Abgewimmelt',
  'scout.missionControl.live.reason.noAp.kein_termin': 'Kein Termin',
  'scout.missionControl.live.reason.noAp.folgetermin': 'Folgetermin',
  'scout.missionControl.live.reason.noAp.sonstiges': 'Sonstiges',
  'scout.missionControl.live.reason.noSale.kein_bedarf': 'Aktuell kein Bedarf',
  'scout.missionControl.live.reason.noSale.bestandslieferant': 'Hat schon Lieferant',
  'scout.missionControl.live.reason.noSale.preis_budget': 'Preis / Budget',
  'scout.missionControl.live.reason.noSale.bedenkzeit': 'Will überlegen',
  'scout.missionControl.live.reason.noSale.kein_interesse': 'Kein Interesse',
  'scout.missionControl.live.reason.noSale.sonstiges': 'Anderer Grund',
  'scout.missionControl.live.report.open': 'Besuchsbericht öffnen',
  'scout.missionControl.live.report.title': 'Besuchsbericht',
  'scout.missionControl.live.report.notRecorded': 'nicht erfasst',
  'scout.missionControl.live.report.missing': 'Zu diesem Besuch liegt kein Besuchsbericht vor.',
  'scout.missionControl.live.report.ambiguous': 'Datenfehler: {{count}} Besuchsberichte passen zu diesem Besuch – keiner wird angezeigt.',
  'scout.missionControl.live.report.yes': 'Ja',
  'scout.missionControl.live.report.no': 'Nein',
  'scout.missionControl.live.report.litersPerYear': '{{product}}: {{liters}} l/Jahr',
  'scout.missionControl.live.report.field.stopType': 'Besuchsart',
  'scout.missionControl.live.report.field.erstbesuch': 'Erstbesuch',
  'scout.missionControl.live.report.field.kundeStatus': 'Kundenstatus',
  'scout.missionControl.live.report.field.leadValid': 'Lead gültig',
  'scout.missionControl.live.report.field.leadInvalidReason': 'Grund Lead ungültig',
  'scout.missionControl.live.report.field.entered': 'Zutritt',
  'scout.missionControl.live.report.field.noEntryReason': 'Grund kein Zutritt',
  'scout.missionControl.live.report.field.gatekeeper': 'Empfang / Gatekeeper',
  'scout.missionControl.live.report.field.apReached': 'Ansprechpartner erreicht',
  'scout.missionControl.live.report.field.noApReason': 'Grund AP nicht erreicht',
  'scout.missionControl.live.report.field.demoDone': 'Demo durchgeführt',
  'scout.missionControl.live.report.field.sold': 'Abschluss',
  'scout.missionControl.live.report.field.noSaleReason': 'Grund kein Abschluss',
  'scout.missionControl.live.report.field.zeichnungsberechtigt': 'Zeichnungsberechtigt',
  'scout.missionControl.live.report.field.zeichnungsberechtigtInfo': 'Info Zeichnungsberechtigung',
  'scout.missionControl.live.report.field.objectsConfirmed': 'Objekte bestätigt',
  'scout.missionControl.live.report.field.relevanteProdukte': 'Relevante Produkte',
  'scout.missionControl.live.report.field.jahresbedarf': 'Jahresbedarf',
  'scout.missionControl.live.report.field.wettbewerb': 'Wettbewerb',
  'scout.missionControl.live.report.field.nextAction': 'Nächster Schritt',
  'scout.missionControl.live.report.field.nextWhen': 'Wann',
  'scout.missionControl.live.report.field.notizen': 'Notizen',
  'scout.missionControl.live.report.enum.stop_type.planned': 'Geplant',
  'scout.missionControl.live.report.enum.stop_type.joker': 'Joker',
  'scout.missionControl.live.report.enum.kunde_status.neukunde': 'Neukunde',
  'scout.missionControl.live.report.enum.kunde_status.bestand': 'Bestandskunde',
  'scout.missionControl.live.report.enum.gatekeeper_passed.durch': 'Durchgekommen',
  'scout.missionControl.live.report.enum.gatekeeper_passed.blockiert': 'Blockiert',
  'scout.missionControl.live.report.enum.gatekeeper_passed.keiner': 'Kein Gatekeeper',
  'scout.missionControl.live.report.enum.lead_invalid_reason.privathaus_kein_fit': 'Privathaus – kein Kunde für uns',
  'scout.missionControl.live.report.enum.lead_invalid_reason.dauerhaft_geschlossen': 'Firma dauerhaft geschlossen',
  'scout.missionControl.live.report.enum.lead_invalid_reason.falsche_firma_adresse': 'Falsche Firma / Adresse',
  'scout.missionControl.live.report.enum.lead_invalid_reason.nicht_icp': 'Kein Zielkunde (Branche / Profil passt nicht)',
  'scout.missionControl.live.report.enum.zeichnungsberechtigt_wer.ansprechpartner_selbst': 'Ansprechpartner selbst',
  'scout.missionControl.live.report.enum.zeichnungsberechtigt_wer.geschaeftsfuehrung': 'Geschäftsführung',
  'scout.missionControl.live.report.enum.zeichnungsberechtigt_wer.einkauf': 'Einkauf',
  'scout.missionControl.live.report.enum.zeichnungsberechtigt_wer.gremium': 'Gremium',
  'scout.missionControl.live.report.enum.zeichnungsberechtigt_wer.unbekannt': 'Unbekannt',
  'scout.missionControl.live.report.enum.next_action.folgetermin': 'Folgetermin',
  'scout.missionControl.live.report.enum.next_action.angebot': 'Angebot',
  'scout.missionControl.live.report.enum.next_action.muster': 'Muster',
  'scout.missionControl.live.report.enum.next_action.rueckruf': 'Rückruf',
  'scout.missionControl.live.report.enum.next_action.wiedervorlage': 'Wiedervorlage',
  'scout.missionControl.live.report.enum.next_action.nichts': 'Nichts',
  'scout.missionControl.live.report.enum.next_when_kind.datum': 'Datum',
  'scout.missionControl.live.report.enum.next_when_kind.kw': 'Kalenderwoche',
  'scout.missionControl.live.report.enum.next_when_kind.monat': 'Monat',
  'scout.missionControl.live.report.enum.next_when_kind.zeitraum': 'Zeitraum',
  'scout.missionControl.live.report.enum.next_when_kind.offen': 'Offen',
  'scout.missionControl.live.result.demo': 'Demo',
  'scout.missionControl.live.result.conversation': 'Gespräch',
  'scout.missionControl.live.result.unreported': 'Kein Bericht',
  'scout.missionControl.live.result.ambiguous': 'Datenfehler',
  'scout.missionControl.live.feed.team': 'Team',
  'scout.missionControl.live.feed.filterLabel': 'Aktivitäten filtern nach Mitarbeiter',
  'scout.missionControl.live.feed.count': '{{count}} Besuche heute',
  'scout.missionControl.live.feed.empty': 'Heute noch keine Besuche erfasst.',
  'scout.missionControl.live.feed.openDay': 'Tagesverlauf & Route',
  'scout.missionControl.live.day.open': 'Tagesverlauf von {{name}} öffnen',
  'scout.missionControl.live.day.title': '{{name}} · Tagesverlauf',
  'scout.missionControl.live.day.description': 'Heute, {{date}}',
  'scout.missionControl.live.day.dataNote': 'Besuchsdauer und gefahrene Strecke werden nicht erfasst. „Abstand“ = Zeit seit dem vorherigen Besuch, „Luftlinie“ = gerade Linie zwischen den Firmenadressen.',
  'scout.missionControl.live.day.map': 'Geplante Route & Besuche',
  'scout.missionControl.live.day.mapShow': 'Karte anzeigen',
  'scout.missionControl.live.day.mapHide': 'Karte ausblenden',
  'scout.missionControl.live.day.mapLegend': 'Linie = geplante Route aus der Tourplanung · Nummern = tatsächliche Besuche in zeitlicher Reihenfolge.',
  'scout.missionControl.live.day.mapNoGeometry': 'Keine Besuche mit Koordinaten und keine geplante Route – Karte nicht verfügbar.',
  'scout.missionControl.live.day.mapMissingStops': '{{count}} von {{total}} Besuchen ohne Koordinaten – nicht auf der Karte.',
  'scout.missionControl.live.day.routeLoading': 'Geplante Route wird geladen…',
  'scout.missionControl.live.day.routeNone': 'Für heute ist keine Tour geplant.',
  'scout.missionControl.live.day.routeNotComputed': '{{count}} geplante Tour(en) ohne berechnete Route.',
  'scout.missionControl.live.day.routeError': 'Geplante Route konnte nicht geladen werden: {{error}}',
  'scout.missionControl.live.day.coordsError': 'Firmenkoordinaten konnten nicht geladen werden – keine Luftlinie: {{error}}',
  'scout.missionControl.live.day.noVisits': 'Heute noch keine Besuche erfasst.',
  'scout.missionControl.live.day.summary.planned': 'Geplant: {{km}} · {{time}} h ({{count}} Tour(en))',
  'scout.missionControl.live.day.summary.plannedNone': 'Geplant: nicht erfasst',
  'scout.missionControl.live.day.summary.straightLine': 'Luftlinie gesamt: {{km}} ({{legs}} von {{total}} Abschnitten)',
  'scout.missionControl.live.day.timeMissing': 'Zeit nicht erfasst',
  'scout.missionControl.live.day.gap': 'Abstand {{time}}',
  'scout.missionControl.live.day.gapHint': 'Zeit seit dem vorherigen Besuch – keine Besuchs- oder Fahrdauer (wird nicht erfasst).',
  'scout.missionControl.live.day.distance.first': 'Erster Besuch',
  'scout.missionControl.live.day.distance.km': 'Luftlinie {{km}}',
  'scout.missionControl.live.day.distance.kmHint': 'Gerade Linie zwischen den Firmenadressen – keine gefahrene Strecke.',
  'scout.missionControl.live.day.distance.loading': 'Luftlinie wird geladen…',
  'scout.missionControl.live.day.distance.error': 'Luftlinie nicht verfügbar',
  'scout.missionControl.live.day.distance.unavailable': 'Keine Luftlinie: {{reason}}',
  'scout.missionControl.live.day.distance.unavailablePrevious': 'Keine Luftlinie: vorheriger Besuch – {{reason}}',
  'scout.missionControl.live.day.distance.reason.repDiscovered': 'vor Ort entdeckte Firma, keine Koordinaten im System',
  'scout.missionControl.live.day.distance.reason.unknownRef': 'Firma nicht zuordenbar',
  'scout.missionControl.live.day.distance.reason.companyNotFound': 'Firma nicht gefunden',
  'scout.missionControl.live.day.distance.reason.noCoordinates': 'Firma ohne Koordinaten',

  // Scout session (NAV-005)

  // Scout Mission Control — territories (MC-001, MC-002)

  // Scout Mission Control — diagnostics (MC-006)
  'scout.missionControl.diagnostics.demoRate': 'Demo-Rate',
  'scout.missionControl.diagnostics.visitDepth': 'Besuchstiefe',

  // Scout Mission Control — Team-Steuerung
  'scout.missionControl.tabs.teamSteering': 'Team-Steuerung',
  'scout.missionControl.teamSteering.noAccessTitle': 'Kein Zugriff',
  'scout.missionControl.teamSteering.noAccessDesc': 'Du hast keine Berechtigung, die Team-Steuerung zu sehen.',
  'scout.missionControl.teamSteering.globalTitle': 'Vorgaben',
  'scout.missionControl.teamSteering.globalNotes': 'Hinweise',
  'scout.missionControl.teamSteering.hide': 'Ausblenden',
  'scout.missionControl.teamSteering.show': 'Einblenden',
  'scout.missionControl.teamSteering.productFocus': 'Produktfokus',
  'scout.missionControl.teamSteering.industries': 'Branchen',
  'scout.missionControl.teamSteering.jokerDefault': 'Joker-Standardlimit',
  'scout.missionControl.teamSteering.territorySummaryTitle': 'Gebietsübersicht',
  'scout.missionControl.teamSteering.territorySummary': '{{green}} grüne und {{grey}} graue PLZ-Zonen zugewiesen.',
  'scout.missionControl.teamSteering.perRepTitle': 'Pro Mitarbeiter',
  'scout.missionControl.teamSteering.perRepTable': 'Mitarbeiter-Steuerungstabelle',
  'scout.missionControl.teamSteering.loading': 'Daten werden geladen…',
  'scout.missionControl.teamSteering.noRepsTitle': 'Keine Mitarbeiter',
  'scout.missionControl.teamSteering.noRepsDesc': 'Es wurden keine Mitarbeiter im Team gefunden.',
  'scout.missionControl.teamSteering.plzGreen': 'PLZ (grün)',
  'scout.missionControl.teamSteering.plzGrey': 'PLZ (grau)',
  'scout.missionControl.teamSteering.productWish': 'Produkte (Wunsch)',
  'scout.missionControl.teamSteering.jokersPerDay': 'Joker / Tag',
  'scout.missionControl.teamSteering.visitTarget': 'Besuche-Ziel',
  'scout.missionControl.teamSteering.plzUpdated': 'PLZ-Zone wurde aktualisiert.',
  'scout.missionControl.teamSteering.plzUpdateError': 'PLZ-Zone konnte nicht aktualisiert werden.',
  'scout.missionControl.teamSteering.plzDeleted': 'PLZ-Zone wurde entfernt.',
  'scout.missionControl.teamSteering.plzDeleteError': 'PLZ-Zone konnte nicht entfernt werden.',
  'scout.missionControl.teamSteering.jokerUpdateError': 'Joker-Limit konnte nicht gespeichert werden.',
  'scout.missionControl.teamSteering.visitTargetUpdateError': 'Besuche-Ziel konnte nicht gespeichert werden.',
  'scout.missionControl.teamSteering.removePlz': 'PLZ entfernen',
  'scout.missionControl.teamSteering.saveGlobal': 'Vorgaben speichern',
  'scout.missionControl.teamSteering.globalSaved': 'Vorgaben gespeichert.',
  'scout.missionControl.teamSteering.globalSaveError': 'Vorgaben konnten nicht gespeichert werden.',
  'scout.missionControl.teamSteering.demoTarget': 'Demo-Ziel',
  'scout.missionControl.teamSteering.revenueTarget': 'Umsatz-Ziel (EUR)',
  'scout.missionControl.teamSteering.demoTargetUpdateError': 'Demo-Ziel konnte nicht gespeichert werden.',
  'scout.missionControl.teamSteering.revenueTargetUpdateError': 'Umsatz-Ziel konnte nicht gespeichert werden.',
  'scout.missionControl.teamSteering.plzOutsideTerritory': 'PLZ außerhalb vertraglichem Gebiet',
  'scout.missionControl.teamSteering.plzOutsideTerritoryDesc': 'PLZ wurde automatisch als Grauzone eingestuft und muss vom Manager genehmigt werden.',
  'scout.missionControl.teamSteering.vorgabenTitle': 'Titel',
  'scout.missionControl.teamSteering.vorgabenTitlePlaceholder': 'z.B. Frühjahrskampagne 2026',
  'scout.missionControl.teamSteering.missionConfigTitle': 'Mission-Konfiguration pro Mitarbeiter',
  'scout.missionControl.teamSteering.missionConfigTable': 'Mission-Konfigurations-Tabelle',
  'scout.missionControl.teamSteering.missionConfigSaved': 'Mission-Konfiguration gespeichert.',
  'scout.missionControl.teamSteering.missionConfigSaveError': 'Mission-Konfiguration konnte nicht gespeichert werden.',
  'scout.missionControl.teamSteering.missionConfigOverrideActive': 'individuelle Werte aktiv',
  'scout.missionControl.teamSteering.missionConfigUsingGlobal': 'Standardwerte (global)',
  'scout.missionControl.teamSteering.minEmployees': 'Min. Mitarbeiter',
  'scout.missionControl.teamSteering.maxRouteKm': 'Max. Route (km)',
  'scout.missionControl.teamSteering.stopsPerDay': 'Stopps / Tag',
  'scout.missionControl.teamSteering.anchorLookbackDays': 'Anchor-Lookback (Tage)',

  // Scout Unternehmenssuche
  'scout.unternehmenssuche.selectAllResults': 'Alle Suchergebnisse auswählen',
  'scout.unternehmenssuche.openingHours': 'ÖFFNUNGSZEITEN',
  'scout.unternehmenssuche.temporarilyClosed': 'Temporär geschlossen',
  'scout.unternehmenssuche.startSearch': 'Suche starten',
  'scout.search.selectStatus': 'Status wählen...',
  'scout.unternehmenssuche.searchRunning': 'Suche läuft...',
  'scout.unternehmenssuche.adjustSearchCriteria': 'Bitte ändern Sie die Suchkriterien oder versuchen Sie es erneut.',
  'scout.unternehmenssuche.selectCompanyType': 'Unternehmenstyp auswählen',
  'scout.unternehmenssuche.openingHoursTime': 'Öffnungszeiten-Uhrzeit',
  'scout.unternehmenssuche.noTimeNeeded': 'Keine Zeitangabe nötig',
  'scout.unternehmenssuche.addConditions': 'Fügen Sie Bedingungen hinzu, um Ihre Suche zu verfeinern',
  'scout.unternehmenssuche.addCondition': 'Bedingung hinzufügen',
  'scout.unternehmenssuche.addGroup': 'Gruppe hinzufügen',
  'scout.unternehmenssuche.savedSearchName': 'Name der gespeicherten Suche',
  'scout.unternehmenssuche.saveCurrentSearch': 'Aktuelle Suche speichern',
  'scout.unternehmenssuche.savedSearches': 'Gespeicherte Suchen',
  'scout.unternehmenssuche.noSavedSearches': 'Keine gespeicherten Suchen vorhanden.',
  'scout.unternehmenssuche.keywordPlaceholder': 'z.B. Restaurant, Bar, Bäckerei',
  'scout.unternehmenssuche.addWaypoint': 'Zwischenstopp hinzufügen',
  'scout.unternehmenssuche.locationPlaceholder': 'z.B. München Marienplatz',
  'scout.unternehmenssuche.toggleAdditionalFilters': 'Zusätzliche Filter ein- oder ausblenden',
  'scout.unternehmenssuche.additionalFilters': 'Zusätzliche Filter',
  'scout.unternehmenssuche.saveSearchAsFile': 'Suche als Datei speichern',
  'scout.unternehmenssuche.loadSearchFromFile': 'Suche aus Datei laden',
  'scout.unternehmenssuche.checkSearchTerms': 'Bitte überprüfen Sie Ihre Suchbegriffe oder versuchen Sie es erneut.',
  'scout.unternehmenssuche.noResults': 'Keine Ergebnisse gefunden.',
  'scout.unternehmenssuche.statusOperational': 'Betrieb aktiv',
  'scout.unternehmenssuche.statusClosedPermanently': 'Dauerhaft geschlossen',
  'scout.unternehmenssuche.noRating': 'Keine Bewertung',
  'scout.unternehmenssuche.openNow': 'Jetzt geöffnet',
  'scout.unternehmenssuche.closed': 'Geschlossen',
  'scout.unternehmenssuche.noInfo': 'Keine Angabe',

  // Search overlay
  'search.overlay.hint': 'Tippen und Enter drücken oder auf Suchen klicken.',
  'search.overlay.placeholder': 'Suchen (/) nach Ressourcen, Docs und mehr',
  'search.overlay.searchLabel': 'Suchen',
  'search.overlay.noResults': 'Keine Ergebnisse für „{{query}}"',
  'search.overlay.tryDifferent': 'Andere Suchbegriffe verwenden oder Rechtschreibung prüfen.',
  'search.overlay.topResults': 'Top-Ergebnisse',
  'search.overlay.documentation': 'Dokumentation · ',

  // Location/Route toggle (Unternehmenssuche)
  'scout.unternehmenssuche.locationRadius': 'Ort + Umkreis',
  'scout.unternehmenssuche.routeCorridor': 'Route + Korridor',
  'scout.unternehmenssuche.withoutLocation': 'Ohne Ortsangabe',

  // Scout missions (Wave 3 i18n)
  'scout.scorecard.heatmapTitle': 'Aktivitäts-Heatmap (PLZ-2)',
  'scout.preferences.defaultRegionLabel': 'Standardregion',
  'scout.preferences.selectRegionPlaceholder': 'Region auswählen',
  'scout.preferences.defaultStatusLabel': 'Standardstatus',
  'scout.preferences.selectDefaultStatus': 'Standardstatus auswählen',
  'scout.preferences.statusDraft': 'Entwurf',
  'scout.preferences.statusActive': 'Aktiv',
  'scout.preferences.statusCompleted': 'Abgeschlossen',
  'scout.preferences.statusArchived': 'Archiviert',
  'scout.preferences.saving': 'Wird gespeichert...',
  'scout.preferences.plzPrefixes': 'PLZ-Präfixe für Missionen',
  'scout.preferences.plzPrefixesPlaceholder': 'Geben Sie PLZ-Präfixe durch Komma getrennt ein (z.B. 70, 71, 72)',
  'scout.preferences.maxRouteLength': 'Max. Routenlänge (km)',
  'scout.preferences.maxRouteLengthDescription': 'Maximale Routenlänge in Kilometern',
  'scout.preferences.autoGenerateMissions': 'Missionen automatisch generieren (nächtliche Automatisierung)',
  'scout.preferences.autoGenerateDescription': 'Wenn aktiviert, werden Missionen automatisch basierend auf Ihren Einstellungen generiert.',
  'scout.preferences.defaultAssigneeLabel': 'Standardverantwortliche Person',
  'scout.preferences.defaultAssigneePlaceholder': 'Standardverantwortliche Person eingeben',
  'scout.preferences.defaultAssigneeAria': 'Standardverantwortliche Person',
  'scout.preferences.defaultLeadCountLabel': 'Standardanzahl Leads',
  'scout.preferences.defaultLeadCountAria': 'Standardanzahl Leads',
  'scout.preferences.defaultDurationLabel': 'Standarddauer (Tage)',
  'scout.preferences.defaultDurationAria': 'Standarddauer in Tagen',
  'scout.preferences.autoAssignLabel': 'Missionen automatisch der Standardverantwortlichen Person zuweisen',
  'scout.preferences.productFamiliesLabel': 'Produktfamilien',
  'scout.preferences.industryCodesLabel': 'Branchen',
  'scout.preferences.keywordsLabel': 'Keywords',
  'scout.preferences.keywordsPlaceholder': 'z.B. beton, estrich',
  'scout.preferences.minLeadsLabel': 'Min. Leads pro Mission',
  'scout.preferences.minLeadsAria': 'Minimale Leads pro Mission',
  'scout.preferences.maxLeadsLabel': 'Max. Leads pro Mission',
  'scout.preferences.maxLeadsAria': 'Maximale Leads pro Mission',
  'scout.preferences.dailyQuotaLabel': 'Anzahl Missionen pro Tag',
  'scout.preferences.dailyQuotaAria': 'Maximale Missionen pro Tag',
  'scout.preferences.dailyQuotaHelper': 'Maximale Anzahl automatisch generierter Missionen pro Tag (1-3)',
  'scout.dailyPlanning.inField': 'Im Aussendienst',
  'scout.dailyPlanning.completed': 'Abgeschlossen',
  'scout.dailyPlanning.openDay': 'Tag aufmachen',
  'scout.dailyPlanning.dayMarkedCompleted': 'Dieser Tag ist als abgeschlossen markiert.',
  'scout.dailyPlanning.statusVisited': 'Besucht',
  'scout.dailyPlanning.statusPlanned': 'Geplant',
  'scout.dailyPlanning.reportDone': 'Bericht erledigt',
  'scout.dailyPlanning.statusCompleted': 'Abgeschlossen',
  'scout.dailyPlanning.exportRoute': 'Nächste Stops exportieren',
  'scout.dailyPlanning.routeFromHome': 'Von Zuhause → Erster Stop',
  'scout.dailyPlanning.routeToHome': 'Letzter Stop → Nach Hause',
  'scout.dailyPlanning.jokerAdd': 'Joker-Stopp',
  'scout.dailyPlanning.jokerTitle': 'Joker-Stopp hinzufügen',
  'scout.dailyPlanning.jokerUsed': 'verwendet',
  'scout.dailyPlanning.jokerLimitReached': 'Tageslimit für Joker-Stopps erreicht.',
  'scout.dailyPlanning.jokerCompany': 'Unternehmen',
  'scout.dailyPlanning.jokerCompanyPlaceholder': 'Unternehmensname eingeben',
  'scout.dailyPlanning.jokerOrt': 'Ort',
  'scout.dailyPlanning.jokerOrtPlaceholder': 'Ort eingeben',
  'scout.dailyPlanning.jokerWhy': 'Warum',
  'scout.dailyPlanning.jokerWhyPlaceholder': 'Warum wird dieser Stopp hinzugefügt?',
  'scout.dailyPlanning.jokerCancel': 'Abbrechen',
  'scout.dailyPlanning.jokerSubmit': 'Stopp hinzufügen',
  'scout.dailyPlanning.jokerCreateError': 'Stopp konnte nicht hinzugefügt werden. Bitte erneut versuchen.',
  'scout.dailyPlanning.jokerQuotaExceeded': 'Tageslimit erreicht – du hast heute bereits alle {{max}} Joker-Stopps genutzt. Morgen geht es wieder.',
  'scout.dailyPlanning.jokerCreatedTitle': 'Stopp angelegt',
  'scout.dailyPlanning.jokerCreatedAs': 'Stopp angelegt als #{{position}}',
  'scout.dailyPlanning.jokerCreatedQueued': 'Offline gespeichert – wird synchronisiert, sobald du wieder online bist.',
  'scout.dailyPlanning.jokerCreatedHint': 'Wie möchtest du fortfahren?',
  'scout.dailyPlanning.jokerCreatedVisit': 'Besuch starten',
  'scout.dailyPlanning.jokerCreatedScan': 'Bestellung scannen',
  'scout.dailyPlanning.jokerCreatedDismiss': 'Später',
  'scout.dailyPlanning.jokerCountError': 'Joker-Kontingent konnte nicht geladen werden.',
  'scout.dailyPlanning.writeQueued': '✓ Gespeichert – wird synchronisiert.',
  'scout.dailyPlanning.bucketUpNext': 'Als Nächstes',
  'scout.dailyPlanning.bucketVisited': 'Besucht',
  'scout.dailyPlanning.bucketPostponed': 'Verschoben',
  'scout.dailyPlanning.bucketRejected': 'Abgelehnt',
  'scout.dailyPlanning.cannotStartDay': 'Tag kann nicht gestartet werden',
  'scout.dailyPlanning.cannotStartDayNotToday': 'Du kannst nur den heutigen Tag starten.',
  'scout.dailyPlanning.cannotStartDayPriorOpen': 'Der vorherige Tag ist noch offen. Bitte schließe ihn zuerst ab.',
  'scout.dailyPlanning.cannotStartDayNoMission': 'Keine Mission für heute ausgewählt.',
  'scout.dailyPlanning.activeMissionExists': 'Du hast bereits eine aktive Mission',
  'scout.dailyPlanning.activeMissionExistsResume': 'Wir bringen dich zu deiner laufenden Mission.',
  'scout.dailyPlanning.startHomeReturnFailed': 'Heimfahrt konnte nicht gestartet werden',
  // PRE-EXISTING GAP on staging, cured here because this branch makes it rep-visible:
  // useTagesplanungDayLifecycle asks for `scout.dailyPlanning.dayCannotClose` (the copy
  // itself only ever existed under the `scout.tagesplanung.` namespace), so a hard
  // day-finish failure rendered the RAW KEY to the rep — a dark write-failure surface,
  // which is exactly what this arc exists to kill. Same copy as the tagesplanung entry.
  'scout.dailyPlanning.dayCannotClose': 'Tag kann nicht geschlossen werden',
  'scout.dailyPlanning.dayWriteQueuedOffline': 'Noch nicht gesendet — offline',
  'scout.dailyPlanning.dayWriteQueuedOfflineHint': 'Die Aktion liegt in der Warteschlange und wird automatisch gesendet, sobald du wieder online bist.',
  'scout.dailyPlanning.dayWriteQueuedUnconfirmed': 'Noch NICHT bestätigt',
  'scout.dailyPlanning.dayWriteQueuedUnconfirmedHint': 'Der Server hat den Tag-Schritt nicht bestätigt. Er liegt in der Warteschlange und wird erneut gesendet — bitte später prüfen.',
  'scout.dailyPlanning.scanOrder': 'Bestellung scannen',
  'scout.dailyPlanning.backlogBlocked': 'Du hast {{count}} offene Besuchsberichte.',
  'scout.dailyPlanning.backlogBlockedHint': 'Bitte schreibe deine Besuchsberichte, bevor du weiter machst.',

  // ReadOnlyPlanModal
  'scout.createMission.title': 'Neue Mission erstellen',
  'scout.createMission.description': 'Name, Filter und Zuweisungen wählen',
  'scout.createMission.nameLabel': 'Name',
  'scout.createMission.nameRequired': 'Name ist erforderlich',
  'scout.createMission.namePlaceholder': 'z. B. Stuttgart Nord — Kälteanlagen',
  'scout.createMission.nameAria': 'Missionsname',
  'scout.createMission.regionLabel': 'Region (optional)',
  'scout.createMission.regionPlaceholder': 'z. B. PLZ 70xxx',
  'scout.createMission.regionAria': 'Region oder PLZ',
  'scout.createMission.ownerLabel': 'Owner',
  'scout.createMission.ownerPlaceholder': 'E-Mail-Adresse',
  'scout.createMission.ownerAria': 'Owner E-Mail-Adresse',
  'scout.createMission.themeLabel': 'Thema (optional)',
  'scout.createMission.themePlaceholder': 'z. B. Kälteanlagen',
  'scout.createMission.themeAria': 'Missionsthema',
  'scout.createMission.productLabel': 'Produkt (optional)',
  'scout.createMission.productPlaceholder': 'z. B. K-2000',
  'scout.createMission.productAria': 'Produkt',
  'scout.createMission.cancel': 'Abbrechen',
  'scout.createMission.save': 'Speichern',
  'scout.createMission.saveBusy': 'Speichern…',
  'scout.createMission.cancelAria': 'Missionserstellung abbrechen',
  'scout.createMission.saveAria': 'Mission speichern',
  'scout.createMission.saveBusyAria': 'Mission wird gespeichert',

  // Inventory

  // Sales

  // Purchase


  // Settings
  'settings.description': 'Verwalten Sie Ihre Anwendungseinstellungen und Anpassungsoptionen',
  'settings.typography.title': 'Typografie',
  'settings.typography.description': 'Passen Sie Textgröße und Dichte für bessere Lesbarkeit oder mehr Informationsdichte an',
  'settings.typography.scale.title': 'Textgröße',
  'settings.typography.scale.description': 'Standard entspricht der Masterslight-Basis; Komfort vergrößert die Schrift für lange Sitzungen',
  'settings.typography.scale.ariaLabel': 'Textgrößen-Preset',
  'settings.typography.scale.compact': 'Kompakt',
  'settings.typography.scale.standard': 'Standard',
  'settings.typography.scale.comfort': 'Komfort',
  'settings.tabs.appearance': 'Erscheinungsbild',
  'settings.tabs.account': 'Konto',
  'settings.tabs.notifications': 'Benachrichtigungen',
  'settings.tabs.security': 'Sicherheit',
  'settings.language.title': 'Spracheinstellungen',
  'settings.language.description': 'Wählen Sie Ihre bevorzugte Sprache für die Anwendungsoberfläche',
  'settings.language.interfaceLanguage': 'Oberflächensprache',
  'settings.language.interfaceLanguageDesc': 'Wählen Sie die Sprache für Menüs, Schaltflächen und Oberflächenelemente',
  'settings.theme.title': 'Farbschema',
  'settings.theme.description': 'Passen Sie das Erscheinungsbild und die Farben Ihrer Oberfläche an',
  'settings.theme.predefinedThemes': 'Möchten Sie aus 10 vordefinierten Themen wählen?',
  'settings.theme.goToThemeSettings': 'Zu Theme-Einstellungen',
  'settings.theme.tabs.themes': 'Design-Themen',
  'settings.theme.tabs.preview': 'Vorschau',
  'settings.theme.colorScheme.title': 'Farbschema',
  'settings.theme.colorScheme.description': 'Wählen Sie zwischen hellem, dunklem oder systemweitem Farbschema',
  'settings.theme.colorScheme.options.light': 'Hell',
  'settings.theme.colorScheme.options.dark': 'Dunkel',
  'settings.theme.colorScheme.options.system': 'System',
  'settings.theme.selector.title': 'Theme auswählen',
  'settings.theme.selector.description': 'Wählen Sie aus 10 vordefinierten Themes. Änderungen werden sofort übernommen.',
  'settings.theme.current.title': 'Aktuelles Theme',
  'settings.theme.current.description': 'Informationen zu Ihrem aktuell ausgewählten Theme',
  'settings.theme.preview.title': 'Theme-Vorschau',
  'settings.theme.preview.description': 'Sehen Sie, wie Ihr ausgewähltes Theme mit Beispiel-UI-Elementen aussieht',
  'settings.theme.palette.title': 'Farbpalette',
  'settings.theme.palette.secondary': 'Sekundär',
  'settings.theme.palette.background': 'Hintergrund',
  'settings.theme.palette.accentSoft': 'Akzent (weich)',
  'settings.themeSettings.title': 'Theme-Einstellungen',
  'settings.themeSettings.description': 'Passen Sie das Erscheinungsbild Ihrer Anwendung mit vordefinierten Themes an',
  'settings.themeSettings.themeDetails': 'Theme-Details',
  'settings.themeSettings.themeId': 'Theme-ID:',
  'settings.themeSettings.colorScheme': 'Farbschema:',
  'settings.account.profile.title': 'Profilinformationen',
  'settings.account.profile.description': 'Aktualisieren Sie Ihre persönlichen Informationen und Kontodaten',
  'settings.account.profile.name': 'Name',
  'settings.account.profile.email': 'E-Mail',
  'settings.account.profile.role': 'Rolle',
  'settings.account.profile.department': 'Abteilung',
  'settings.account.profile.editProfile': 'Profil bearbeiten',
  'settings.account.data.title': 'Datenverwaltung',
  'settings.account.data.description': 'Verwalten Sie Ihre Datensynchronisierung und Backup-Einstellungen',
  'settings.account.data.cloudSync': 'Cloud-Synchronisierung',
  'settings.account.data.cloudSyncEnabled': 'Ihre Einstellungen werden in die Cloud synchronisiert',
  'settings.account.data.cloudSyncDisabled': 'Cloud-Synchronisierung ist deaktiviert (Feature-Flag)',
  'settings.account.data.syncNow': 'Jetzt synchronisieren',
  'settings.notifications.title': 'Benachrichtigungseinstellungen',
  'settings.notifications.description': 'Konfigurieren Sie, wie Sie Benachrichtigungen erhalten',
  'settings.notifications.email.title': 'E-Mail-Benachrichtigungen',
  'settings.notifications.email.description': 'Benachrichtigungen per E-Mail erhalten',
  'settings.notifications.push.title': 'Push-Benachrichtigungen',
  'settings.notifications.push.description': 'Push-Benachrichtigungen im Browser erhalten',
  'settings.notifications.system.title': 'Systemwarnungen',
  'settings.notifications.system.description': 'Wichtige Systembenachrichtigungen',
  'settings.notifications.configure': 'Konfigurieren',
  'settings.security.title': 'Sicherheitseinstellungen',
  'settings.security.description': 'Verwalten Sie Ihre Kontosicherheit und Datenschutzeinstellungen',
  'settings.security.password.title': 'Passwort',
  'settings.security.password.lastChanged': 'Zuletzt geändert vor 30 Tagen',
  'settings.security.password.change': 'Ändern',
  'settings.security.twoFactor.title': 'Zwei-Faktor-Authentifizierung',
  'settings.security.twoFactor.description': 'Fügen Sie eine zusätzliche Sicherheitsebene hinzu',
  'settings.security.twoFactor.enable': 'Aktivieren',
  'settings.security.sessions.title': 'Sitzungsverwaltung',
  'settings.security.sessions.description': 'Aktive Sitzungen verwalten',
  'settings.security.sessions.view': 'Sitzungen anzeigen',
  'settings.company.title': 'Unternehmenseinstellungen',
  'settings.company.description': 'Verwalten Sie Ihre Unternehmensinformationen und Einstellungen',
  'settings.company.edit': 'Unternehmen bearbeiten',
  'settings.company.saveChanges': 'Änderungen speichern',
  'settings.company.cancel': 'Abbrechen',
  'settings.company.tabs.general': 'Allgemein',
  'settings.company.tabs.contact': 'Kontakt',
  'settings.company.tabs.billing': 'Abrechnung',
  'settings.company.tabs.branding': 'Markenidentität',
  'settings.company.general.companyInfo': 'Unternehmensinformationen',
  'settings.company.general.companyName': 'Firmenname',
  'settings.company.general.legalName': 'Rechtlicher Name',
  'settings.company.general.taxId': 'Steuernummer',
  'settings.company.general.registrationNumber': 'Registrierungsnummer',
  'settings.company.general.industry': 'Branche',
  'settings.company.general.foundedYear': 'Gründungsjahr',
  'settings.company.general.employees': 'Anzahl der Mitarbeiter',
  'settings.company.general.industry.technology': 'Technologie',
  'settings.company.general.industry.manufacturing': 'Produktion',
  'settings.company.general.industry.retail': 'Einzelhandel',
  'settings.company.general.industry.healthcare': 'Gesundheitswesen',
  'settings.company.general.industry.finance': 'Finanzen',
  'settings.company.general.industry.other': 'Sonstiges',
  'settings.company.address.title': 'Adressinformationen',
  'settings.company.address.street': 'Straßenadresse',
  'settings.company.address.city': 'Stadt',
  'settings.company.address.state': 'Bundesland',
  'settings.company.address.zipCode': 'PLZ',
  'settings.company.address.country': 'Land',
  'settings.company.address.country.us': 'Vereinigte Staaten',
  'settings.company.address.country.ca': 'Kanada',
  'settings.company.address.country.uk': 'Vereinigtes Königreich',
  'settings.company.address.country.de': 'Deutschland',
  'settings.company.address.country.fr': 'Frankreich',
  'settings.company.address.country.other': 'Sonstiges',
  'settings.company.contact.title': 'Kontaktinformationen',
  'settings.company.contact.phone': 'Telefonnummer',
  'settings.company.contact.email': 'E-Mail-Adresse',
  'settings.company.contact.website': 'Website',
  'settings.company.contact.supportEmail': 'Support-E-Mail',
  'settings.company.billing.title': 'Abrechnungseinstellungen',
  'settings.company.billing.currency': 'Währung',
  'settings.company.billing.taxRate': 'Steuersatz (%)',
  'settings.company.billing.paymentTerms': 'Zahlungsbedingungen',
  'settings.company.billing.billingCycle': 'Abrechnungszyklus',
  'settings.company.billing.paymentTerms.net15': 'Netto 15',
  'settings.company.billing.paymentTerms.net30': 'Netto 30',
  'settings.company.billing.paymentTerms.net45': 'Netto 45',
  'settings.company.billing.paymentTerms.net60': 'Netto 60',
  'settings.company.billing.paymentTerms.dueOnReceipt': 'Bei Erhalt fällig',
  'settings.company.billing.cycle.monthly': 'Monatlich',
  'settings.company.billing.cycle.quarterly': 'Vierteljährlich',
  'settings.company.billing.cycle.annually': 'Jährlich',
  'settings.company.billing.cycle.custom': 'Benutzerdefiniert',
  'settings.company.billing.summary.title': 'Abrechnungsübersicht',
  'settings.company.billing.summary.currentPlan': 'Aktueller Plan',
  'settings.company.billing.summary.monthlyCost': 'Monatliche Kosten',
  'settings.company.billing.summary.nextBillingDate': 'Nächstes Abrechnungsdatum',
  'settings.company.billing.summary.paymentMethod': 'Zahlungsmethode',
  'settings.company.billing.summary.status': 'Status',
  'settings.company.billing.summary.active': 'Aktiv',
  'settings.company.branding.title': 'Markenidentität & Erscheinungsbild',
  'settings.company.branding.logo': 'Firmenlogo',
  'settings.company.branding.uploadLogo': 'Logo hochladen',
  'settings.company.branding.logoHint': 'PNG, JPG bis zu 2MB',
  'settings.company.branding.favicon': 'Favicon',
  'settings.company.branding.uploadFavicon': 'Favicon hochladen',
  'settings.company.branding.faviconHint': 'ICO, PNG bis zu 1MB',
  'settings.company.branding.primaryColor': 'Primärfarbe',
  'settings.company.branding.secondaryColor': 'Sekundärfarbe',
  'settings.usersRoles.stats.totalUsers': 'Gesamt Benutzer',
  'settings.usersRoles.stats.activeUsers': 'aktive Benutzer',
  'settings.usersRoles.stats.totalRoles': 'Gesamt Rollen',
  'settings.usersRoles.stats.roleConfigurations': 'Rollenkonfigurationen',
  'settings.usersRoles.stats.permissionRules': 'Berechtigungsregeln',
  'settings.usersRoles.stats.acrossAllRoles': 'Regeln \u00fcber alle Rollen',
  'settings.userManagement.title': 'Benutzerverwaltung',
  'settings.userManagement.description': 'Verwalten Sie Benutzer, Rollen und Systemeinstellungen',
  'settings.userManagement.addUser': 'Benutzer hinzufügen',
  'settings.userManagement.editUser': 'Benutzer bearbeiten',
  'settings.userManagement.createNewUser': 'Neuen Benutzer erstellen',
  'settings.userManagement.updateUserInfo': 'Benutzerinformationen aktualisieren',
  'settings.userManagement.addNewUser': 'Einen neuen Benutzer zum System hinzufügen',
  'settings.userManagement.tabs.users': 'Benutzer',
  'settings.userManagement.tabs.appAccess': 'App-Zugriff',
  'settings.userManagement.tabs.roles': 'Rollen',
  'settings.userManagement.toast.userCreated': 'Benutzer erfolgreich erstellt',
  'settings.userManagement.toast.userUpdated': 'Benutzer erfolgreich aktualisiert',
  'settings.userManagement.toast.userDeleted': 'Benutzer erfolgreich gelöscht',
  'settings.userManagement.toast.roleCreated': 'Rolle erfolgreich erstellt',
  'settings.userManagement.toast.roleUpdated': 'Rolle erfolgreich aktualisiert',
  'settings.userManagement.toast.roleDeleted': 'Rolle erfolgreich gelöscht',
  'settings.userManagement.toast.error': 'Benutzer konnte nicht erstellt werden',
  'settings.userManagement.toast.errorUpdate': 'Benutzer konnte nicht aktualisiert werden',
  'settings.userManagement.toast.errorDelete': 'Benutzer konnte nicht gelöscht werden',
  'settings.userManagement.toast.errorRoleCreate': 'Rolle konnte nicht erstellt werden',
  'settings.userManagement.toast.errorRoleUpdate': 'Rolle konnte nicht aktualisiert werden',
  'settings.userManagement.toast.errorRoleDelete': 'Rolle konnte nicht gelöscht werden',
  'settings.userManagement.selectUserForAccess': 'Wählen Sie einen Benutzer im Benutzer-Tab aus, um den App- und Feature-Zugriff zu verwalten.',
  'settings.userManagement.roles.title': 'Rollen',
  'settings.userManagement.roles.subtitle': 'Rollen und deren Berechtigungsmatrix verwalten',
  'settings.userManagement.roles.addRole': 'Rolle hinzufügen',
  'settings.userManagement.roles.createTitle': 'Neue Rolle erstellen',
  'settings.userManagement.roles.createDescription': 'Geben Sie einen Namen für die neue Rolle ein. Berechtigungen können nach der Erstellung konfiguriert werden.',
  'settings.userManagement.roles.roleName': 'Rollenname',
  'settings.userManagement.roles.cancel': 'Abbrechen',
  'settings.userManagement.roles.create': 'Erstellen',
  'settings.userManagement.roles.permissionsTitle': 'Berechtigungen: {{name}}',
  'settings.userManagement.roles.permissionsDescription': 'Apps × Aktionen Berechtigungsmatrix. Apps aufklappen für Features.',
  'settings.userManagement.roles.savePermissions': 'Berechtigungen speichern',
  'settings.userManagement.roles.saving': 'Wird gespeichert...',
  'settings.userManagement.roles.usersAssigned': '{{count}} Benutzer zugewiesen',
  'settings.userManagement.roles.userAssigned': '{{count}} Benutzer zugewiesen',
  'settings.userManagement.roles.deleteConfirmTitle': 'Rolle löschen',
  'settings.userManagement.roles.deleteConfirmDescription': 'Möchten Sie die Rolle „{{name}}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
  'settings.userManagement.roles.deleteConfirm': 'Löschen',
  'settings.userManagement.roles.permissionCount': '{{count}} Berechtigungen',
  'settings.userManagement.roles.accessLevelsTab': 'Zugriffsebenen',
  'settings.userManagement.roles.granularTab': 'Detailberechtigungen',
  'settings.userManagement.roles.accessLevel': 'Zugriffsebene',
  'settings.userManagement.access.selectUser': 'Wählen Sie einen Benutzer aus, um Berechtigungen zu verwalten',
  'settings.userManagement.access.permissionsTitle': 'Berechtigungen: {{name}}',
  'settings.userManagement.access.matrixDescription': 'App \u00d7 Feature \u00d7 Aktion Berechtigungsmatrix',
  'settings.userManagement.access.appFeature': 'App / Feature',
  'settings.userManagement.access.reset': 'Zur\u00fccksetzen',
  'settings.userManagement.access.save': 'Speichern',
  'settings.userManagement.access.flightPermit': 'Flugerlaubnis (KI-Agent)',
  'settings.userManagement.access.validUntil': 'G\u00fcltig bis',
  'settings.userManagement.access.maxInvocations': 'Max. Aufrufe',
  'settings.userManagement.access.unlimited': 'Unbegrenzt',
  'settings.userManagement.access.reason': 'Begr\u00fcndung',
  'settings.userManagement.access.reasonPlaceholder': 'Genehmigungsgrund...',
  'settings.userManagement.access.pickUser': 'Benutzer ausw\u00e4hlen...',
  'settings.userManagement.access.searchUsers': 'Benutzer suchen...',
  'settings.userManagement.access.noUsersFound': 'Keine Benutzer gefunden.',
  'settings.userManagement.access.action.read': 'Lesen',
  'settings.userManagement.access.action.write': 'Schreiben',
  'settings.userManagement.access.action.delete': 'L\u00f6schen',
  'settings.userManagement.access.action.execute': 'Ausf\u00fchren',
  'settings.userManagement.access.action.admin': 'Admin',
  'settings.integrations.settings.security.enabled': 'Aktiviert',
  'settings.integrations.settings.security.disabled': 'Deaktiviert',

  // Analytics - Pivot Table

  // Reports

  // Warehouse - Picking

  // Warehouse - Returns

  // Warehouse - ASN

  // CRM - Contacts
  'crm.contacts.title': 'CRM-Kontakte',
  'crm.contacts.description': 'Kunden- und Lieferantenkontakte mit Adressinformationen verwalten',
  'crm.contacts.add': 'Kontakt hinzufügen',
  'crm.contacts.edit': 'Kontakt bearbeiten',
  'crm.contacts.delete': 'Kontakt löschen',
  'crm.contacts.view360': '360° Ansicht',
  'crm.contacts.unassigned': 'Nicht zugewiesen',
  'crm.contacts.type.customer': 'Kunde',
  'crm.contacts.type.supplier': 'Lieferant',
  'crm.contacts.type.partner': 'Partner',
  'crm.contacts.type.prospect': 'Interessent',
  'crm.contacts.status.active': 'Aktiv',
  'crm.contacts.status.inactive': 'Inaktiv',
  'crm.contacts.status.suspended': 'Gesperrt',
  'crm.contacts.validation.companyRequired': 'Firmenname ist erforderlich',
  'crm.contacts.validation.streetRequired': 'Straßenadresse ist erforderlich',
  'crm.contacts.validation.postalRequired': 'Postleitzahl ist erforderlich',
  'crm.contacts.validation.cityRequired': 'Stadt ist erforderlich',
  'crm.contacts.validation.countryRequired': 'Land ist erforderlich',
  'crm.contacts.validation.nameRequired': 'Kontaktname ist erforderlich',
  'crm.contacts.validation.emailInvalid': 'Ungültige E-Mail-Adresse',
  'crm.contacts.validation.phoneRequired': 'Telefonnummer ist erforderlich',
  'crm.contacts.validation.salesPersonRequired': 'Verkaufsmitarbeiter ist erforderlich',
  'crm.contacts.validation.ordererNameRequired': 'Bestellername ist erforderlich',
  'crm.contacts.validation.roleRequired': 'Rolle ist erforderlich',
  'crm.contacts.validation.hoursRequired': 'Stunden sind erforderlich',
  'crm.openMenu': 'Menü öffnen',
  'crm.contacts.search': 'Kontakte suchen...',
  'crm.contacts.searchLabel': 'Kontakte suchen',
  'crm.contacts.name': 'Name',
  'crm.contacts.company': 'Unternehmen',
  'crm.contacts.contact': 'Kontakt',
  'crm.contacts.type': 'Typ',
  'crm.contacts.status': 'Status',
  'crm.contacts.salesPerson': 'Vertriebsmitarbeiter',
  'crm.contacts.lastContact': 'Letzter Kontakt',
  'crm.contacts.actions': 'Aktionen',
  'crm.contacts.viewDetails': 'Details anzeigen',
  'crm.contacts.manageAddresses': 'Adressen verwalten',
  'crm.contacts.addNote': 'Notiz hinzufügen',
  'crm.contacts.assignSalesPerson': 'Vertriebsmitarbeiter zuweisen',
  'crm.contacts.tabs.contacts': 'Kontakte',
  'crm.contacts.tabs.analytics': 'Analytik',
  'crm.contacts.tabs.documents': 'Dokumente',
  'crm.contacts.tabs.email': 'E-Mail',
  'crm.contacts.tabs.search': 'Erweiterte Suche',
  'crm.contacts.emptyState.selectHeading': 'Kontakt auswählen',
  'crm.contacts.emptyState.documentsMessage': 'Wählen Sie einen Kontakt aus dem Kontakte-Tab, um Dokumente zu verwalten',
  'crm.contacts.emptyState.emailMessage': 'Wählen Sie einen Kontakt aus dem Kontakte-Tab, um E-Mail-Kommunikation anzuzeigen',
  'crm.contacts.quickSearch': 'Kontakte schnell suchen...',
  'crm.contacts.close': 'Schließen',
  'crm.contacts.stats.total': 'Kontakte gesamt',
  'crm.contacts.stats.active': 'Aktive Kontakte',
  'crm.contacts.stats.customers': 'Kunden',
  'crm.contacts.stats.suppliers': 'Lieferanten',
  'crm.contacts.stats.changeFromLastMonth': '+{pct}% zum Vormonat',
  'crm.contacts.stats.percentActive': '% aktiv',
  'crm.contacts.stats.percentOfTotal': '% der Gesamtzahl',

  // CRM - Leads
  'crm.leads.title': 'Leads',
  'crm.leads.description': 'Verkaufsleads verwalten und Konversion verfolgen',
  'crm.leads.add': 'Lead hinzufügen',
  'crm.leads.edit': 'Lead bearbeiten',
  'crm.leads.delete': 'Lead löschen',
  'crm.leads.status.new': 'Neu',
  'crm.leads.status.contacted': 'Kontaktiert',
  'crm.leads.status.qualified': 'Qualifiziert',
  'crm.leads.status.proposal': 'Angebot',
  'crm.leads.status.negotiation': 'Verhandlung',
  'crm.leads.status.closedWon': 'Gewonnen',
  'crm.leads.status.closedLost': 'Verloren',
  'crm.leads.source.website': 'Website',
  'crm.leads.source.referral': 'Empfehlung',
  'crm.leads.source.email': 'E-Mail',
  'crm.leads.source.phone': 'Telefon',
  'crm.leads.source.social': 'Soziale Medien',
  'crm.leads.source.other': 'Sonstiges',
  'crm.leads.value': 'Wert',
  'crm.leads.lastContact': 'Letzter Kontakt',
  'crm.leads.notes': 'Notizen',
  'crm.leads.search': 'Leads suchen...',
  'crm.leads.filterByStatus': 'Nach Status filtern',
  'crm.leads.filterBySource': 'Nach Quelle filtern',
  'crm.leads.totalLeads': 'Gesamt Leads',
  'crm.leads.pipelineValue': 'Pipeline-Wert',
  'crm.leads.qualifiedLeads': 'Qualifizierte Leads',
  'crm.leads.percentConversion': '% Konversion',

  // CRM - Shared flat keys (used by Leads page)
  'crm.leads': 'Leads',
  'crm.name': 'Name',
  'crm.company': 'Unternehmen',
  'crm.contact': 'Kontakt',
  'crm.email': 'E-Mail',
  'crm.phone': 'Telefon',
  'crm.source': 'Quelle',
  'crm.value': 'Wert',
  'crm.lastContact': 'Letzter Kontakt',
  'crm.notes': 'Notizen',
  'crm.fullName': 'Vollständiger Name',
  'crm.estimatedValue': 'Geschätzter Wert',
  'crm.searchPlaceholder': 'Suchen...',
  'crm.closedWon': 'Abgeschlossen (gewonnen)',
  'crm.viewDetails': 'Details anzeigen',
  'crm.editLead': 'Lead bearbeiten',
  'crm.addNote': 'Notiz hinzufügen',
  'crm.convertToCustomer': 'In Kunden umwandeln',
  'crm.deleteLead': 'Lead löschen',
  'crm.addNewLead': 'Neuen Lead hinzufügen',
  'crm.createNewLead': 'Einen neuen Verkaufs-Lead erstellen',
  'crm.leadDetails': 'Lead-Details',
  'crm.viewLeadDetails': 'Lead-Informationen anzeigen und bearbeiten',
  'crm.status.new': 'Neu',
  'crm.status.contacted': 'Kontaktiert',
  'crm.status.qualified': 'Qualifiziert',
  'crm.status.proposal': 'Angebot',
  'crm.status.negotiation': 'Verhandlung',
  'crm.status.closedWon': 'Abgeschlossen (gewonnen)',
  'crm.status.closedLost': 'Abgeschlossen (verloren)',
  'crm.source.website': 'Website',
  'crm.source.referral': 'Empfehlung',
  'crm.source.tradeShow': 'Messe',
  'crm.source.coldCall': 'Kaltakquise',
  'crm.source.socialMedia': 'Soziale Medien',
  'crm.source.emailCampaign': 'E-Mail-Kampagne',

  // CRM - Lead Map
  'crm.leadMap.title': 'Hierarchische Lead-Karte',
  'crm.leadMap.description': 'Unternehmensbeziehungen, Hierarchien, USt-IdNr.-Gruppierungen und Vertriebsmitarbeiter-Zuweisungen visualisieren',
  'crm.leadMap.loading': 'Lead-Karten-Daten werden geladen...',
  'crm.leadMap.loadError': 'Fehler beim Laden der Lead-Karten-Daten:',

  // CRM - Address Management
  'crm.address.management': 'Adressverwaltung',
  'crm.address.manageAll': 'Alle Adressinformationen verwalten',
  'crm.address.company': 'Firmenadresse',
  'crm.address.delivery': 'Lieferadresse',
  'crm.address.invoice': 'Rechnungsadresse',
  'crm.address.sameAsCompany': 'Wie Firmenadresse',
  'crm.address.deliverySameAsCompany': 'Lieferadresse ist identisch mit der Firmenadresse.',
  'crm.address.invoiceSameAsCompany': 'Rechnungsadresse ist identisch mit der Firmenadresse.',
  'crm.address.useDifferent': 'Andere Adresse verwenden',

  // Visit Report
  'visitReport.title': 'Besuchsbericht',
  'visitReport.createTitle': 'Besuchsbericht erstellen',
  'visitReport.titleFor': 'Besuchsbericht für {{name}}',
  'visitReport.visitType': 'Besuchstyp',
  'visitReport.coldVisit': 'Kaltbesuch',
  'visitReport.appointment': 'Termin',
  'visitReport.salesOutcome': 'Verkaufserfolg',
  'visitReport.noContact': 'Kein Kontakt',
  'visitReport.conversation': 'Gespräch',
  'visitReport.demo': 'Demo',
  'visitReport.order': 'Auftrag',
  'visitReport.orderValue': 'Auftragswert (EUR)',
  'visitReport.nextStep': 'Nächster Schritt',
  'visitReport.callback': 'Rückruf',
  'visitReport.sendOffer': 'Angebot senden',
  'visitReport.revisit': 'Wiederbesuch',
  'visitReport.completed': 'Abgeschlossen',
  'visitReport.appointmentWindow': 'Terminfenster (optional)',
  'visitReport.from': 'Von',
  'visitReport.to': 'Bis',
  'visitReport.contactName': 'Gesprächspartner Name',
  'visitReport.enterName': 'Name eingeben',
  'visitReport.roleFunction': 'Funktion / Rolle',
  'visitReport.enterRole': 'Funktion eingeben',
  'visitReport.isDecisionMaker': 'Ist Entscheider?',
  'visitReport.decisionMakerName': 'Entscheider Name',
  'visitReport.decisionMakerRole': 'Entscheider Funktion',
  'visitReport.email': 'Email (optional)',
  'visitReport.phone': 'Telefon (optional)',
  'visitReport.notes': 'Notizen (optional)',
  'visitReport.additionalInfo': 'Zusätzliche Informationen...',
  'visitReport.productsDiscussed': 'Produkte besprochen?',
  'visitReport.annualDemand': 'Jahresbedarf',
  'visitReport.select': 'Auswählen',
  'visitReport.interest': 'Interesse',
  'visitReport.interestHigh': 'hoch',
  'visitReport.interestMedium': 'mittel',
  'visitReport.interestLow': 'gering',
  'visitReport.modelFeedback': 'War die System-Empfehlung passend?',
  'visitReport.feedbackYes': 'Ja',
  'visitReport.feedbackPartially': 'Teilweise',
  'visitReport.feedbackNo': 'Nein',
  'visitReport.feedbackNotSeen': 'Nicht gesehen',
  'visitReport.branchCorrect': 'Branche korrekt? (optional)',
  'visitReport.selectBranch': 'Branche auswählen',
  'visitReport.branchConstruction': 'Bau',
  'visitReport.branchIndustry': 'Industrie',
  'visitReport.branchTrade': 'Handel',
  'visitReport.branchService': 'Dienstleistung',
  'visitReport.noInterestReason': 'Grund kein Interesse',
  'visitReport.wrongProduct': 'Falsches Produkt',
  'visitReport.wrongTiming': 'Richtiger Zeitpunkt fehlt',
  'visitReport.existingSupplier': 'Bestehender Lieferant',
  'visitReport.noBudget': 'Kein Budget',
  'visitReport.noNeed': 'Kein Bedarf',
  'visitReport.decisionMakerNotReached': 'Entscheider nicht erreicht',
  'visitReport.additionalRemarks': 'Weitere Bemerkungen (optional)',
  'visitReport.error': 'Fehler',
  'visitReport.validationError': 'Bitte wähle Besuchstyp und Verkaufserfolg aus.',
  'visitReport.deferralNotPossible': 'Aufschub nicht möglich',
  'visitReport.maxDeferralReached': 'Du hast den letzten Bericht bereits aufgeschoben. Bitte fülle diesen aus.',
  'visitReport.reportDeferred': 'Bericht aufgeschoben',
  'visitReport.deferralMessage': 'Du kannst den Bericht später ausfüllen.',
  'visitReport.reportCreated': 'Besuchsbericht erstellt',
  'visitReport.reportSaved': 'Besuchsbericht wurde gespeichert.',
  'visitReport.reportSavedFor': 'Besuchsbericht für {{name}} wurde gespeichert.',
  'visitReport.reportError': 'Besuchsbericht konnte nicht erstellt werden.',
  'visitReport.stepOf': 'Schritt {{current}} von {{total}}',
  'visitReport.back': 'Zurück',
  'visitReport.cancel': 'Abbrechen',
  'visitReport.inAHurry': 'Ich bin in Eile',
  'visitReport.next': 'Weiter',
  'visitReport.saving': 'Speichern...',
  'visitReport.finishVisit': 'Besuch abschließen',
  'visitReport.contactNotes': 'Zusätzliche Informationen zum Gesprächspartner...',
  'visitReport.callingQueue.prompt': 'Soll ein AI-Termin-Call für diesen Lead vorbereitet werden?',
  'visitReport.callingQueue.yes': 'Ja, in Queue aufnehmen',
  'visitReport.callingQueue.no': 'Nein',
  'visitReport.callingQueue.toast': 'Lead in Calling Queue aufgenommen.',

  // --- SS-145: admin ---
  // --- SS-145: ui-components ---

  // --- SS-145: learning ---

  // --- SS-145: modals ---
  'modals.assignMissionModal.close': 'Schließen',
  'modals.assignMissionModal.searchPlaceholder': 'Suche (Titel/Branche)',
  'modals.assignMissionModal.searchAriaLabel': 'Suche',
  'modals.missionQuickViewModal.description': 'Schnelle Übersicht der Mission. Für Details öffnen Sie die Missionsseite.',
  'modals.missionQuickViewModal.close': 'Schließen',
  'modals.missionQuickViewModal.openDetails': 'Details öffnen',
  'modals.missionQuickViewModal.openDetailsAria': 'Missionsdetail öffnen',
  'modals.leadDetailModal.close': 'Schließen',
  'modals.leadDetailModal.whoIsThis': 'Wer ist das?',
  'modals.leadDetailModal.whatDoTheyNeed': 'Was brauchen die?',
  'modals.leadDetailModal.whatDoISay': 'Was sage ich?',
  'modals.leadDetailModal.moreProducts': 'Weitere Produkte',
  'modals.leadDetailModal.topProduct': 'Hauptprodukt',
  'modals.leadDetailModal.demoObject': 'Demo-Objekt',
  'modals.leadDetailModal.problem': 'Problem',
  'modals.leadDetailModal.dilution': 'Verdünnung',
  'modals.leadDetailModal.noProductData': 'Keine Produktdaten vorhanden',
  'modals.leadDetailModal.contactPersons': 'Ansprechpartner',
  'modals.leadDetailModal.addContact': 'Hinzufügen',
  'modals.leadDetailModal.contactNamePlaceholder': 'Name des Ansprechpartners',
  'modals.leadDetailModal.save': 'Speichern',
  'modals.leadDetailModal.visitHistory': 'Besuchshistorie (90 Tage)',
  // FR-FE-POST-CALL-ENVELOPE-TO-STEFFEN-P0 (doc-store 85571ff7-…): post-call briefing tile.
  'modals.leadDetailModal.postCall.title': 'Aus dem Telefonat',
  'modals.leadDetailModal.postCall.empty': 'Kein qualifizierter Anruf vorhanden.',
  'modals.leadDetailModal.postCall.slPending': 'Post-Call-Envelope wird vorbereitet (SL-Endpunkt ausstehend).',
  'modals.leadDetailModal.postCall.contact': 'Kontakt',
  'modals.leadDetailModal.postCall.contactName': 'Ansprechpartner',
  'modals.leadDetailModal.postCall.decisionMaker': 'Entscheider',
  'modals.leadDetailModal.postCall.yes': 'Ja',
  'modals.leadDetailModal.postCall.no': 'Nein',
  'modals.leadDetailModal.postCall.directPhone': 'Direkte Nummer',
  'modals.leadDetailModal.postCall.email': 'E-Mail',
  'modals.leadDetailModal.postCall.availability': 'Verfügbarkeit',
  'modals.leadDetailModal.postCall.window': 'Zeitfenster',
  'modals.leadDetailModal.postCall.timePreference': 'Bevorzugte Zeit',
  'modals.leadDetailModal.postCall.qualification': 'Qualifizierung',
  'modals.leadDetailModal.postCall.interestLevel': 'Interesse',
  'modals.leadDetailModal.postCall.infrastructure': 'Infrastruktur',
  'modals.leadDetailModal.postCall.detection': 'Erkennung',
  'modals.leadDetailModal.postCall.systemType': 'Systemtyp',
  'modals.leadDetailModal.postCall.cluster': 'Cluster',
  'modals.leadDetailModal.postCall.competitor': 'Wettbewerb',
  'modals.leadDetailModal.postCall.notes': 'Notizen',
  'modals.leadDetailModal.postCall.corrections': 'Korrekturen am Briefing',
  'modals.leadDetailModal.postCall.caller': 'Anrufer',
  'modals.leadDetailModal.postCall.script': 'Skript',
  'modals.createLead.title': 'Neuen Lead erstellen',
  'modals.createLead.firma': 'Firmenname',
  'modals.createLead.adresse': 'Adresse',
  'modals.createLead.plz': 'PLZ',
  'modals.createLead.ort': 'Ort',
  'modals.createLead.branche': 'Branche',
  'modals.createLead.telefon': 'Telefon',
  'modals.createLead.website': 'Website',
  'modals.createLead.submit': 'Lead erstellen',
  'modals.createLead.success': 'Lead wurde erstellt',
  'modals.createLead.error': 'Lead konnte nicht erstellt werden',
  'modals.regionDetailsModal.description': 'Übersicht der Missionsdetails. Diese Ansicht ist schreibgeschützt.',
  'modals.regionDetailsModal.edit': 'Bearbeiten',
  'modals.regionDetailsModal.close': 'Schließen',
  'modals.editRegionModal.close': 'Schließen',
  'modals.editRegionModal.description': 'Zeit und Notiz für die Mission bearbeiten. Status ist schreibgeschützt.',
  'modals.editRegionModal.statusReadonlySrOnly': 'Status ist schreibgeschützt.',
  'modals.splitAssignmentDialog.actionLabel': 'Aktion auswählen',
  'modals.splitAssignmentDialog.confirmButton': 'Bestätigen',
  'modals.addAppointmentModal.titleAdd': 'Termin hinzufügen',
  'modals.addAppointmentModal.titleEdit': 'Termin bearbeiten',
  'modals.addAppointmentModal.description': 'Terminangaben eingeben und speichern',
  'modals.addAppointmentModal.start': 'Start',
  'modals.addAppointmentModal.end': 'Ende',
  'modals.addAppointmentModal.companyLabel': 'Firma / Lead *',
  'modals.addAppointmentModal.companyAriaLabel': 'Firma / Lead auswählen oder eingeben',
  'modals.addAppointmentModal.location': 'Ort',
  'modals.addAppointmentModal.commitment': 'Verbindlichkeit',
  'modals.addAppointmentModal.commitmentConfirmed': 'Bestätigt',
  'modals.addAppointmentModal.errorTimeMissing': 'Bitte Start- und Endzeit angeben.',
  'modals.addAppointmentModal.errorTimeInvalid': 'Ungültige Zeit. Format HH:MM.',
  'modals.rejectLead.title': 'Lead ablehnen',
  'modals.rejectLead.closeAria': 'Dialog schließen',
  'modals.rejectLead.description': 'Wählen Sie mindestens einen Ablehnungsgrund aus.',
  'modals.rejectLead.reasonsLabel': 'Ablehnungsgründe',
  'modals.rejectLead.reasonsError': 'Bitte wählen Sie mindestens einen Grund aus.',
  'modals.rejectLead.otherReasonLabel': 'Sonstiger Grund',
  'modals.rejectLead.otherReasonPlaceholder': 'Bitte beschreiben Sie den Grund...',
  'modals.rejectLead.otherReasonAria': 'Sonstiger Ablehnungsgrund',
  'modals.rejectLead.otherReasonError': 'Bitte geben Sie einen Grund ein.',
  'modals.rejectLead.cancel': 'Abbrechen',
  'modals.rejectLead.confirm': 'Ablehnen ({count})',
  'modals.rejectLead.reason.outOfBusiness': 'Nicht mehr aktiv',
  'modals.rejectLead.reason.temporarilyClosed': 'Vorübergehend geschlossen',
  'modals.rejectLead.reason.knownAndUnsuitable': 'Bekannt und ungeeignet',
  'modals.rejectLead.reason.noInterest': 'Kein Interesse',
  'modals.rejectLead.reason.wrongContact': 'Falscher Ansprechpartner',
  'modals.rejectLead.reason.other': 'Sonstiges',

  // --- SS-145: ui-components + app-components ---
  'app.routes.loadingSettings': 'Lade Einstellungen...',
  'companySearch.filters.companySize': 'Unternehmensgröße',
  'curriculum.modules.pillar': 'Säule',
  'curriculum.modules.selectLevel': 'Level auswählen',
  'curriculum.modules.selectPillar': 'Säule auswählen',
  'curriculum.modules.selectPillarOption': 'Select Säule',
  'learning.lessonViewer.audioNotSupported': 'Dein Browser unterstützt das Audio-Element nicht.',
  'learning.lessonViewer.complete': 'Abschließen',
  'learning.lessonViewer.formatNotSupported': 'Format nicht unterstützt',
  'learning.lessonViewer.videoNotSupported': 'Dein Browser unterstützt das Video-Element nicht.',
  'learning.moduleEditor.pillar': 'Säule',
  'learning.moduleEditor.pillarLabel': 'Säule',
  'learning.tabs.availableLessons': 'Verfügbare Lektionen',
  'learning.tabs.availableQuizzes': 'Verfügbare Quizzes',
  'missionControl.totalLeads': 'Gesamt Leads',
  'missionControl.completedLeads': 'Abgeschlossene Leads',
  'missions.management.decisionMakerMet': 'Entscheider getroffen',
  'missions.management.wonAmount': 'Gewonnener Umsatz',
  'missions.management.demoPerformed': 'Demo durchgeführt',
  'missions.management.demoPerformedLabel': 'Demo durchgeführt',
  'missions.management.kpiDescription': 'Entscheider getroffen, Demo durchgeführt, Umsatz',
  'missions.management.moreActions': 'Weitere Aktionen für Mission anzeigen',
  'missions.management.publish': 'Veröffentlichen',
  'missions.management.searchPlaceholder': 'Suchen (Name/Region/Thema/Produkt)',
  'mobile.layout.closeMenu': 'Menü schließen',
  'mobile.layout.menu': 'Menü',
  'mobile.layout.noOfflineContent': 'Keine offline verfügbaren Inhalte',
  'mobile.layout.offlinePerformance': 'Für bessere Performance offline',
  'navigation.tileCard.openActions': 'Aktionen für Kachel öffnen',
  'scout.preferences.badenWuerttemberg': 'Baden-Württemberg',
  'scout.preferences.thueringen': 'Thüringen',
  'scout.sprints.ciEstimate': 'CI-Laufzeit-Schätzung',
  'scout.sprints.estimatedMinutes': 'Geschätzte Minuten',
  'styleGuide.charts.noStatusColors': 'Charts dürfen keine Statusfarben benutzen',
  'styleGuide.confirmation': 'Bestätigung',
  'styleGuide.description': 'Beschreibung',
  'styleGuide.statusSemantics.success': 'Erfolg = Abgeschlossen / OK',
  'tickets.list.filterPriority': 'Priorität filtern',
  'ui.calendar.nextMonth': 'Nächster Monat',
  'ui.errorBoundary.returnToDashboard': 'Zum Dashboard zurückkehren',
  'ui.impersonation.selectImpersonation': 'Impersonation auswählen',
  'ui.impersonation.selectUser': 'Benutzer auswählen:',
  'ui.routingPreview.openAppleMaps': 'In Apple Maps öffnen',
  'ui.routingPreview.openGoogleMaps': 'In Google Maps öffnen',
  'ui.routingPreview.stopsLabel': '{{count}} Stopps · {{distance}} km · {{time}} min (geschätzt)',
  'ui.routingPreview.title': 'Routenvorschau',
  'weeklyPlanning.appointmentModal.additionalNotes': 'Zusätzliche Notizen',
  'weeklyPlanning.legacyAppointments.addAppointment': 'Termin hinzufügen',
  'scout.help.selectArticle': 'Wähle links einen Artikel oder verwende die Suche, um einen Hilfe-Artikel zu öffnen.',
  'scout.help.title': 'Hilfe',
  'scout.help.subtitle': 'Finde Antworten und Produktguides für SCOUT',
  'scout.help.localeLabel': 'Sprache',
  'scout.help.localeDescription': 'Wechsle zwischen deutschen und englischen Inhalten',
  'scout.help.toggle.english': 'Englisch',
  'scout.help.toggle.german': 'Deutsch',
  'scout.help.clearCategory': 'Zurücksetzen',
  'scout.help.loadError': 'Hilfe-Inhalte konnten nicht geladen werden.',
  'scout.help.searchPlaceholder': 'Artikel suchen',
  'scout.help.searchLabel': 'Hilfe-Artikel durchsuchen',

  // Externe Freigabe-Akte (linkgeschützt, ohne App-Chrome)
  'external.case360.nav.jumpLabel': 'Zu Abschnitt springen',
  'external.case360.nav.summary': 'Überblick',
  'external.case360.nav.parties': 'Beteiligte',
  'external.case360.nav.timeline': 'Zeitverlauf',
  'external.case360.nav.amountsDocuments': 'Beträge & Dokumente',
  'external.case360.section.summary': 'Fallüberblick',
  'external.case360.section.parties': 'Beteiligte & Kontakte',
  'external.case360.section.timeline': 'Zeitverlauf',
  'external.case360.section.amountsDocuments': 'Beträge & Dokumente',
  'external.case360.summary.caseId': 'Fall-ID',
  'external.case360.summary.status': 'Status',
  'external.case360.summary.priority': 'Priorität',
  'external.case360.summary.assignee': 'Bearbeiter',
  'external.case360.summary.opened': 'Eröffnet',
  'external.case360.parties.role': 'Rolle',
  'external.case360.amounts.regionLabel': 'Betragsaufschlüsselung',
  'external.case360.amounts.heading': 'Beträge',
  'external.case360.amounts.line.principal': 'Hauptforderung',
  'external.case360.amounts.line.fees': 'Gebühren',
  'external.case360.amounts.line.interest': 'Zinsen',
  'external.case360.amounts.line.total': 'Gesamt',
  'external.case360.documents.regionLabel': 'Dokumente',
  'external.case360.documents.heading': 'Eingereichte Dokumente',
  'external.case360.documents.received': 'Eingang',

  // Visit Report — Rejection Sheet (B1)

  // Visit Report — Post-Visit Report (B2)

  // Visit Report — Compliance Gate (B3)
  'scout.visitReport.questionnaire.unknownType': 'Unbekannter Fragetyp',
  'scout.visitReport.questionnaire.finish': 'Bericht abschließen',
  'scout.visitReport.questionnaire.empty': 'Keine Fragen in der aktiven Konfiguration.',
  'scout.visitReport.compliance.title': 'Offene Besuchsberichte',
  'scout.visitReport.compliance.description': 'Du hast {{count}} offene Besuchsberichte. Bitte fülle diese zuerst aus.',
  'scout.visitReport.compliance.lockoutTitle': 'Berichte erforderlich',
  'scout.visitReport.compliance.lockoutDescription': 'Bitte fülle alle offenen Besuchsberichte aus, bevor du fortfahren kannst.',
  'scout.visitReport.compliance.deferButton': 'Später ausfüllen',
  'scout.visitReport.compliance.deferCount': '{{remaining}} Zurückstellungen verbleibend',
  'scout.visitReport.compliance.noDeferrals': 'Keine Zurückstellungen mehr verfügbar',
  'scout.visitReport.compliance.fillReport': 'Bericht ausfüllen',
  'scout.visitReport.compliance.morningLockout': 'Tagesplanung gesperrt bis alle offenen Berichte ausgefüllt sind.',

  // V1.3 Typeform-style visit report
  'scout.vr.submitted': 'Bericht gesendet',
  'scout.vr.scanPrompt.title': 'Bestellblock fotografieren?',
  'scout.vr.scanPrompt.jetzt': 'Jetzt fotografieren',
  'scout.vr.scanPrompt.spaeter': 'Später',
  'scout.vr.scanPrompt.noIdWarning': 'Beleg-Verknüpfung folgt nach Sync.',
  'scout.vr.next': 'Weiter',
  'scout.vr.yes': 'Ja',
  'scout.vr.no': 'Nein',
  'scout.vr.submit': 'Besuch abschließen',
  'scout.vr.access.title': 'Wie weit bist du gekommen?',
  'scout.vr.access.noAccess': 'Kein Zugang',
  'scout.vr.access.noDecisionMaker': 'Empfang / Pförtner',
  'scout.vr.access.decisionMakerReached': 'Ja, Entscheider erreicht',
  'scout.vr.noAccess.title': 'Warum kein Zugang?',
  'scout.vr.noAccess.business_closed': 'Geschlossen / keiner da',
  'scout.vr.noAccess.wrong_address': 'Adresse falsch / umgezogen',
  'scout.vr.noAccess.outside_hours': 'Außerhalb Geschäftszeiten',
  'scout.vr.noAccess.security_clearance': 'Kein Zutritt (Sicherheit)',
  'scout.vr.noAccess.other': 'Sonstiges',
  'scout.vr.noAccess.otherPlaceholder': 'Grund eingeben...',
  'scout.vr.noAccess.otherLabel': 'Kein Zugang - sonstiger Grund',
  'scout.vr.noDm.title': 'Was ist passiert?',
  'scout.vr.noDm.gatekeeper_rejected': 'Pförtner hat abgelehnt',
  'scout.vr.noDm.dm_unavailable': 'Entscheider nicht da',
  'scout.vr.noDm.referred_callback': 'Soll zurückrufen / Termin',
  'scout.vr.noDm.other': 'Sonstiges',
  'scout.vr.noDm.otherPlaceholder': 'Was ist passiert?',
  'scout.vr.noDm.otherLabel': 'Kein Entscheider - sonstiger Grund',
  'scout.vr.conversation.title': 'Wie lief das Gespräch?',
  'scout.vr.conversation.sale': 'Auftrag',
  'scout.vr.conversation.demo': 'Demo',
  'scout.vr.conversation.conversation': 'Gespräch',
  'scout.vr.conversation.rejected': 'Abgelehnt',
  'scout.vr.sale.title': 'Auftragsdetails',
  'scout.vr.sale.demoGiven': 'Wurde eine Demo gemacht?',
  'scout.vr.sale.productsOrdered': 'Welche Produkte bestellt?',
  'scout.vr.sale.estimatedValue': 'Geschätzter Wert?',
  'scout.vr.demo.title': 'Demo-Details',
  'scout.vr.demo.productsPresented': 'Welche Produkte vorgeführt?',
  'scout.vr.demo.productsInterested': 'Wofür Interesse?',
  'scout.vr.demo.followUp': 'Follow-up?',
  'scout.vr.conv.title': 'Gesprächsdetails',
  'scout.vr.conv.productsDiscussed': 'Welche Produkte besprochen?',
  'scout.vr.conv.productsInterested': 'Wofür Interesse?',
  'scout.vr.rejected.title': 'Warum kein Interesse?',
  'scout.vr.rejected.has_our_product': 'Hat bereits unser Produkt',
  'scout.vr.rejected.has_competitor_product': 'Hat Wettbewerbsprodukt',
  'scout.vr.rejected.too_expensive': 'Zu teuer',
  'scout.vr.rejected.no_purchasing_authority': 'Keine Einkaufsbefugnis',
  'scout.vr.rejected.no_conversation': 'Kein Gespräch möglich',
  'scout.vr.rejected.dm_not_present': 'Entscheider nicht anwesend',
  'scout.vr.rejected.business_closed': 'Geschäft geschlossen',
  'scout.vr.rejected.no_cleaning_need': 'Kein Reinigungsbedarf',
  'scout.vr.rejected.other': 'Sonstiges',
  'scout.vr.rejected.otherPlaceholder': 'Grund eingeben...',
  'scout.vr.rejected.otherLabel': 'Ablehnung - sonstiger Grund',
  'scout.vr.useCases.title': 'Stimmten die Anwendungsfälle?',
  'scout.vr.contact.title': 'Wen hast du getroffen?',
  'scout.vr.contact.takePhoto': 'Foto machen',
  'scout.vr.contact.orManual': '— oder —',
  'scout.vr.contact.firstName': 'Vorname',
  'scout.vr.contact.lastName': 'Nachname',
  'scout.vr.contact.role': 'Funktion',
  'scout.vr.contact.isDecisionMaker': 'Entscheider?',
  'scout.vr.contact.addPerson': '+ Weitere Person',
  'scout.vr.contact.secondPerson': 'Weitere Person',
  'scout.vr.briefing.toggle': 'Briefing ein-/ausblenden',
  'scout.vr.briefing.demoObject': 'Demo-Objekt',
  'scout.vr.briefing.problem': 'Problem',
  'scout.vr.briefing.moreProducts': 'Weitere Produkte',
  'scout.vr.typeCheck.title': 'Branche korrekt?',
  'scout.vr.typeCheck.unknown': 'Branche unbekannt',
  'scout.vr.typeCheck.yes': 'Ja, stimmt',
  'scout.vr.typeCheck.no': 'Nein, falsch',
  'scout.vr.wrapUp.title': 'Abschluss',
  'scout.vr.wrapUp.customerStatus': 'Hattest du vorher schon Kontakt?',
  'scout.vr.wrapUp.neukunde': 'Erstkontakt',
  'scout.vr.wrapUp.bekannt': 'Kenne ich',
  'scout.vr.wrapUp.visitType': 'Mit oder ohne Termin?',
  'scout.vr.wrapUp.termin': 'Termin',
  'scout.vr.wrapUp.kaltbesuch': 'Kaltbesuch',
  'scout.vr.wrapUp.nextStep': 'Nächster Schritt?',
  'scout.vr.wrapUp.send_offer': 'Angebot senden',
  'scout.vr.wrapUp.deliver_test': 'Muster liefern',
  'scout.vr.wrapUp.schedule_followup': 'Termin vereinbaren',
  'scout.vr.wrapUp.none': 'Kein Follow-up',
  'scout.vr.wrapUp.offerNotePlaceholder': 'z.B. Produkte, Konditionen...',
  'scout.vr.wrapUp.timeframe.this_week': 'Diese Woche',
  'scout.vr.wrapUp.timeframe.next_week': 'Nächste Woche',
  'scout.vr.wrapUp.timeframe.in_2_weeks': 'In 2 Wochen',
  'scout.vr.wrapUp.timeframe.in_1_month': 'In 1 Monat',
  'scout.vr.wrapUp.timeframe.unclear': 'Unklar',
  'scout.vr.optional': 'optional',
  'scout.vr.wrapUp.notes': 'Notizen (optional)',
  'scout.vr.wrapUp.notesPlaceholder': 'Weitere Anmerkungen zum Besuch...',
  'scout.vr.briefingLoading': 'Briefing wird geladen…',
  'scout.vr.briefingErrorTitle': 'Briefing nicht verfügbar',
  'scout.vr.briefingErrorDesc': 'Briefing konnte nicht geladen werden.',
  'scout.vr.questionnaireLoading': 'Fragebogen wird geladen…',
  'scout.vr.questionnaireErrorTitle': 'Fragebogen nicht verfügbar',
  'scout.vr.questionnaireErrorDesc': 'Der aktive Fragebogen konnte nicht geladen werden.',
  // NEVER-DARK: a spontaneous walk-in (Joker) / not-in-mission stop has no
  // briefing. The report must still be fileable — soft inline notice, never a
  // blocking screen (BUG: joker visit-report dead-end 2026-06-17).
  'scout.vr.briefingMissingNotice': 'Kein Briefing für diesen Stopp (z. B. spontaner Besuch). Sie können den Bericht trotzdem ausfüllen.',
  // Edit-not-resend (operator 2026-06-17): a report already exists for this
  // stop. Block a silent duplicate; let the rep open it to make changes.
  'scout.vr.alreadySubmitted.title': 'Bericht bereits gesendet',
  'scout.vr.alreadySubmitted.desc': 'Für diesen Besuch wurde bereits ein Bericht abgegeben. Öffnen Sie ihn, um Änderungen vorzunehmen.',
  'scout.vr.alreadySubmitted.openToEdit': 'Bericht öffnen & ändern',

  // Learning — Lehrplan & Curriculum (pages)
  'learning.lehrplan.title': 'Lehrplan',
  'learning.lehrplan.subtitle': 'Lehrplan und Lernziele verwalten',
  'learning.curriculumPlanning.title': 'Lehrplanplanung',
  'learning.curriculumPlanning.subtitle': 'Lehrplan strukturieren und Lerninhalte zuordnen',

  // Navigation (App Overview, Tile View)
  'navigation.appOverview': 'App-Übersicht',

  // PO Sprints (page titles)

  // Purchase (list/detail)

  // Sales (list)

  // Common (extra)
  'common.next': 'Weiter',

  // Warehouse Picking (action)

  // Scout Wochenplanung — Aggregates

  // Scout Wochenplanung — Mission Wishes (Rep self-serve)
  'scout.wochenplanung.missionWishes.title': 'Meine Wünsche für nächste Woche',
  'scout.wochenplanung.missionWishes.loadError': 'Fehler beim Laden deiner Missionswünsche.',
  'scout.wochenplanung.missionWishes.saveError': 'Deine Missionswünsche konnten nicht gespeichert werden.',
  'scout.wochenplanung.missionWishes.noUserTitle': 'Keine Nutzerinformationen',
  'scout.wochenplanung.missionWishes.noUserDescription': 'Melde dich an, um deine Missionswünsche zu hinterlegen.',
  'scout.wochenplanung.missionWishes.assignedPlzTitle': 'PLZ-Gebiete (zugewiesen)',
  'scout.wochenplanung.missionWishes.assignedPlzEmptyTitle': 'Keine PLZ-Gebiete zugewiesen',
  'scout.wochenplanung.missionWishes.assignedPlzEmptyDescription': 'Sobald dein Gebietsplan steht, siehst du deine PLZ-Gebiete hier als grüne Badges.',
  'scout.wochenplanung.missionWishes.focusPlzTitle': 'Wunsch-PLZ',
  'scout.wochenplanung.missionWishes.focusPlzDescription': 'Wähle die PLZ-Gebiete aus, in denen du nächste Woche bevorzugt arbeiten möchtest.',
  'scout.wochenplanung.missionWishes.focusProductsTitle': 'Produkte',
  'scout.wochenplanung.missionWishes.focusProductsPlaceholder': 'Produkte auswählen...',
  'scout.wochenplanung.missionWishes.focusProductsDescription': 'Wähle die Produkte aus, auf die du dich nächste Woche fokussieren möchtest.',
  'scout.wochenplanung.missionWishes.productsWeightsDescription': 'Gewichtung pro Produkt — ↑ Fokus, = neutral, ↓ vermeiden. Mission-Generator multipliziert die Score.',
  'scout.wochenplanung.missionWishes.industriesWeightsDescription': 'Gewichtung pro Branche — ↑ Fokus, = neutral, ↓ vermeiden.',
  'scout.wochenplanung.missionWishes.idUnresolvedWarning': 'PLZ-Daten zurzeit nicht verfügbar — Benutzer-ID wird noch geladen. Bitte Seite neu laden, falls es länger dauert.',
  'scout.wochenplanung.missionWishes.focusIndustriesTitle': 'Branchen',
  'scout.wochenplanung.missionWishes.focusIndustriesPlaceholder': 'Branchen auswählen...',
  'scout.wochenplanung.missionWishes.focusIndustriesDescription': 'Wähle die Branchen aus, die du nächste Woche priorisieren möchtest.',
  'scout.wochenplanung.missionWishes.managerNoteTitle': 'Manager-Hinweis',
  'scout.wochenplanung.missionWishes.managerNoteEmptyTitle': 'Noch kein Manager-Hinweis',
  'scout.wochenplanung.missionWishes.managerNoteEmptyDescription': 'Sobald es einen Fokus oder Hinweis von deinem Manager gibt, erscheint er hier.',
  'scout.wochenplanung.missionWishes.saving': 'Speichern…',
  'scout.wochenplanung.missionWishes.save': 'Wünsche speichern',
  'scout.wochenplanung.missionWishes.saved': 'Wünsche gespeichert',
  'scout.wochenplanung.missionWishes.savedQueued': 'Wünsche gespeichert – werden synchronisiert.',
  'scout.wochenplanung.missionWishes.removePlz': 'PLZ entfernen',

  // Scout Mission Control — Plan View

  // Supplier onboarding — Form (CompanyInfoSection, ContactInfoSection, DocumentUploadSection)

  // Placeholders (supplier forms)

  // Form (supplier — ContactInfoSection)

  // Role (supplier contact)

  // Country (supplier address)
  'country.US': 'Vereinigte Staaten',
  'country.CA': 'Kanada',
  'country.MX': 'Mexiko',
  'country.GB': 'Vereinigtes Königreich',
  'country.DE': 'Deutschland',
  'country.FR': 'Frankreich',
  'country.other': 'Sonstiges',

  // Business type (supplier — CompanyInfoSection uses businessType.*)

  // DynamicSurvey — contact_block field type
  'survey.contact.name': 'Name',
  'survey.contact.namePlaceholder': 'Name eingeben',
  'survey.contact.function': 'Funktion / Rolle',
  'survey.contact.functionPlaceholder': 'Funktion eingeben',
  'survey.contact.email': 'E-Mail',
  'survey.contact.emailPlaceholder': 'E-Mail-Adresse eingeben',
  'survey.contact.phone': 'Telefon',
  'survey.contact.phonePlaceholder': 'Telefonnummer eingeben',
  'survey.contact.isDecisionMaker': 'Ist Entscheider?',

  // Wiedervorlagen (callback queue) — FR-RI-CALLBACK-QUEUE-V1
  // Visit-Report Viewer (read-only browse of submitted reports)
  'scout.visitReportViewer.title': 'Besuchsberichte',
  'scout.visitReportViewer.subtitle': 'Eingereichte Besuchsberichte ansehen — nur lesen',
  'scout.visitReportViewer.filterRep': 'Außendienstler',
  'scout.visitReportViewer.filterDate': 'Datum',
  'scout.visitReportViewer.filterCustomer': 'Kunde',
  'scout.visitReportViewer.filterAll': 'Alle',
  'scout.visitReportViewer.customerRef': 'Kunde',
  'scout.visitReportViewer.repRef': 'AD',
  'scout.visitReportViewer.statusSubmitted': 'Eingereicht',
  'scout.visitReportViewer.statusDraft': 'Entwurf',
  'scout.visitReportViewer.errorTitle': 'Besuchsberichte konnten nicht geladen werden',
  'scout.visitReportViewer.emptyTitle': 'Keine Berichte',
  'scout.visitReportViewer.emptyDesc': 'Für die letzten 30 Tage liegen keine Besuchsberichte vor.',
  'scout.visitReportViewer.noMatchTitle': 'Keine Treffer',
  'scout.visitReportViewer.noMatchDesc': 'Für die gewählten Filter gibt es keine Besuchsberichte.',
  'scout.wiedervorlagen.title': 'Wiedervorlagen',
  'scout.wiedervorlagen.subtitle': 'Fällige Rückrufe — nach „telefoniert am“ sortiert',
  'scout.wiedervorlagen.hint': 'Diese Liste dient nur zur Priorisierung. Zurückgerufen wird über die normale Anruf-Maske — von hier aus wird nicht telefoniert.',
  'scout.wiedervorlagen.overdue': 'Überfällig',
  'scout.wiedervorlagen.col.company': 'Firma',
  'scout.wiedervorlagen.col.contact': 'Ansprechpartner',
  'scout.wiedervorlagen.col.lastCalledAt': 'Telefoniert am',
  'scout.wiedervorlagen.col.callbackAt': 'Rückruf am',
  'scout.wiedervorlagen.col.detail': 'Notiz / Grund',
  'scout.wiedervorlagen.col.lastOutcome': 'Letztes Ergebnis',
  'scout.wiedervorlagen.col.phone': 'Telefon',
  'scout.wiedervorlagen.col.status': 'Status',
  'scout.wiedervorlagen.col.actions': 'Aktionen',
  'scout.wiedervorlagen.call.noPhone': 'Keine Telefonnummer vorhanden',
  'scout.wiedervorlagen.call.notReady': 'Telefonverbindung wird aufgebaut …',
  'scout.wiedervorlagen.action.call': 'Anrufen',
  'scout.wiedervorlagen.action.complete': 'Erledigt',
  'scout.wiedervorlagen.action.reschedule': 'Verschieben',
  'scout.wiedervorlagen.reschedule.label': 'Neuer Termin',
  'scout.wiedervorlagen.reschedule.confirm': 'Termin setzen',
  'scout.wiedervorlagen.empty.title': 'Keine Wiedervorlagen',
  'scout.wiedervorlagen.empty.description': 'Aktuell sind keine Rückrufe geplant.',
  'scout.wiedervorlagen.error.title': 'Wiedervorlagen konnten nicht geladen werden',
  'scout.wiedervorlagen.error.contract': 'Die Datenstruktur hat sich geändert (Contract-Fehler). Bitte an das Team melden.',
  'scout.wiedervorlagen.error.generic': 'Unerwarteter Fehler beim Laden der Wiedervorlagen.',
  'scout.wiedervorlagen.toast.completed': 'Wiedervorlage als erledigt markiert',
  'scout.wiedervorlagen.toast.rescheduled': 'Termin verschoben',
  'scout.wiedervorlagen.toast.writeFailed': 'Aktion fehlgeschlagen — bitte erneut versuchen',

  // PreQual Calling
  'scout.prequal.loadError': 'Fehler beim Laden der Leads',
  'scout.prequal.sessionStale.title': 'Session ist abgelaufen',
  'scout.prequal.sessionStale.desc': 'Diese Calling-Session wurde bereits beendet. Starte eine neue Session, um weiter zu telefonieren.',
  'scout.prequal.sessionStale.action': 'Neue Session starten',
  'scout.prequal.startSession': 'Session starten',
  'scout.prequal.skipLead': 'Überspringen',
  'scout.prequal.disqualifyLead': 'Disqualifizieren',
  'scout.prequal.disqualify.title': 'Lead disqualifizieren',
  'scout.prequal.disqualify.confirm': 'Disqualifizieren',

  // PreQual Calling V2 (Live Phone — live transcript surface)
  'scout.prequalV2.title': 'Pre-Qual Calling',
  'scout.prequalV2.layout': 'Layout:',
  'scout.prequalV2.loading': 'Calling-Cockpit wird geladen…',
  'scout.prequalV2.muted': 'Stumm',
  'scout.prequalV2.queue': 'Warteschlange',
  'scout.prequalV2.leadProfile': 'Lead-Profil',
  'scout.prequalV2.projection': 'DEC-012 Projektion',
  'scout.prequalV2.phone': 'Telefon',
  'scout.prequalV2.location': 'Standort',
  'scout.prequalV2.employees': 'Mitarbeiter',
  'scout.prequalV2.website': 'Website',
  'scout.prequalV2.tradeDescription': 'Tätigkeit',
  'scout.prequalV2.revenue': 'Umsatz',
  'scout.prequalV2.founded': 'Gegründet',
  'scout.prequalV2.score': 'Score',
  'scout.prequalV2.liveTranscript': 'Live-Transkript',
  'scout.prequalV2.transcriptBeta': 'Beta — Deepgram',
  'scout.prequalV2.transcriptEmpty': 'Warte auf Gesprächsbeginn…',
  'scout.prequalV2.speakerAgent': 'Sie',
  'scout.prequalV2.speakerCustomer': 'Kunde',
  'scout.prequalV2.spinGuide': 'SPIN-Leitfaden',
  'scout.prequalV2.outcomeLabel': 'Ergebnis',
  'scout.prequalV2.outcomeAppointment': 'Termin vereinbart',
  'scout.prequalV2.outcomeNoInterest': 'Kein Interesse',
  'scout.prequalV2.outcomeCallback': 'Rückruf gewünscht',
  'scout.prequalV2.outcomeNotReached': 'Nicht erreicht',
  'scout.prequalV2.outcomeQualified': 'Qualifiziert',
  'scout.prequalV2.notes': 'Notiz',
  'scout.prequalV2.notesPlaceholder': 'Gesprächsnotiz…',
  'scout.prequalV2.mute': 'Stumm',
  'scout.prequalV2.unmute': 'Laut',
  'scout.prequalV2.hold': 'Halten',
  'scout.prequalV2.resumeHold': 'Weiter',
  'scout.prequalV2.transfer': 'Transfer',
  'scout.prequalV2.end': 'Beenden',
  'scout.prequalV2.logAndNext': 'Loggen & Weiter',
  'scout.prequalV2.expose': 'Exposé',
  'scout.prequalV2.exposePending': 'Recherche wird vorbereitet…',
  'scout.prequalV2.exposePredictedProduct': 'Produkt-Prognose',
  'scout.prequalV2.exposeObjects': 'Objekte',
  'scout.prequalV2.exposeContamination': 'Verschmutzung',
  'scout.prequalV2.exposeDmToAskFor': 'Ansprechpartner',
  'scout.prequalV2.exposeUseCases': 'Anwendungsfälle',
  'scout.prequalV2.exposeOpeningQuestion': 'Einstiegsfrage',
  'scout.prequalV2.exposeProbeQuestions': 'Vertiefungsfragen',
  'scout.prequalV2.autoDial': 'Auto-Dialer',
  'scout.prequalV2.autoDialOn': 'Auto-Dialer aktiviert',
  'scout.prequalV2.autoDialOff': 'Auto-Dialer deaktiviert',
  'scout.prequalV2.on': 'An',
  'scout.prequalV2.off': 'Aus',
  'scout.prequal.noLeads': 'Keine Leads verfügbar',
  'scout.prequal.callerProfileUnresolved': 'Caller-Profil nicht vollständig geladen — Anrufliste evtl. eingeschränkt. Anrufe/Sitzung können erst nach vollständigem Laden gestartet werden.',
  'scout.prequal.queueDegraded': 'Lead-Vorschau aktuell eingeschränkt — eine Kampagne konnte nicht geladen werden. Anrufe in den anderen Kampagnen sind weiterhin möglich.',
  'scout.prequal.startBlockedUnresolved': 'Profil nicht aufgelöst',

  // ── Calling-Session Start: die rep-sichtbare Wahrheit, wenn KEINE Session
  //    gestartet wurde (BUG-FE-CALLING-SESSION-SILENT-SKIP-2026-07-27).
  //    Jede Meldung nennt (a) was passiert ist, (b) die Folge — es werden keine
  //    Leads geladen — und (c) den nächsten Schritt. Laut UND lösbar.
  'scout.prequal.sessionStart.title': 'Session nicht gestartet.',
  'scout.prequal.sessionStart.noAssignedCampaigns': 'Ihnen ist keine Kampagne zugewiesen. Es wurde keine Calling-Session gestartet und es werden keine Leads geladen. Bitte wenden Sie sich an Ihren Vorgesetzten.',
  'scout.prequal.sessionStart.noActiveCampaign': 'Keine Ihrer zugewiesenen Kampagnen ist aktiv — alle sind archiviert. Es wurde keine Calling-Session gestartet und es werden keine Leads geladen. Bitte wenden Sie sich an Ihren Vorgesetzten.',
  'scout.prequal.sessionStart.campaignNotActive': 'Die gewählte Kampagne ist nicht mehr aktiv (archiviert). Es wurde keine Calling-Session gestartet und es werden keine Leads geladen. Bitte wählen Sie eine aktive Kampagne aus.',
  'scout.prequal.sessionStart.campaignUnknown': 'Die gewählte Kampagne ist Ihnen nicht zugewiesen. Es wurde keine Calling-Session gestartet und es werden keine Leads geladen. Bitte wählen Sie eine Kampagne aus Ihrer Liste aus.',
  'scout.prequal.sessionStart.ambiguousCampaign': 'Es ist keine Kampagne ausgewählt. Es wurde keine Calling-Session gestartet und es werden keine Leads geladen. Bitte wählen Sie zuerst eine Kampagne aus.',
  'scout.prequal.sessionStart.startFailed': 'Die Calling-Session konnte auf dem Server nicht gestartet werden. Es werden keine Leads geladen. Bitte erneut versuchen.',
  'scout.prequal.sessionStart.noSessionId': 'Der Server hat keine Session-ID zurückgegeben — die Calling-Session ist nicht aktiv und es werden keine Leads geladen. Bitte erneut versuchen.',
  'scout.prequal.sessionStart.pickCampaign': 'Kampagne auswählen',
  'scout.prequal.sessionStart.retry': 'Erneut versuchen',

  'scout.prequal.sessionDoneTitle': 'Session abgeschlossen',
  'scout.prequal.sessionDoneSubtitle': 'Alle Leads für heute wurden bearbeitet.',
  'scout.prequal.restartSession': 'Neue Session starten',
  'scout.prequal.statsCalls': 'Anrufe',
  'scout.prequal.statsReached': 'Erreicht',
  'scout.prequal.saveAndNext': 'Speichern & Weiter',
  'scout.prequal.role': 'Rolle',
  'scout.prequal.availability': 'Erreichbarkeit',
  'scout.prequal.directPhone': 'Durchwahl',
  'scout.prequal.email': 'E-Mail',
  'scout.prequal.addressStreet': 'Straße',
  'scout.prequal.addressPostalCode': 'PLZ',
  'scout.prequal.addressCity': 'Ort',
  'scout.prequal.companyName': 'Firma',
  'scout.prequal.leadId': 'Lead-ID',
  'scout.prequal.notes': 'Notizen',
  'scout.prequal.callNotesPlaceholder': 'Notizen zum Gespräch…',
  'scout.prequal.leadHistory.title': 'Lead-Historie',
  'scout.prequal.leadHistory.loading': 'Vorherige Gesprächsdaten werden geladen…',
  'scout.prequal.leadHistory.error': 'Lead-Historie konnte nicht geladen werden.',
  'scout.prequal.leadHistory.empty': 'Keine vorherigen Gespräche zu diesem Lead.',
  'scout.prequal.leadHistory.lastOutcome': 'Letztes Ergebnis',
  'scout.prequal.leadHistory.notes': 'Notizen vom letzten Gespräch',
  'scout.prequal.leadHistory.when': 'Wann',
  'scout.prequal.callHistory.title': 'Anrufverlauf',
  'scout.prequal.callHistory.loading': 'Anrufverlauf wird geladen…',
  'scout.prequal.callHistory.error': 'Anrufverlauf konnte nicht geladen werden.',
  'scout.prequal.callHistory.empty': 'Keine vorherigen Anrufe zu diesem Lead.',
  'scout.prequal.callHistory.dial': 'Anrufen',
  'scout.prequal.disqualificationReason': 'Grund der Disqualifizierung',
  'scout.prequal.savedNextLoading': 'Gespeichert — Nächster Lead wird geladen',
  'scout.prequal.saveFailed': 'Speichern fehlgeschlagen',
  'scout.prequal.saveFailedDesc': 'Deine Eingaben sind noch da. Bitte nochmal versuchen.',
  'scout.prequal.retrySave': 'Erneut speichern',
  'scout.calling.lobbyTitle': 'Bereit für die nächste Session',
  'scout.calling.saveAndNext': 'Speichern und weiter',
  'scout.calling.pullNext': 'Nächsten Lead holen',
  'scout.calling.backToDashboard': 'Zurück zum Scout-Dashboard',
  'scout.calling.objectionsHeard': 'Einwände gehört',
  'scout.calling.evaluation': 'Bewertung',
  'scout.calling.isDecisionMaker': 'Entscheider?',
  'scout.calling.interestLevel': 'Interesse',
  'scout.calling.yes': 'Ja',
  'scout.calling.no': 'Nein',
  'scout.calling.unknown': 'Unklar',
  'scout.calling.callbackTime': 'Rückruf-Termin',
  'scout.calling.callbackHint': 'Wann soll zurückgerufen werden?',
  'scout.calling.disqualifiedReasons': 'Disqualifikation — Gründe',
  'scout.calling.transportHealth.unstable': 'Voice-Verbindung instabil — Seite neu laden, falls Anrufe nicht starten.',
  'scout.calling.transportHealth.dismiss': 'Hinweis ausblenden',
  'scout.prequal.objections': 'Einwände',
  'scout.prequal.noLeadSelected': 'Kein Lead ausgewählt',
  'scout.prequal.selectIndustryForClusters': 'Branche wählen, um Cluster zu laden',
  'scout.prequal.clustersLoading': 'Cluster werden geladen…',
  'scout.prequal.clustersLoadError': 'Cluster konnten nicht geladen werden — bitte Seite neu laden (Ctrl+Shift+R)',
  'scout.prequal.cockpit.calls': 'Anrufe',
  'scout.prequal.cockpit.reached': 'Erreicht',
  'scout.prequal.cockpit.qualified': 'Qualifiziert',
  'scout.prequal.cockpit.conversionRate': 'Quote',
  'scout.prequal.cockpit.exitSession': 'Session verlassen',
  'scout.prequal.cockpit.saveAndNext': 'Speichern & Weiter',
  'scout.prequal.cockpit.interestLevel': 'Interesse',
  'scout.prequal.cockpit.facility': 'Anlage vorhanden?',
  'scout.prequal.cockpit.facilityYes': 'Ja',
  'scout.prequal.cockpit.facilityNo': 'Nein',
  'scout.prequal.cockpit.facilityUnknown': 'Unklar',
  'scout.prequal.cockpit.gatekeeperPassed': 'Am Empfang vorbei?',
  'scout.prequal.cockpit.competitor': 'Wettbewerber',
  'scout.prequal.cockpit.competitorPlaceholder': 'z.B. Würth, Dr. Schnell',
  'scout.prequal.callStats.title': 'Deine Anrufe heute',
  'scout.prequal.callStats.calls': 'Anrufe',
  'scout.prequal.callStats.reached': 'Erreicht',
  'scout.prequal.callStats.qualified': 'Qualifiziert',
  'scout.prequal.callStats.notReached': 'Nicht erreicht',
  'scout.prequal.callStats.reachedRate': 'Erreichbarkeit',
  'scout.prequal.voice.connecting': 'Verbinde…',
  'scout.prequal.transcript.title': 'Live-Transkript',
  'scout.prequal.transcript.waiting': 'Warte auf Gesprächsbeginn…',
  'scout.prequal.transcript.extracted': 'Erkannte Daten',
  'scout.prequal.lastNamePlaceholder': 'Müller',
  'scout.prequal.selectDate': 'Datum wählen',
  'scout.prequal.onboardingTitle': 'Willkommen bei PreQual',
  'scout.prequal.onboardingStart': 'Los geht\'s',
  'scout.prequal.onboardingDismiss': 'Nicht mehr anzeigen',
  'scout.prequal.leadsLabel': 'Leads in der Warteschlange',
  'scout.prequal.openLeadsLabel': 'offene Leads',
  'scout.prequal.leadsTable.heading': 'Leads in dieser Kampagne',
  'scout.prequal.leadsTable.company': 'Firma',
  'scout.prequal.leadsTable.orders': 'Bestellungen',
  'scout.prequal.leadsTable.revenue': 'Umsatz',
  'scout.prequal.leadsTable.products': 'Produkte',
  'scout.prequal.leadsTable.contact': 'Ansprechpartner',
  'scout.prequal.leadsTable.phone': 'Telefon',
  'scout.prequal.leadsTable.status': 'Status',
  'scout.prequal.leadsTable.lastCall': 'Letzter Anruf',
  'scout.prequal.leadsTable.callbackAt': 'Rückruf am',
  'scout.prequal.leadsTable.attempts': 'Versuche',
  'scout.prequal.leadsTable.grabAndCall': 'Übernehmen & anrufen',
  'scout.prequal.leadsTable.error': 'Leads konnten nicht geladen werden',
  'scout.prequal.leadsTable.empty': 'Keine Leads in dieser Kampagne.',
  'scout.prequal.leadsTable.filterAll': 'Alle',
  'scout.prequal.leadsTable.filterOpen': 'Offen',
  'scout.prequal.leadsTable.filterCallback': 'Rückruf',
  'scout.prequal.leadsTable.filterBestandskunde': 'Bestandskunde',
  'scout.prequal.leadsTable.statusCallback': 'Rückruf',
  'scout.prequal.leadsTable.statusNotReached': 'Noch nicht erreicht',
  'scout.prequal.leadsTable.statusNeverTried': 'Nie versucht',
  'scout.prequal.leadsTable.phonesHeading': 'Telefonnummern',
  'scout.prequal.leadsTable.phoneCentral': 'Zentrale',
  'scout.prequal.leadsTable.phoneContact': 'Durchwahl',
  'scout.prequal.leadsTable.phoneGoogle': 'Google',
  'scout.prequal.leadsTable.industry': 'Branche',
  'scout.prequal.leadsTable.firma': 'Firma',
  'scout.prequal.leadsTable.location': 'Ort',
  'scout.prequal.leadsTable.employees': 'Mitarbeiter',
  'scout.prequal.leadsTable.note': 'Notiz',
  'scout.prequal.leadsTable.bestandskunde': 'Bestandskunde',
  'scout.prequal.leadsTable.bestandskundeYes': 'Bestandskunde',
  'scout.prequal.callbacks.button': 'Rückrufe',
  'scout.prequal.callbacks.heading': 'Fällige Rückrufe',
  'scout.prequal.callbacks.empty': 'Keine Rückrufe in dieser Kampagne.',
  'scout.prequal.callbacks.due': 'Rückruf',
  'scout.prequal.callbacks.lastCall': 'Zuletzt',
  'scout.prequal.pinned.backToLobby': 'Zurück zur Lobby',
  'scout.prequal.pinned.resumeCampaign': 'Kampagne fortsetzen',
  'info.products.title': 'Produktkatalog',
  'info.products.description': 'Alle CLANDA Produkte auf einen Blick.',
  'info.products.noDescription': 'Produktbeschreibung folgt.',
  'info.industries.title': 'Branchenübersicht',
  'info.industries.description': 'Alle Kundensegmente und Branchen-Codes.',
  'scout.prequal.duration': 'Dauer',
  'scout.prequal.summary.verifyCompany': 'Unternehmensdaten bestätigen',
  'scout.prequal.interestRequired': 'Bitte Interesse setzen',
  'scout.customers.title': 'Kunden',
  'scout.customers.subtitle': 'RFM-Analyse deiner Kunden',
  'scout.customers.loadError': 'Kundendaten konnten nicht geladen werden',
  'scout.customers.table.customer': 'Kunde',
  'scout.customers.table.rfmScore': 'RFM Score',
  'scout.customers.table.segment': 'Segment',
  'scout.customers.table.recency': 'Zuletzt (Tage)',
  'scout.customers.table.frequency': 'Frequenz',
  'scout.customers.table.monetary': 'Umsatz',
  'scout.dailyPlanning.cityCompletion': 'Orte-Fortschritt',
  'scout.dailyPlanning.endDay': 'Tag beenden',
  'scout.dailyPlanning.endDayConfirm': 'Tag beenden und Mission zur Review einreichen?',
  'scout.dailyPlanning.reviewRequested': 'Mission zur Review eingereicht',
  'scout.dailyPlanning.reviewFailed': 'Missionstatus konnte nicht aktualisiert werden',
  'scout.dailyPlanning.missionStatus.draft': 'Entwurf',
  'scout.dailyPlanning.missionStatus.planned': 'Geplant',
  'scout.dailyPlanning.missionStatus.inProgress': 'Aktiv',
  'scout.dailyPlanning.missionStatus.done': 'Abgeschlossen',
  'prequal.industryCheatSheet': 'Branchen-Übersicht',
  'prequal.industry.confirm': 'Bestätigen',
  'scout.missions.wunschliste.noPostalCodes': 'Noch keine PLZ-Gebiete hinzugefügt.',
  'scout.missions.wunschliste.addPostalCode': 'PLZ hinzufügen',
  'scout.missions.wunschliste.add': 'Hinzufügen',
  'scout.missionControl.teamSteering.globalNotesPlaceholder': 'z.B. Irankonflikt — Ölprodukte reduzieren',
  'styleGuide.hover.toggleSwitch': 'Toggle / Switch',
  'styleGuide.hover.trackLightens': 'Track hellt leicht auf',
  'sync.syncing': 'Synchronisiere…',
  'sync.offline': 'Offline',
  'sync.queued': 'in Warteschlange',
  'scout.missionControl.live.prevWeek': 'Vorherige Woche',
  'scout.missionControl.live.nextWeek': 'Nächste Woche',
  'scout.missionControl.live.currentWeek': 'Aktuelle Woche',

  // ── ATC / Commander Bridge ──────────────────────────────────────────────
  'nav.atc': 'ATC',
  'nav.atc.bridge': 'Commander Bridge',
  'nav.atc.docs': 'Doc-Suche',

  // Registry list (/atc/bridge/agents/registry)
  'atc.registry.list.hint': 'Zum vollständigen Audit eine Zeile antippen.',

  // Registry shell (identity-first master/detail, R1)
  'atc.registry.shell.title': 'Agents',
  'atc.registry.shell.subtitle': '{{count}} Personas — Identity-first Registry',
  'atc.registry.shell.filterAll': 'Alle',
  'atc.registry.shell.filterLive': 'Live',
  'atc.registry.shell.selectTitle': 'Agent auswählen',
  'atc.registry.shell.selectDesc': 'Wähle links eine Persona, um die Identity Stack zu sehen.',
  'atc.registry.shell.pendingTitle': 'Identity Stack ausstehend',
  'atc.registry.shell.pendingDesc':
    'SL FR-RG1 (/v1/agents/{id}/identity-docs) noch nicht live. Inhalt füllt Welle 2.',
  'atc.registry.shell.backLabel': 'Zurück zur Liste',
  'atc.registry.shell.liveCount': '{{count}} live',
  'atc.registry.shell.errorTitle': 'Registry nicht verfügbar',
  'atc.registry.shell.emptyTitle': 'Keine Agents registriert',
  'atc.registry.shell.emptyDesc': 'Es sind keine Personas in der Registry vorhanden.',
  'atc.registry.shell.scaffoldingMessage': 'Registry wird neu gebaut (V14). Sortie S4 in Vorbereitung.',
  'atc.registry.column.agent': 'Agent',
  'atc.registry.column.shorthandle': 'Shorthandle',
  'atc.registry.column.status': 'Status',
  'atc.registry.column.live': 'Live',
  'atc.registry.column.turns': 'Turns',
  'atc.registry.column.replies': 'Replies',
  'atc.registry.column.idle': 'Idle',
  'atc.registry.column.branch': 'Branch',
  'atc.registry.column.model': 'Model',
  'atc.registry.column.repo': 'Repo',
  'atc.registry.column.lastActivity': 'Last activity',
  'atc.registry.column.liveCount': 'Live count',
  'atc.registry.column.ctxPercent': 'CTX %',
  'atc.registry.drawer.title': 'Agent-Details',
  'atc.registry.drawer.tab.uebersicht': 'Übersicht',
  'atc.registry.drawer.tab.aktivitaet': 'Aktivität',
  'atc.registry.drawer.tab.arbeit': 'Arbeit',
  'atc.registry.drawer.tab.prs': 'PRs',
  'atc.registry.drawer.tab.dokumente': 'Dokumente',
  'atc.registry.drawer.action.openChat': 'Chat öffnen (J)',
  'atc.registry.drawer.action.pauseEmbodiment': 'Embodiment pausieren (P)',
  'atc.registry.drawer.action.restart': 'Restart auslösen (R)',
  'atc.registry.drawer.action.openInRepo': 'Im Repo öffnen (G)',
  'atc.registry.drawer.action.close': 'Schließen (Esc)',
  'atc.registry.tooltip.ctxPending': 'Wartet auf session_host-Instrumentierung',
  'atc.registry.viewToggle.flat': 'Flach',
  'atc.registry.viewToggle.byRepo': 'Nach Repo',
  'atc.registry.viewToggle.byOwner': 'Nach Owner',
  'atc.registry.viewToggle.byPersona': 'Nach Persona',
  'atc.registry.savedView.all': 'Alle',
  'atc.registry.savedView.live': 'Live',
  'atc.registry.savedView.idle': 'Idle',
  'atc.registry.savedView.stuck': 'Steckt fest',
  'atc.registry.savedView.cloud': 'Cloud lane',
  'atc.registry.savedView.local': 'Local lane',
  'atc.registry.toolbar.filter': 'Filter',
  'atc.registry.toolbar.addPersona': 'Persona',
  'atc.registry.toolbar.searchPlaceholder': 'Suchen…',
  'atc.registry.profile.tabs.uebersicht': 'Übersicht',
  'atc.registry.profile.tabs.aktivitaet': 'Aktivität',
  'atc.registry.profile.tabs.arbeit': 'Arbeit',
  'atc.registry.profile.tabs.prs': 'PRs',
  'atc.registry.profile.tabs.dokumente': 'Dokumente',
  'atc.registry.profile.kv.shorthandle': 'Shorthandle',
  'atc.registry.profile.kv.agentId': 'agent_id',
  'atc.registry.profile.kv.repo': 'Repo',
  'atc.registry.profile.kv.branch': 'Branch',
  'atc.registry.profile.kv.model': 'Model',
  'atc.registry.profile.kv.created': 'Erstellt',
  'atc.registry.profile.section.embodiments': 'Embodiments',
  'atc.registry.profile.section.work': 'Aktuelle Arbeit',
  'atc.registry.profile.section.timeline': 'Letzte Aktivität',
  'atc.registry.profile.work.empty': 'Keine aktive Arbeit',
  'atc.registry.taskStatus.aktiv': 'AKTIV',
  'atc.registry.taskStatus.review': 'REVIEW',
  'atc.registry.taskStatus.blockiert': 'BLOCKIERT',
  'atc.registry.actions.chat': 'Chat',
  'atc.registry.actions.logs': 'Logs',
  'atc.registry.actions.kill': 'Kill',
  'atc.registry.actions.killConfirm': 'Agent {{handle}} beenden? Dies stoppt jede aktive Embodiment-Session.',
  'atc.registry.actions.killEmbodimentConfirm': 'Embodiment {{handle}} beenden?',
  'atc.registry.empty.notProjected': 'Noch nicht projiziert — wartet auf SL {{fr}}',
  'atc.registry.profile.signals.loadError': 'Signale konnten nicht geladen werden',
  'atc.registry.profile.work.loadError': 'Arbeitsliste konnte nicht geladen werden',
  'atc.registry.profile.prs.loadError': 'PRs konnten nicht geladen werden',
  'atc.registry.profile.docs.loadError': 'Dokumente konnten nicht geladen werden',
  'atc.registry.profile.loadError.desc': 'Fehler beim Laden — bitte erneut versuchen.',
  'atc.registry.detailV2.section.identityStack': 'Identity Stack',
  'atc.registry.detailV2.section.persona': 'Persona',
  'atc.registry.detailV2.section.embodiments': 'Embodiments',
  'atc.registry.detailV2.section.flightRights': 'Flight Rights',
  'atc.registry.detailV2.section.pearlChain': 'Pearl Chain',
  'atc.registry.detailV2.pearlChain.title': 'Titel',
  'atc.registry.detailV2.pearlChain.type': 'Typ',
  'atc.registry.detailV2.pearlChain.lifecycle': 'Lifecycle',
  'atc.registry.detailV2.pearlChain.priority': 'Priorität',
  'atc.registry.detailV2.pearlChain.emptyTitle': 'Keine Pearl-Chain-Einträge',
  'atc.registry.detailV2.pearlChain.emptyDesc': 'Keine Manifest-Einträge sind dieser Persona zugewiesen.',
  'atc.registry.detailV2.section.signals': 'Recent Signals',
  'atc.registry.detailV2.identity.systemPrompt': 'System Prompt',
  'atc.registry.detailV2.identity.bootstrap': 'Bootstrap',
  'atc.registry.detailV2.identity.workingDoc': 'Working Doc',
  'atc.registry.detailV2.identity.compositionPlaceholder': 'composition (1 doc · 0 snippets)',
  'atc.registry.detailV2.identity.emptyTitle': 'Identity Stack nicht registriert',
  'atc.registry.detailV2.identity.emptyDesc':
    'Kein System Prompt / Bootstrap / Working Doc für diese Persona registriert. Anfrage an god-mode stellen.',
  'atc.registry.detailV2.persona.notFound': 'Persona-Zeile in /v1/agents nicht gefunden',
  'atc.registry.detailV2.embodiments.spawn': 'Neues Embodiment spawnen',
  'atc.registry.detailV2.embodiments.spawnSubmit': 'Spawn',
  'atc.registry.detailV2.embodiments.initialMessage': 'Initiale Nachricht (optional)',
  'atc.registry.detailV2.embodiments.shorthandle': 'shorthandle',
  'atc.registry.detailV2.embodiments.vendor': 'vendor',
  'atc.registry.detailV2.embodiments.machine': 'machine',
  'atc.registry.detailV2.embodiments.startedAt': 'started_at',
  'atc.registry.detailV2.embodiments.endedAt': 'ended_at',
  'atc.registry.detailV2.embodiments.lastSeenAt': 'last_seen_at',
  'atc.registry.detailV2.embodiments.branch': 'branch',
  'atc.registry.detailV2.embodiments.model': 'model',
  'atc.registry.detailV2.embodiments.ctxPct': 'ctx %',
  'atc.registry.detailV2.embodiments.lastActivity': 'last activity',
  'atc.registry.detailV2.embodiments.actions': 'Aktionen',
  'atc.registry.detailV2.embodiments.kill': 'Kill',
  'atc.registry.detailV2.embodiments.restart': 'Restart',
  'atc.registry.detailV2.embodiments.empty': 'Keine Embodiments für diese Persona gefunden.',
  'atc.registry.detailV2.embodiments.live': 'Live',
  'atc.registry.detailV2.embodiments.retired': 'Beendet',
  'atc.registry.detailV2.flightRights.identitiesPrefix': 'Agent-Identitäten — für Human-User-Identity →',
  'atc.registry.detailV2.pendingEndpoint': 'SL-Endpoint ausstehend — FR-RG2',
  'atc.registry.detailV2.signals.expand': 'Recent Signals anzeigen (letzte 20)',
  'atc.registry.detailV2.signals.empty': 'Keine Signals verfügbar.',

  // Registry detail (/atc/bridge/agents/registry/:agentId)
  'atc.registry.detail.back': 'Zurück',
  'atc.registry.detail.fallbackTitle': 'Registry-Detail',
  'atc.registry.detail.unavailableTitle': 'Registry nicht verfügbar',
  'atc.registry.detail.payloadInvalid': 'Die Registry-Antwort entspricht nicht der erwarteten Form.',
  'atc.registry.detail.personaNotFoundTitle': 'Persona nicht gefunden',
  'atc.registry.detail.emptyValue': '—',
  'atc.registry.detail.section.persona': 'Persona',
  'atc.registry.detail.section.embodiments': 'Embodiments',
  'atc.registry.detail.section.daemon': 'Daemon-Status',
  'atc.registry.detail.section.replies': 'Signals — Antworten',
  'atc.registry.detail.section.narration': 'Signals — Narration',
  'atc.registry.detail.section.decisions': 'Signals — Entscheidungen',
  'atc.registry.detail.section.escalations': 'Signals — Eskalationen',
  'atc.registry.detail.section.pinnedDocs': 'Angepinnte Docs',
  'atc.registry.detail.section.auditLog': 'Audit-Log',
  'atc.registry.detail.section.serviceAccounts': 'Service-Accounts',
  'atc.registry.detail.field.agent_id': 'agent_id',
  'atc.registry.detail.field.shorthandle': 'shorthandle',
  'atc.registry.detail.field.display_name': 'display_name',
  'atc.registry.detail.field.vendor': 'vendor',
  'atc.registry.detail.field.repo': 'repo',
  'atc.registry.detail.field.status': 'status',
  'atc.registry.detail.status.alive': 'alive',
  'atc.registry.detail.status.dead': 'dead',
  'atc.registry.detail.field.embodiment_id': 'embodiment_id',
  'atc.registry.detail.field.session_id': 'session_id',
  'atc.registry.detail.field.location': 'location',
  'atc.registry.detail.field.machine': 'machine',
  'atc.registry.detail.field.started_at': 'started_at',
  'atc.registry.detail.field.last_activity_at': 'last_activity_at',
  'atc.registry.detail.field.branch': 'branch',
  'atc.registry.detail.field.model': 'model',
  'atc.registry.detail.field.turns': 'turns',
  'atc.registry.detail.field.replies': 'replies',
  'atc.registry.detail.field.ctx_pct': 'ctx_pct',
  'atc.registry.detail.field.current_task_ref': 'current_task_ref',
  'atc.registry.detail.field.source': 'source',
  'atc.registry.detail.copy': 'In die Zwischenablage kopieren',
  'atc.registry.detail.copied': 'Kopiert',
  'atc.registry.detail.embodimentsEmpty': 'Keine live Embodiments für diese Persona.',
  'atc.registry.detail.daemonNoRow': 'Keine Daemon-Zeile für diese Persona',
  'atc.registry.detail.daemonNoRowDesc': 'Die lokale Daemon-Status-Tabelle enthält keine passende Zeile.',
  'atc.registry.detail.daemonBranch': 'branch',
  'atc.registry.detail.daemonContext': 'context_pct',
  'atc.registry.detail.daemonPushAge': 'push_age_min',
  'atc.registry.detail.daemonCi': 'ci_status',
  'atc.registry.detail.daemonHeartbeat': 'Heartbeat (daemon updated_at)',
  'atc.registry.detail.repliesEmpty': 'Keine Reply-Signale für diesen Filter.',
  'atc.registry.detail.narrationEmpty': 'Keine Narration-Stream-Einträge für diese Persona.',
  'atc.registry.detail.decisionsEmpty': 'Keine Decision-Signale für diese Persona.',
  'atc.registry.detail.escalationsEmpty': 'Keine Escalation-Signale für diese Persona.',
  'atc.registry.detail.decisionExpiry': 'expiry',
  'atc.registry.detail.openDoc': 'Verknüpftes Dokument öffnen',
  'atc.registry.detail.pinnedDocs.empty': 'Keine Governance-Dokumente mit diesem Agenten in frontmatter.consumers.',
  'atc.registry.detail.pinnedDocs.unpin': 'Lösen',
  'atc.registry.detail.pinnedDocs.unpinFailedTitle': 'Lösen fehlgeschlagen',
  'atc.registry.detail.escalationResolved': 'Gelöst',
  'atc.registry.detail.escalationOpen': 'Offen',
  'atc.registry.detail.placeholder.pinnedDocs':
    'Legacy-Hinweis — angepinnte Docs laden live via GET /v1/agents/:id/docs (FR-A).',
  'atc.registry.detail.placeholder.auditLog':
    'Benötigt SL FR-B — GET /v1/agents/:id/audit liefert [{actor, action, target_field, before, after, at}] aus neuer append-only-Tabelle agent_audit_log. Nachverfolgt in MO v9 §FR-B (P2).',
  'atc.registry.detail.placeholder.serviceAccounts':
    'Verwaltung in der Service-Accounts-Konsole (separater Track). Laut Commander 2026-05-03: „flight rights kommt später, wir machen service accounts.“',

  // Tabs
  'atc.bridge.tabs.manifest': 'Manifest',
  'atc.bridge.tabs.highlights': 'Highlights',
  'atc.bridge.tabs.health': 'Health',
  'atc.bridge.tabs.prs': 'PRs',
  'atc.bridge.tabs.staging': 'Staging',
  'atc.bridge.tabs.escalations': 'Eskalationen',
  'atc.bridge.tabs.triggers': 'Trigger',
  'atc.bridge.tabs.registry': 'Registry',
  'atc.bridge.tabs.heartbeat': 'Heartbeat',
  'atc.bridge.tabs.chat': 'Chat',
  'atc.bridge.tabs.wiki': 'Wiki',

  // Bridge IA v2 shell (grouped nav + Wiki)
  'atc.bridge.groups.operations': 'Operations',
  'atc.bridge.groups.repos': 'Repos',
  'atc.bridge.groups.agents': 'Agents',
  'atc.bridge.groups.wiki': 'Wiki',
  'atc.bridge.groupsNav.ariaLabel': 'Bridge-Bereiche',
  'atc.bridge.subNav.ariaLabel': 'Bridge-Abschnitt',
  'atc.bridge.subNav.label': 'Abschnitt',

  // Workright grant / revoke / scope-request — FR-FE-AGENT-CONSOLE-V1 Wave 2,
  // SL ticket §2.G2. Per-error_code keys mirror the typed enums in
  // useGrantWorkright/useRevokeWorkright/useRequestScope.
  'atc.bridge.workright.grant.title': 'Workright erteilen',
  'atc.bridge.workright.grant.description':
    'Scope-Globs für eine Agent-Embodiment freischalten. Validierung und Persistenz erfolgen in Server Logic.',
  'atc.bridge.workright.grant.submit': 'Grant',
  'atc.bridge.workright.grant.cancel': 'Abbrechen',
  'atc.bridge.workright.grant.successToast': 'Workright erteilt.',
  'atc.bridge.workright.grant.field.agent_id': 'Agent-ID',
  'atc.bridge.workright.grant.field.embodiment_id': 'Embodiment-ID (optional)',
  'atc.bridge.workright.grant.field.manifest_entry_id': 'Manifest-Eintrag (optional)',
  'atc.bridge.workright.grant.field.scope_globs': 'Scope-Globs (kommagetrennt oder pro Zeile)',
  'atc.bridge.workright.grant.field.expires_at': 'Läuft ab am',
  'atc.bridge.workright.grant.field.permanent_auto_renew': 'Permanent, automatisch verlängern',
  'atc.bridge.workright.grant.field.granted_reason': 'Begründung',
  'atc.bridge.workright.grant.field.verify_token': 'Verify-Token (optional)',
  // Grant error_code enum (11 codes) — SL §2.G2 §2.2 grant.
  'atc.bridge.workright.error.WORKRIGHT_NOT_FOUND': 'Workright nicht gefunden.',
  'atc.bridge.workright.error.WORKRIGHT_REVOKED': 'Workright bereits widerrufen.',
  'atc.bridge.workright.error.WORKRIGHT_EXPIRED': 'Workright abgelaufen.',
  'atc.bridge.workright.error.EMBODIMENT_NOT_FOUND': 'Embodiment nicht gefunden.',
  'atc.bridge.workright.error.EMBODIMENT_NOT_ACTIVE': 'Embodiment ist nicht aktiv.',
  'atc.bridge.workright.error.ALREADY_ASSIGNED': 'Scope ist bereits zugewiesen.',
  'atc.bridge.workright.error.VERIFY_MISMATCH': 'Verify-Token stimmt nicht überein.',
  'atc.bridge.workright.error.GRANT_WRITE_FAILED':
    'Verify-after-write fehlgeschlagen — der Grant wurde nicht persistiert.',
  'atc.bridge.workright.error.FORBIDDEN': 'Nicht erlaubt.',
  'atc.bridge.workright.error.MANIFEST_ENTRY_NOT_FOUND': 'Manifest-Eintrag nicht gefunden.',
  'atc.bridge.workright.error.INVALID_SCOPE_FORMAT': 'Ungültiges Scope-Glob-Format.',
  // Scope-request error_code enum (6 codes) — SL §2.G2 §2.2 scope-request.
  'atc.bridge.workright.error.INVALID_TARGET_FORMAT': 'Ungültiges Ziel-Format.',
  'atc.bridge.workright.error.RATE_LIMIT_EXCEEDED': 'Rate-Limit erreicht — bitte später erneut versuchen.',
  'atc.bridge.workright.error.SCOPE_REJECTED': 'Scope wurde abgelehnt.',
  'atc.bridge.workright.error.INTERNAL': 'Interner Fehler — bitte erneut versuchen.',

  // Doc search page (/atc/docs)
  'atc.docs.title': 'Doc-Suche',
  'atc.docs.reset': 'Zurücksetzen',
  'atc.docs.uuidDetected': 'UUID erkannt — direkter Lookup läuft parallel zur Volltextsuche.',
  'atc.docs.col.changed': 'Geändert',
  'atc.docs.openInDocStore': 'Im Doc-Store öffnen',
  'atc.wiki.sidebar.sections.types': 'Dok-Typen',
  'atc.wiki.sidebar.sections.repos': 'Repos',
  'atc.wiki.sidebar.searchPlaceholder': 'Titel oder UUID suchen…',
  'atc.wiki.sidebar.searchAria': 'Suchbegriff',
  'atc.wiki.sidebar.mobile.typeAria': 'Typ-Filter',
  'atc.wiki.sidebar.mobile.repoAria': 'Repo-Filter',
  'atc.wiki.sidebar.mobile.typePlaceholder': 'Typ',
  'atc.wiki.sidebar.mobile.repoPlaceholder': 'Repo',
  'atc.wiki.sidebar.mobile.allTypes': 'Alle Typen',
  'atc.wiki.sidebar.mobile.allRepos': 'Alle Repos',
  'atc.wiki.sidebar.transitionalHint':
    'Bucket-Browse ist bis SL FR-WK1/2/3 nur transitional. Counts sind als (?) Platzhalter dargestellt, Ergebnisse laufen uber Search-Fallback.',
  'atc.wiki.sidebar.emptyFiltered': 'Keine Dokumente fur die gewahlten Bucket-Filter gefunden',
  'atc.wiki.sidebar.emptyFilteredDesc':
    'Suche verfeinern oder Typ-/Repo-Filter anpassen.',
  'atc.wiki.sidebar.types.dogma': 'Dogmas',
  'atc.wiki.sidebar.types.systemPrompt': 'System Prompts',
  'atc.wiki.sidebar.types.bootstrap': 'Bootstraps',
  'atc.wiki.sidebar.types.workingDoc': 'Working Docs',
  'atc.wiki.sidebar.types.skill': 'Skills',
  'atc.wiki.sidebar.types.adr': 'ADRs',
  'atc.wiki.sidebar.types.mo': 'MOs',
  'atc.wiki.sidebar.types.sortie': 'Sorties',
  'atc.wiki.sidebar.types.fr': 'FRs',
  'atc.wiki.sidebar.types.libraryCard': 'Library Cards',
  'atc.wiki.sidebar.types.audit': 'Audits',
  'atc.wiki.sidebar.types.runbook': 'Runbooks',
  'atc.wiki.sidebar.types.assessment': 'Assessments',
  'atc.wiki.sidebar.types.governance': 'Governance',
  'atc.wiki.sidebar.types.other': 'Other',
  'atc.wiki.filters.status': 'Status',
  'atc.wiki.filters.repo': 'Repo',
  'atc.wiki.filters.tag': 'Tag',
  'atc.wiki.filters.searchChip': 'Titel',
  'atc.wiki.filters.allTags': 'Alle Tags',
  'atc.wiki.table.col.document': 'Dokument',
  'atc.wiki.table.col.updated': 'Aktualisiert',
  'atc.wiki.table.sortAria': 'Sortierung umschalten',

  // Doc detail page (/atc/docs/:id) — full-width reader.
  'atc.docs.detail.back': 'Zurück zur Suche',
  'atc.docs.detail.frontmatter': 'Frontmatter',
  'atc.docs.detail.body': 'Inhalt',
  'atc.docs.detail.notFound': 'Dokument nicht gefunden',
  'atc.docs.detail.notFoundDesc': 'Die UUID liefert keine Zeile aus dem Doc-Store. Möglicherweise wurde das Dokument zurückgezogen oder die ID ist falsch.',
  'atc.docs.detail.emptyBody': 'Dieses Dokument hat keinen Body — nur Frontmatter.',
  'atc.docs.detail.invalidId': 'Die ID ist keine gültige UUID.',
  'atc.docs.edit.action': 'Bearbeiten',
  'atc.docs.edit.actionAria': 'Dokument-Body bearbeiten',
  'atc.docs.edit.editorAria': 'Dokument-Body (Markdown)',
  'atc.docs.edit.placeholder': 'Markdown-Text…',
  'atc.docs.edit.save': 'Speichern',
  'atc.docs.edit.saving': 'Wird gespeichert…',
  'atc.docs.edit.cancel': 'Abbrechen',
  'atc.docs.edit.successToast': 'Dokument gespeichert',
  'atc.docs.edit.error': 'Speichern fehlgeschlagen — das Dokument wurde nicht geändert.',
  'atc.wiki.docNotFoundDetail': 'Dokument mit der ID "{{id}}" nicht gefunden. Es wurde möglicherweise gelöscht oder verschoben.',
  'atc.bridge.notFound.title': 'Seite nicht gefunden',
  'atc.bridge.notFound.desc': 'Diese Bridge-Route existiert nicht. Wähle oben einen Tab oder kehre zum Manifest zurück.',
  'atc.bridge.notFound.action': 'Zum Manifest',

  // Wiki-Namespace-Auswahl (atc | clanda). Der namespaceübergreifende
  // Doc-Zugriff ist eine SL-Abhängigkeit — siehe
  // BUG-FE-BRIDGE-WIKI-NAMESPACE-LIMITED. Die clanda-Option zeigt einen
  // expliziten Hinweis "noch nicht verfügbar" statt stillschweigend
  // atc-Daten auszuliefern (D-33 R1: keine stillen Fehler).
  'atc.wiki.namespace.label': 'Namespace',
  'atc.wiki.namespace.atc': 'ATC (Plattform)',
  'atc.wiki.namespace.clanda': 'CLANDA (Mandant)',
  'atc.wiki.namespace.aria': 'Doc-Store-Namespace',
  'atc.wiki.namespace.pendingTitle': 'CLANDA-Namespace noch nicht erreichbar',
  'atc.wiki.namespace.pendingDesc':
    'Der CLANDA-Doc-Store ist ein eigenes Supabase-Projekt. Der Service Layer stellt für das Wiki noch keinen namespace-geroutet Lesepfad bereit — heute ist nur der ATC-Namespace erreichbar.',
  'atc.wiki.searchFailed': 'Suche fehlgeschlagen:',
  'atc.wiki.noResults': 'Keine Ergebnisse für „{{query}}“',
  'atc.wiki.noResultsDesc': 'Andere Suchbegriffe verwenden oder Filter zurücksetzen.',
  'atc.wiki.noResultsUuidDesc':
    'Weder Volltextsuche noch direkter UUID-Lookup haben einen Treffer geliefert. Falls die UUID stimmt, hat SL den direkten Lookup-Endpoint /v1/commander/docs/{id} möglicherweise noch nicht ausgerollt.',
  'atc.wiki.searchHint': 'Suchbegriff eingeben, um die Doc-Store zu durchsuchen. UUIDs werden direkt nachgeschlagen.',
  'atc.wiki.browse.title': 'Doc-Store durchstöbern',
  'atc.wiki.browse.description': 'Dokumenttyp zum Durchstöbern auswählen oder oben suchen.',
  'atc.wiki.browse.countsUnavailable': 'Dokumentanzahlen vorübergehend nicht verfügbar — Durchstöbern nach Typ ist weiterhin möglich.',

  // Doc stamp + frontmatter-edit UI (Wave 1, SL G1 pending — mock-backed).
  'atc.docs.stamp.action': 'Stempeln',
  'atc.docs.stamp.actionAria': 'Dokument stempeln',
  'atc.docs.stamp.confirmTitle': 'Dokument stempeln',
  'atc.docs.stamp.confirmBody': 'Status nach „active" setzen? Die Operation ist auditierbar und wird nach Schreibvorgang verifiziert.',
  'atc.docs.stamp.submit': 'Stempeln',
  'atc.docs.stamp.cancel': 'Abbrechen',
  'atc.docs.stamp.successToast': 'Dokument gestempelt — Status aktualisiert.',
  'atc.docs.stamp.error.DOC_NOT_FOUND': 'Dokument nicht gefunden.',
  'atc.docs.stamp.error.STAMP_FORBIDDEN': 'Stempeln nicht erlaubt — fehlendes Workright.',
  'atc.docs.stamp.error.STAMP_INVALID_STATE_TRANSITION': 'Ungültiger Status-Übergang.',
  'atc.docs.stamp.error.FRONTMATTER_PATCH_INVALID': 'Frontmatter-Patch ungültig.',
  'atc.docs.stamp.error.FRONTMATTER_FIELD_LOCKED': 'Frontmatter-Feld gesperrt — Schreibrecht fehlt.',
  'atc.docs.stamp.error.VERIFY_AFTER_WRITE_MISMATCH': 'Verify-After-Write fehlgeschlagen — bitte erneut versuchen.',
  'atc.docs.stamp.error.UNAUTHORIZED': 'Nicht autorisiert.',
  'atc.docs.stamp.error.INTERNAL': 'Interner Fehler — bitte später erneut versuchen.',

  // Agent chat room (decide / escalate v1)
  'atc.agentRoom.header.backAria': 'Zurück zur Agentenliste',
  'atc.agentRoom.header.menuAria': 'Weitere Aktionen',
  'atc.agentRoom.header.refresh': 'Aktualisieren',
  'atc.agentRoom.header.restart': 'Neustart',
  'atc.agentRoom.header.restarting': 'Startet neu…',
  'atc.agentRoom.header.spawn': 'Spawn',
  'atc.agentRoom.header.spawnAria': '{{agent}} spawnen',
  'atc.agentRoom.header.spawnBlockedTitle': '{{agent}} hat bereits eine Live-Embodiment — zum Sync aktualisieren',
  'atc.agentRoom.header.kill': 'Beenden',
  'atc.agentRoom.header.killAria': '{{agent}} beenden',
  'atc.agentRoom.header.maximize': 'Maximieren',
  'atc.agentRoom.header.collapse': 'Verkleinern',
  'atc.agentRoom.tabs.stream': 'Stream',
  'atc.agentRoom.tabs.conversation': 'Konversation',
  'atc.agentRoom.tabs.docs': 'Docs',
  'atc.agentRoom.tabs.decisions': 'Entscheidungen',
  'atc.agentRoom.tabs.narration': 'Narration',
  'atc.agentRoom.tabs.escalations': 'Eskalationen',
  'atc.agentRoom.docs.blurb': 'Commander Bridge öffnen, um Governance-Dokumente und Manifest-Einträge zu durchsuchen.',
  'atc.agentRoom.docs.openBridge': 'Commander Bridge öffnen',
  'atc.agentRoom.docs.accessUnavailableTitle': 'Zugriff auf den Dokumentenspeicher ist nicht verfügbar',
  'atc.agentRoom.docs.accessUnavailableDesc': 'Deine Rolle erlaubt keinen Zugriff auf Governance-Dokumente.',
  'atc.agentRoom.docs.searchFailedTitle': 'Dokumentensuche fehlgeschlagen',
  'atc.agentRoom.docs.unknownError': 'Unbekannter Fehler',
  'atc.agentRoom.docs.noDocsForAgentTitle': 'Keine Dokumente für {{agentId}} gefunden',
  'atc.agentRoom.docs.noDocsForAgentDesc':
    'Der Agent-Docs-Endpunkt lieferte keine Zeilen — die Persona hat möglicherweise noch keine consumer-verknüpften Docs.',
  'atc.agentRoom.docs.payloadInvalidTitle': 'Ungültige Payload-Form',
  'atc.agentRoom.docs.payloadInvalidDesc':
    'Der Dienst lieferte eine Dokumentenliste, die der Client nicht parsen konnte. Es wird nichts angezeigt, bis die Payload dem Vertrag entspricht.',
  'atc.agentRoom.docs.swipeHint': 'Horizontal wischen, um alle Dokumentspalten zu sehen.',
  'atc.agentRoom.docs.table.title': 'Titel',
  'atc.agentRoom.docs.table.type': 'Typ',
  'atc.agentRoom.docs.table.status': 'Status',
  'atc.agentRoom.docs.table.version': 'Version',
  'atc.agentRoom.docs.table.updated': 'Aktualisiert',
  'atc.agentRoom.docs.table.id': 'ID',
  'atc.agentRoom.docs.showingCount': '{{shown}} von {{total}} angezeigt',
  'atc.agentRoom.docs.loadMore': 'Mehr laden',
  'atc.agentRoom.docs.loadingMore': 'Lädt...',
  'atc.agentRoom.narration.placeholder': 'Für diesen Agenten ist noch kein Narration-Feed angebunden.',
  'atc.agentRoom.decisions.alternativesToggle': 'Geprüfte Alternativen',
  'atc.agentRoom.decisions.supersedesChip': 'Ersetzt',
  'atc.agentRoom.decisions.docChip': 'Verknüpftes Dokument',
  'atc.agentRoom.decisions.loadErrorTitle': 'Entscheidungen konnten nicht geladen werden',
  'atc.agentRoom.decisions.loadErrorDesc': 'Beim Abruf der Decision-Signals ist ein Fehler aufgetreten.',
  'atc.agentRoom.decisions.payloadInvalidTitle': 'Ungültige Payload-Form',
  'atc.agentRoom.decisions.payloadInvalidDesc': 'Der Dienst lieferte Zeilen, die der Client nicht parsen konnte. Es wird nichts angezeigt, bis die Payload dem Vertrag entspricht.',
  'atc.agentRoom.decisions.tabActive': 'Aktiv',
  'atc.agentRoom.decisions.tabStale': 'Abgelaufen',
  'atc.agentRoom.decisions.emptyTitle': 'Keine aktiven Entscheidungen',
  'atc.agentRoom.decisions.emptyDesc': 'Sobald dieser Agent eine Entscheidung protokolliert, erscheint sie hier.',
  'atc.agentRoom.decisions.emptyStaleTitle': 'Keine abgelaufenen Entscheidungen',
  'atc.agentRoom.decisions.emptyStaleDesc': 'Entscheidungen nach Ablauf des Ablaufdatums landen in dieser Liste.',
  'atc.agentRoom.decisions.columnDecision': 'Entscheidung',
  'atc.agentRoom.escalations.deadlinePassed': 'Frist vorbei',
  'atc.agentRoom.escalations.deadlineMinutes': 'noch {{minutes}} Min.',
  'atc.agentRoom.escalations.deadlineHours': 'noch {{hours}} Std.',
  'atc.agentRoom.escalations.resolvedLabel': 'Gelöst',
  'atc.agentRoom.escalations.notifyTitle': 'Eskalations-Update',
  'atc.agentRoom.escalations.loadErrorTitle': 'Eskalationen konnten nicht geladen werden',
  'atc.agentRoom.escalations.loadErrorDesc': 'Beim Abruf der Escalation-Signals ist ein Fehler aufgetreten.',
  'atc.agentRoom.escalations.payloadInvalidTitle': 'Ungültige Payload-Form',
  'atc.agentRoom.escalations.payloadInvalidDesc': 'Der Dienst lieferte Zeilen, die der Client nicht parsen konnte. Es wird nichts angezeigt, bis die Payload dem Vertrag entspricht.',
  'atc.agentRoom.escalations.emptyTitle': 'Keine Eskalationen',
  'atc.agentRoom.escalations.emptyDesc': 'Wenn dieser Agent einen Blocker eskaliert, erscheint er hier mit Antwortoptionen.',
  'atc.agentRoom.escalations.columnEscalation': 'Eskalation',
  'atc.agentRoom.escalations.rateLimitTitle': 'Rate-Limit erreicht',
  'atc.agentRoom.escalations.rateLimitDesc': 'Zu viele Antworten in kurzer Zeit. Bitte kurz warten und erneut versuchen.',
  'atc.chat.list.errorTitle': 'Agenten konnten nicht geladen werden',
  'atc.chat.list.errorRetry': 'Erneut versuchen',
  'atc.chat.list.emptyTitle': 'Keine Agenten',
  'atc.chat.list.emptyDesc': 'Es sind derzeit keine Agenten verfügbar.',
  'atc.chat.groupHeader.repoUnknown': 'Ohne Repo',
  'atc.chat.viewToggle.repo': 'Repo',
  'atc.chat.viewToggle.flat': 'Flach',
  'atc.chat.persona.expandEmbodiments': 'Embodiments aufklappen',
  'atc.chat.persona.idle': 'inaktiv',
  'atc.chat.persona.machineUnknown': 'unbekannt',
  'atc.chat.identity.personaUnknown': 'Unbekannte Persona',
  'atc.chat.identity.embodimentAria': 'Embodiment-Kennung (Kurzform)',
  'atc.chat.target.expandedAddressing.title': 'Detailliertes Addressing',
  'atc.chat.target.label': 'Ziel:',
  'atc.chat.target.headerAria': 'Adressiertes Embodiment',
  'atc.chat.target.switchAria': 'Embodiment zum Adressieren wählen',
  'atc.chat.target.selectLabel': 'Ziel-Embodiment wählen',
  'atc.chat.target.noLive': 'Keine Live-Embodiment',
  'atc.chat.target.allLabel': 'Alle · {{count}} live',
  'atc.chat.target.presence.live': 'live',
  'atc.chat.target.presence.idle': 'idle',
  'atc.chat.message.you': 'Du',
  'atc.chat.list.liveSection': 'Live',
  'atc.chat.list.offlineSection': 'Offline',
  'atc.chat.action.beenden': 'Beenden',
  'atc.chat.action.aktualisieren': 'Aktualisieren',
  'atc.chat.action.neustart': 'Neustart',
  'atc.chat.action.openInRegistry': 'In Registry öffnen',
  'atc.chat.kbd.beenden': 'Esc',
  'atc.chat.kbd.aktualisieren': 'R',
  'atc.chat.kbd.neustart': 'Shift+R',
  'atc.decisions.title': 'Wartende Entscheidungen',
  'atc.decisions.empty': 'Keine wartenden Entscheidungen',
  'atc.decisions.error': 'Fehler beim Laden der Entscheidungen',
  'atc.decisions.action.approve': 'Genehmigen',
  'atc.decisions.action.reject': 'Ablehnen',
  'atc.decisions.action.amend': 'Ändern',
  'atc.decisions.amendmentLabel': 'Änderungstext (erforderlich)',
  'atc.decisions.rejectReasonLabel': 'Grund (optional)',
  'atc.decisions.alternatives': 'Geprüfte Alternativen',
  'atc.decisions.rollbackPlan': 'Rollback-Plan',
  'atc.decisions.doorType.twoWay': 'Reversibel',
  'atc.decisions.doorType.oneWay': 'Irreversibel',
  'atc.decisions.blastRadius.agentOnly': 'Nur Agent',
  'atc.decisions.blastRadius.consumerRepo': 'Consumer-Repo',
  'atc.decisions.blastRadius.fleet': 'Fleet',
  'atc.decisions.blastRadius.ratificationLine': 'Ratification Line',
  'atc.decisions.toast.ratified': 'Entscheidung ratifiziert',
  'atc.decisions.toast.rejected': 'Entscheidung abgelehnt',
  'atc.decisions.toast.amended': 'Änderung erfasst',
  'atc.decisions.toast.error': 'Ratifikation konnte nicht gespeichert werden — bitte erneut versuchen',
  'atc.narration.kind.decision': 'Entscheidung',
  'atc.narration.kind.escalation': 'Eskalation',

  // Manifest view
  'atc.bridge.manifest.empty': 'Kein Manifest vorhanden',
  'atc.bridge.manifest.emptyDesc': 'Es gibt aktuell keine Einträge im Execution Manifest.',
  // Manifest Backlog page (Wave 6d, G7 §2.G7)
  'atc.bridge.manifest.page.title': 'Manifest-Backlog',
  'atc.bridge.manifest.page.subtitle': 'Operator-Backlog für das Manifest. Priorität, Lifecycle, Closeout-Profil, Parent-Referenz, Fälligkeit und Notizen pro Eintrag bearbeiten.',
  'atc.bridge.manifest.col.id': 'ID',
  'atc.bridge.manifest.col.title': 'Titel',
  'atc.bridge.manifest.col.persona': 'Persona',
  'atc.bridge.manifest.col.lifecycle': 'Lifecycle',
  'atc.bridge.manifest.col.closeoutProfile': 'Closeout',
  'atc.bridge.manifest.col.priority': 'Priorität',
  'atc.bridge.manifest.col.parent': 'Parent',
  'atc.bridge.manifest.col.dueAt': 'Fällig',
  'atc.bridge.manifest.col.notes': 'Notizen',
  'atc.bridge.manifest.col.actions': 'Aktionen',
  'atc.bridge.manifest.view.toggleLabel': 'Ansicht wechseln',
  'atc.bridge.manifest.view.list': 'Liste',
  'atc.bridge.manifest.view.kanban': 'Kanban',
  'atc.bridge.manifest.kanban.boardLabel': 'Manifest-Kanban nach Lifecycle-Knoten',
  'atc.bridge.manifest.kanban.otherColumn': 'Sonstige',
  'atc.bridge.manifest.kanban.emptyColumn': 'Keine Einträge',
  'atc.bridge.manifest.action.edit': 'Bearbeiten',
  'atc.bridge.manifest.action.hold': 'Anhalten',
  'atc.bridge.manifest.action.redispatch': 'Neu zuteilen',
  'atc.bridge.manifest.action.forceClose': 'Force Close',
  'atc.bridge.manifest.action.forceCloseConfirm': 'Diesen Manifest-Eintrag wirklich force-closen? Dies erzwingt einen Lifecycle-Übergang und kann nicht rückgängig gemacht werden.',
  'atc.bridge.manifest.action.holdReasonPrompt': 'Grund für das Anhalten dieses Manifest-Eintrags:',
  'atc.bridge.manifest.action.create': '+ Neuer Eintrag',
  'atc.bridge.manifest.action.delete': 'Löschen',
  'atc.bridge.manifest.field.priority': 'Priorität (Ganzzahl)',
  'atc.bridge.manifest.field.lifecycle': 'Lifecycle-Knoten',
  'atc.bridge.manifest.field.closeoutProfile': 'Closeout-Profil',
  'atc.bridge.manifest.field.parent': 'Parent-Manifest-Referenz',
  'atc.bridge.manifest.field.dueAt': 'Fälligkeit',
  'atc.bridge.manifest.field.notes': 'Notizen',
  'atc.bridge.manifest.editModal.title': 'Manifest-Eintrag bearbeiten',
  'atc.bridge.manifest.editModal.description': 'Den gewählten Backlog-Eintrag patchen. Leere Felder löschen den Wert; unveränderte Felder werden nicht gesendet.',
  'atc.bridge.manifest.editModal.save': 'Änderungen speichern',
  'atc.bridge.manifest.editModal.saving': 'Speichere...',
  // Create modal (FR-FE-BRIDGE-FULL-CRUD)
  'atc.bridge.manifest.field.id': 'Eintrags-ID',
  'atc.bridge.manifest.field.title': 'Titel',
  'atc.bridge.manifest.field.entityType': 'Entitätstyp',
  'atc.bridge.manifest.field.priorityBucket': 'Prioritäts-Bucket',
  'atc.bridge.manifest.field.assignee': 'Assignee',
  'atc.bridge.manifest.field.executionMode': 'Ausführungsmodus',
  'atc.bridge.manifest.field.repo': 'Repo',
  'atc.bridge.manifest.createModal.title': 'Neuer Manifest-Eintrag',
  'atc.bridge.manifest.createModal.description': 'Neuen Work-Item ins Execution-Manifest einfügen. Pflicht: Eintrags-ID, Entitätstyp, Titel. Andere Felder werden serverseitig befüllt, wenn leer.',
  'atc.bridge.manifest.createModal.save': 'Eintrag anlegen',
  'atc.bridge.manifest.createModal.saving': 'Wird angelegt...',
  'atc.bridge.manifest.createModal.parentPlaceholder': 'Optionale Parent-ID (leer = Root-Eintrag)',
  // Delete dialog (FR-FE-BRIDGE-FULL-CRUD)
  'atc.bridge.manifest.deleteDialog.title': 'Manifest-Eintrag löschen',
  'atc.bridge.manifest.deleteDialog.confirm': 'Diesen Manifest-Eintrag dauerhaft löschen?',
  'atc.bridge.manifest.deleteDialog.confirmFor': '"{title}" dauerhaft löschen?',
  'atc.bridge.manifest.deleteDialog.confirmButton': 'Löschen',
  'atc.bridge.manifest.deleteDialog.cascadeWarn': 'Dieser Eintrag hat {count} Nachfolger. Bestätigen führt zum Kaskaden-Löschen aller.',
  'atc.bridge.manifest.deleteDialog.cascadeWarnUnknown': 'Dieser Eintrag hat Nachfolger. Bestätigen führt zum Kaskaden-Löschen aller.',
  'atc.bridge.manifest.deleteDialog.cascadeConfirm': 'Kaskaden-Löschen',
  'atc.bridge.manifest.deleteDialog.deleting': 'Lösche...',
  'atc.bridge.manifest.error.NOT_FOUND': 'Manifest-Eintrag nicht gefunden. Möglicherweise bereits gelöscht.',
  'atc.bridge.manifest.error.MANIFEST_ENTRY_HAS_CHILDREN': 'Eintrag hat Nachfolger. Erneut bestätigen für Kaskaden-Löschen.',
  'atc.bridge.manifest.error.ATC_WRITE_FAILED': 'Server konnte den Schreibvorgang nicht ausführen. Bitte erneut versuchen.',
  'atc.bridge.manifest.error.PARENT_NOT_FOUND': 'Parent-ID existiert nicht. Bitte existierenden Eintrag wählen oder leer lassen für Root-Eintrag.',
  'atc.bridge.manifest.error.DUPLICATE_ID': 'Ein Eintrag mit dieser ID existiert bereits. Bitte andere ID wählen.',
  'atc.bridge.manifest.error.INVALID_PRIORITY': 'Priorität muss P0, P1, P2 oder P3 sein.',
  'atc.bridge.manifest.error.INVALID_ENTITY_TYPE': 'Entitätstyp ist nicht im zulässigen Bereich.',
  'atc.bridge.manifest.error.INVALID_LIFECYCLE_NODE': 'Lifecycle-Knoten ist nicht im zulässigen Bereich.',
  'atc.bridge.manifest.error.INVALID_EXECUTION_MODE': 'Ausführungsmodus muss cloud, local_daemon oder local_raw sein.',
  'atc.bridge.manifest.error.INVALID_CLOSURE_REASON': 'Closure Reason ist nicht im zulässigen Bereich.',
  'atc.bridge.manifest.error.INVALID_SESSION_PURPOSE': 'Session Purpose ist nicht im zulässigen Bereich.',
  'atc.bridge.manifest.error.INVALID_PHASE': 'Phase muss Ganzzahl 1..5 sein.',
  'atc.bridge.manifest.error.MANIFEST_ENTRY_CREATE_NO_ROW': 'Insert lieferte keine Zeile. Berechtigungen prüfen und erneut versuchen.',
  'atc.bridge.manifest.error.MANIFEST_NOT_FOUND': 'Manifest-Eintrag nicht gefunden. Möglicherweise geschlossen oder gelöscht.',
  'atc.bridge.manifest.error.EMPTY_PATCH': 'Keine Änderungen zum Speichern.',
  'atc.bridge.manifest.error.INVALID_LIFECYCLE_TRANSITION': 'Unzulässiger Lifecycle-Übergang für diesen Eintrag.',
  'atc.bridge.manifest.error.INVALID_PARENT_REFERENCE': 'Parent-Referenz ist ungültig oder bildet einen Zyklus.',
  'atc.bridge.manifest.error.PRIORITY_OUT_OF_RANGE': 'Prioritätswert liegt außerhalb des zulässigen Bereichs.',
  'atc.bridge.manifest.error.FORBIDDEN': 'Kein Workright zum Bearbeiten dieses Eintrags.',
  'atc.bridge.manifest.error.VERIFY_AFTER_WRITE_MISMATCH': 'Server hat Drift nach dem Schreiben erkannt. Bitte neu laden.',
  'atc.bridge.manifest.error.UNKNOWN': 'Aktualisierung fehlgeschlagen. Bitte erneut versuchen.',
  'atc.bridge.manifest.filters.entityType': 'Typ',
  'atc.bridge.manifest.filters.owner': 'Owner',
  'atc.bridge.manifest.filters.repo': 'Repo',
  'atc.bridge.manifest.filters.priority.aria': 'Nach Priorität filtern',
  'atc.bridge.manifest.filters.lifecycle.aria': 'Nach Lifecycle-Knoten filtern',
  'atc.bridge.manifest.filters.entityType.aria': 'Nach Entitätstyp filtern',
  'atc.bridge.manifest.filters.owner.aria': 'Nach Owner-Persona filtern',
  'atc.bridge.manifest.filters.repo.aria': 'Nach Repo filtern (Teilstring)',
  'atc.bridge.manifest.filters.blocked.aria': 'Nach Blockierungsstatus filtern',
  'atc.operations.column.id': 'ID',
  'atc.operations.column.title': 'Titel',
  'atc.operations.column.stage': 'Lifecycle-Stage',
  'atc.operations.column.assignee': 'Assignee',
  'atc.operations.column.priority': 'Priorität',
  'atc.operations.column.age': 'Alter',
  'atc.operations.column.blocked': 'Blockiert',
  'atc.operations.column.linkedPrs': '# Verknüpfte PRs',
  'atc.operations.column.lastUpdate': 'Letztes Update',
  'atc.operations.drawer.tab.uebersicht': 'Übersicht',
  'atc.operations.drawer.tab.aktivitaet': 'Aktivität',
  'atc.operations.drawer.tab.pearlChain': 'Pearl-Chain',
  'atc.operations.drawer.tab.linkedPrs': 'Linked PRs',
  'atc.operations.drawer.tab.dokumente': 'Dokumente',
  'atc.operations.drawer.action.assign': 'Zuweisen',
  'atc.operations.drawer.action.moveStage': 'Stage wechseln',
  'atc.operations.drawer.action.markBlocked': 'Blockiert markieren',
  'atc.operations.drawer.action.addComment': 'Kommentar hinzufügen',
  'atc.operations.drawer.action.openChat': 'Chat mit Assignee öffnen',
  'atc.operations.drawer.action.openInRepo': 'Im Repo öffnen',
  'atc.operations.drawer.action.kbd.assign': 'W',
  'atc.operations.drawer.action.kbd.moveStage': 'M',
  'atc.operations.drawer.action.kbd.markBlocked': 'B',
  'atc.operations.drawer.action.kbd.addComment': 'C',
  'atc.operations.drawer.action.kbd.openChat': 'J',
  'atc.operations.drawer.action.kbd.openInRepo': 'G',
  'atc.operations.shell.emptyTitle': 'Keine Operations gefunden',
  'atc.operations.shell.emptyDesc': 'Für die gewählte Filterkombination sind keine Operations verfügbar.',
  'atc.operations.empty.notProjected': 'Projektion ist noch nicht verfügbar ({fr}).',
  'atc.operations.drawer.overview.title': 'Titel',
  'atc.operations.drawer.overview.description': 'Beschreibung',
  'atc.operations.drawer.overview.stage': 'Lifecycle-Stage',
  'atc.operations.drawer.overview.assignee': 'Assignee',
  'atc.operations.drawer.overview.priority': 'Priorität',
  'atc.operations.drawer.overview.blocked': 'Blockiert',
  'atc.operations.drawer.overview.blockedReason': 'Blockiergrund',
  'atc.operations.drawer.overview.parentOp': 'Parent Op',
  'atc.operations.drawer.overview.parentSf': 'Parent SF',
  'atc.operations.drawer.overview.createdAt': 'Erstellt',
  'atc.operations.drawer.overview.updatedAt': 'Aktualisiert',
  'atc.operations.drawer.activity.timestamp': 'Zeitpunkt',
  'atc.operations.drawer.activity.actor': 'Akteur',
  'atc.operations.drawer.activity.type': 'Eventtyp',
  'atc.operations.drawer.activity.payload': 'Payload',
  'atc.operations.drawer.pearlChain.predecessor': 'Vorgänger',
  'atc.operations.drawer.pearlChain.successor': 'Nachfolger',
  'atc.operations.drawer.linkedPrs.branch': 'Branch -> Target',
  'atc.operations.drawer.linkedPrs.status': 'Status',
  'atc.operations.drawer.linkedPrs.age': 'Alter',
  'atc.operations.drawer.linkedPrs.ci': 'CI-Übersicht',
  'atc.operations.drawer.docs.type': 'Typ',
  'atc.operations.drawer.docs.status': 'Status',
  'atc.operations.drawer.docs.updated': 'Letztes Update',

  // Filters
  'atc.bridge.filters.all': 'Alle',
  'atc.bridge.filters.any': 'Beliebig',
  'atc.bridge.filters.yes': 'Ja',
  'atc.bridge.filters.no': 'Nein',
  'atc.bridge.filters.lifecycle': 'Lifecycle',
  'atc.bridge.filters.blocked': 'Blockiert',
  'atc.bridge.filters.closure': 'Abschluss',
  'atc.bridge.filters.priority': 'Priorität',
  'atc.bridge.filters.mode': 'Modus',
  'atc.bridge.filters.assignee': 'Zuständig',
  'atc.bridge.filters.refresh': 'Aktualisieren',

  // Actions

  // PR Queue view
  'atc.bridge.prs.approve': 'Approve + Merge',
  'atc.bridge.prs.reject': 'Ablehnen',
  'atc.bridge.prs.merged': '{repo} #{number} gemerged',
  'atc.bridge.prs.rejected': 'PR geschlossen',
  'atc.bridge.prs.selected': '{count} ausgewählt',
  'atc.bridge.prs.approveAll': 'Alle genehmigen',
  'atc.bridge.prs.batchResult': '{merged} gemerged, {failed} fehlgeschlagen',
  'atc.bridge.prs.ungrouped': 'Nicht zugeordnet',
  'atc.bridge.prs.empty': 'Keine offenen PRs',
  'atc.bridge.prs.emptyDesc': 'Alle Pull Requests wurden bearbeitet.',
  'atc.bridge.prs.confirmBatch': 'Batch-Genehmigung',
  'atc.bridge.prs.confirmBatchDesc': '{count} PRs genehmigen und mergen?',
  'atc.bridge.prs.confirmReject': 'PR ablehnen',
  'atc.bridge.prs.confirmRejectDesc': '{repo} #{number} schließen ohne Merge?',
  'atc.bridge.commanderPrs.title': 'Commander PRs',
  'atc.bridge.commanderPrs.filterLabel': 'Target-Branches',
  'atc.bridge.commanderPrs.empty': 'Keine passenden PRs',
  'atc.bridge.commanderPrs.emptyDesc': 'Passe die Branch-Filter an.',
  'atc.bridge.commanderPrs.refreshing': 'Aktualisiere...',
  'atc.bridge.commanderPrs.columns.repo': 'Repo',
  'atc.bridge.commanderPrs.columns.number': '#',
  'atc.bridge.commanderPrs.columns.title': 'Titel',
  'atc.bridge.commanderPrs.columns.author': 'Autor',
  'atc.bridge.commanderPrs.columns.ci': 'CI',
  'atc.bridge.commanderPrs.columns.mergeable': 'Mergebar',
  'atc.bridge.commanderPrs.columns.comments': 'Kommentare',
  'atc.bridge.commanderPrs.columns.updated': 'Aktualisiert',
  'atc.bridge.commanderPrs.authorUnknown': 'Unbekannt',
  'atc.bridge.commanderPrs.authorKind.bot': 'Bot',
  'atc.bridge.commanderPrs.authorKind.user': 'User',
  'atc.bridge.commanderPrs.ci.success': 'Erfolg',
  'atc.bridge.commanderPrs.ci.failure': 'Fehler',
  'atc.bridge.commanderPrs.ci.pending': 'Laufend',
  'atc.bridge.commanderPrs.ci.error': 'Abgebrochen/Fehler',
  'atc.bridge.commanderPrs.ci.unknown': 'Unbekannt',
  'atc.bridge.commanderPrs.mergeable.checking': 'Prüfung...',
  'atc.bridge.commanderPrs.mergeable.ready': 'Bereit',
  'atc.bridge.commanderPrs.mergeable.blocked': 'Blockiert',
  'atc.bridge.commanderPrs.commentsCount': '{count}',
  'atc.bridge.commanderPrs.unresolvedComments': 'Offene Kommentare',
  'atc.bridge.commanderPrs.branchProtectionLock': 'Branch Protection blockiert',
  'atc.bridge.commanderPrs.drawer.emptyTitle': 'Kein Pull Request ausgewählt',
  'atc.bridge.commanderPrs.drawer.emptyDesc': 'Wähle einen PR aus der Liste, um Details zu sehen.',
  'atc.bridge.commanderPrs.drawer.viewOnGitHub': 'Auf GitHub ansehen',
  'atc.bridge.commanderPrs.drawer.tabs.overview': 'Übersicht',
  'atc.bridge.commanderPrs.drawer.tabs.files': 'Dateien',
  'atc.bridge.commanderPrs.drawer.tabs.ci': 'CI',
  'atc.bridge.commanderPrs.drawer.tabs.comments': 'Kommentare',
  'atc.bridge.commanderPrs.drawer.tabs.reviews': 'Reviews',
  'atc.bridge.commanderPrs.drawer.actions.promoteToMain': 'Promote to main',
  'atc.bridge.commanderPrs.drawer.files.empty': 'Keine geänderten Dateien',
  'atc.bridge.commanderPrs.drawer.files.emptyDesc': 'Für diesen PR liegen noch keine Dateidetails vor.',
  'atc.bridge.commanderPrs.drawer.files.noPatch': 'Keine Patch-Vorschau verfügbar.',
  'atc.bridge.commanderPrs.drawer.files.viewFullDiff': 'Vollen Diff ansehen',
  'atc.bridge.commanderPrs.drawer.ci.empty': 'Keine Checks gefunden',
  'atc.bridge.commanderPrs.drawer.ci.emptyDesc': 'Für diesen Pull Request sind keine CI-Check-Runs vorhanden.',
  'atc.bridge.commanderPrs.drawer.comments.threads': 'Review-Threads',
  'atc.bridge.commanderPrs.drawer.comments.threadsEmpty': 'Keine Review-Threads',
  'atc.bridge.commanderPrs.drawer.comments.threadsEmptyDesc': 'Noch keine threaded Review-Kommentare vorhanden.',
  'atc.bridge.commanderPrs.drawer.comments.issueComments': 'Issue-Kommentare',
  'atc.bridge.commanderPrs.drawer.comments.issueEmpty': 'Keine Issue-Kommentare',
  'atc.bridge.commanderPrs.drawer.comments.issueEmptyDesc': 'Zu diesem Pull Request gibt es noch keine Issue-Kommentare.',
  'atc.bridge.commanderPrs.drawer.comments.resolved': 'Gelöst',
  'atc.bridge.commanderPrs.drawer.comments.unresolved': 'Offen',
  'atc.bridge.commanderPrs.drawer.comments.resolve': 'Lösen',
  'atc.bridge.commanderPrs.drawer.comments.commentPlaceholder': 'Kommentar schreiben...',
  'atc.bridge.commanderPrs.drawer.comments.submit': 'Senden',
  'atc.bridge.commanderPrs.drawer.comments.you': 'Du',
  'atc.bridge.commanderPrs.drawer.reviews.empty': 'Noch keine Reviews',
  'atc.bridge.commanderPrs.drawer.reviews.emptyDesc': 'Reviews erscheinen nach dem Einreichen.',
  'atc.bridge.commanderPrs.drawer.reviews.approve': 'Genehmigen',
  'atc.bridge.commanderPrs.drawer.reviews.requestChanges': 'Änderungen anfordern',
  'atc.bridge.commanderPrs.drawer.reviews.dismiss': 'Verwerfen',
  'atc.bridge.commanderPrs.drawer.reviews.dismissReason': 'Im Commander-Drawer verworfen',
  'atc.bridge.commanderPrs.drawer.reviews.state.approved': 'Genehmigt',
  'atc.bridge.commanderPrs.drawer.reviews.state.changes_requested': 'Änderungen angefordert',
  'atc.bridge.commanderPrs.drawer.reviews.state.commented': 'Kommentiert',
  'atc.bridge.commanderPrs.drawer.reviews.state.dismissed': 'Verworfen',
  'atc.bridge.commanderPrs.drawer.actions.merge': 'Mergen',
  'atc.bridge.commanderPrs.drawer.actions.close': 'Schließen',
  'atc.bridge.commanderPrs.drawer.actions.confirmMerge': 'Diesen Pull Request mergen?',
  'atc.bridge.commanderPrs.drawer.actions.confirmMergeDesc': '{{repo}} #{{number}} jetzt mergen.',
  'atc.bridge.commanderPrs.drawer.actions.confirmClose': 'Diesen Pull Request schließen?',
  'atc.bridge.commanderPrs.drawer.actions.confirmCloseDesc': '{{repo}} #{{number}} ohne Merge schließen.',
  'atc.bridge.commanderPrs.drawer.actions.ciMustPass': 'CI muss erfolgreich sein',
  'atc.bridge.commanderPrs.drawer.actions.branchProtectionBlocking': 'Branch-Protection blockiert',
  'atc.bridge.commanderPrs.drawer.actions.overrideBranchProtection': 'Branch-Protection übersteuern',
  'atc.bridge.commanderPrs.drawer.actions.overrideTypedConfirmTitle': 'PR-Nummer eingeben, um fortzufahren',
  'atc.bridge.commanderPrs.drawer.actions.overrideTypedConfirmDesc': 'Bitte #{{number}} erneut eingeben, um diesen Bypass zu bestätigen.',
  'atc.bridge.commanderPrs.drawer.actions.overrideTypedConfirmInputLabel': 'PR-Nummer',
  'atc.bridge.commanderPrs.drawer.actions.confirmBypass': 'Branch-Protection für PR #{{number}} umgehen?',
  'atc.bridge.commanderPrs.drawer.actions.confirmBypassDesc': 'Das versucht einen direkten GitHub-Merge mit den Rechten deines PAT.',
  'atc.bridge.commanderPrs.drawer.actions.comingB4': 'Kommt in SORTIE-B4',
  'atc.bridge.commanderPrs.drawer.actions.edit': 'PR bearbeiten',
  'atc.bridge.commanderPrs.drawer.actions.editTitle': 'Titel',
  'atc.bridge.commanderPrs.drawer.actions.editBody': 'Beschreibung',
  'atc.bridge.commanderPrs.drawer.actions.editDraft': 'Entwurf',
  'atc.bridge.commanderPrs.drawer.actions.editNoChangesTitle': 'Keine Änderungen',
  'atc.bridge.commanderPrs.drawer.actions.editNoChangesDesc': 'Bitte Titel, Beschreibung oder Entwurf-Status ändern, bevor du speicherst.',
  'atc.bridge.commanderPrs.drawer.actions.updateBranch': 'Branch aktualisieren',
  'atc.bridge.commanderPrs.drawer.actions.rerunWorkflow': 'Erneut ausführen',
  'atc.bridge.commanderPrs.drawer.actions.rerunFailedJobs': 'Fehlgeschlagene Jobs erneut starten',
  'atc.bridge.commanderPrs.drawer.ci.failedWorkflows': 'Fehlgeschlagene Workflow-Runs',
  'atc.bridge.commanderPrs.drawer.reviews.requestChangesDefaultBody': 'Änderungen über Commander Bridge angefordert.',
  'atc.repos.column.prNumber': 'PR #',
  'atc.repos.column.title': 'Titel',
  'atc.repos.column.branchTarget': 'Branch -> Target',
  'atc.repos.column.age': 'Alter',
  'atc.repos.column.status': 'Status',
  'atc.repos.column.author': 'Autor',
  'atc.repos.column.ci': 'CI-Summary',
  'atc.repos.column.reviewComments': 'Review-Kommentare',
  'atc.repos.drawer.tab.uebersicht': 'Uebersicht',
  'atc.repos.drawer.tab.diff': 'Diff',
  'atc.repos.drawer.tab.files': 'Dateien',
  'atc.repos.drawer.tab.ci': 'CI',
  'atc.repos.drawer.tab.comments': 'Kommentare',
  'atc.repos.drawer.tab.reviews': 'Reviews',
  'atc.repos.drawer.action.approve': 'Genehmigen',
  'atc.repos.drawer.action.requestChanges': 'Aenderungen anfordern',
  'atc.repos.drawer.action.merge': 'Mergen',
  'atc.repos.drawer.action.mergeAsAdmin': 'Als Admin mergen',
  'atc.repos.drawer.action.mergeAsAdminHint': 'GitHub-Review-Pflicht via Admin-Override umgehen (FR-PR-MERGE-WITHOUT-APPROVE).',
  'atc.repos.drawer.action.edit': 'Bearbeiten',
  'atc.repos.drawer.action.updateBranch': 'Branch aktualisieren',
  'atc.repos.drawer.action.rerunCi': 'CI neu starten',
  'atc.repos.viewToggle.byRepo': 'Nach Repo gruppieren',
  'atc.repos.viewToggle.flat': 'Flach',
  'atc.repos.viewToggle.byStatus': 'Nach Status gruppieren',
  'atc.repos.empty.notProjected': 'Feature wartet auf Upstream ({pointer})',

  // Staging Delta view
  'atc.bridge.staging.commitsAhead': 'Commits voraus',
  'atc.bridge.staging.filesChanged': 'Dateien geändert',
  'atc.bridge.staging.promote': 'Promote',
  'atc.bridge.staging.upToDate': 'Aktuell',
  'atc.bridge.staging.noCommits': 'Keine Commits',
  'atc.bridge.staging.justNow': 'Gerade eben',
  'atc.bridge.staging.ago': 'her',
  'atc.bridge.staging.staleWarning': 'Überfällig — mehr als 5 Commits voraus',
  'atc.bridge.staging.promoted': '{repo} promoted — PR #{pr} erstellt',
  'atc.bridge.staging.confirmPromote': 'Staging promoten',
  'atc.bridge.staging.confirmPromoteDesc': 'staging → main PR für {repo} erstellen?',
  'atc.bridge.staging.empty': 'Keine Repos',
  'atc.bridge.staging.emptyDesc': 'Staging-Delta konnte nicht geladen werden.',
  'atc.bridge.staging.reposWithChanges': 'Repos mit Änderungen',
  'atc.bridge.staging.totalCommits': 'Commits gesamt',

  // Escalations view
  'atc.bridge.escalations.title': 'Eskalationen',
  'atc.bridge.escalations.resetToGate': 'Reset → GATE',
  'atc.bridge.escalations.kill': 'Beenden',
  'atc.bridge.escalations.replan': 'Neu planen',
  'atc.bridge.escalations.actionApplied': '{action} ausgeführt — Status: {status}',
  'atc.bridge.escalations.confirmKill': 'Entity beenden',
  'atc.bridge.escalations.confirmKillDesc': '„{id}" endgültig beenden? Diese Aktion kann nicht rückgängig gemacht werden.',
  'atc.bridge.escalations.empty': 'Keine Eskalationen',
  'atc.bridge.escalations.emptyDesc': 'Alle Entities laufen normal. Keine HALTED-Einträge.',

  // ── Bridge Chat Composer — Send ─────────────────────────────────────────
  // Typed-error branches per `SendMessageErrorCode` (Wave 5 of Pillar 3
  // typed-fetch migration, ADR-CROSS-SYSTEM-CONTRACTS-V1 v4 §2.2). Each
  // key matches one enum value; `contractMismatch` covers response-shape
  // drift (D-33 R1), `unknown` covers everything else.
  'atc.bridge.chat.send.retry': 'Erneut senden',
  'atc.bridge.chat.send.error.UNAUTHORIZED': 'Nicht angemeldet — bitte erneut einloggen.',
  'atc.bridge.chat.send.error.FORBIDDEN': 'Keine Berechtigung, an dieses Ziel zu senden.',
  'atc.bridge.chat.send.error.NOT_FOUND': 'Empfänger nicht gefunden.',
  'atc.bridge.chat.send.error.VALIDATION_ERROR': 'Nachricht abgelehnt — ungültiger Inhalt.',
  'atc.bridge.chat.send.error.RATE_LIMITED': 'Zu viele Nachrichten — kurz warten und erneut versuchen.',
  'atc.bridge.chat.send.error.INTERNAL': 'Service-Layer-Fehler — bitte erneut versuchen.',
  'atc.bridge.chat.send.error.TIMEOUT': 'Zeitüberschreitung — bitte erneut versuchen.',
  'atc.bridge.chat.send.error.CONFLICT': 'Konflikt mit bestehendem Signal — bitte aktualisieren.',
  'atc.bridge.chat.send.error.TARGET_UNREACHABLE': 'Empfänger hat keine aktive Session — erst spawnen.',
  'atc.bridge.chat.send.error.EMPTY_BODY': 'Nachricht ist leer — Text oder Anhang ergänzen.',
  'atc.bridge.chat.send.error.contractMismatch': 'Antwort vom Service Layer ist ungültig — bitte neu laden.',
  'atc.bridge.chat.send.error.unknown': 'Nachricht konnte nicht gesendet werden.',

  // ── Workitem-Chat-Picker (Operator 2026-05-23) ──────────────────────────
  // Der Picker stempelt `from_work_item_id` auf das ausgehende Signal,
  // damit die Diskussion am Workitem landet, nicht im flachen Chat.
  'atc.bridge.chat.workitem.label': 'Spricht über',
  'atc.bridge.chat.workitem.none': 'Kein Workitem — flacher Chat',
  'atc.bridge.chat.workitem.pick': 'Workitem wählen',
  'atc.bridge.chat.workitem.clear': 'Workitem entfernen',
  'atc.bridge.chat.workitem.search': 'Workitems suchen…',
  'atc.bridge.chat.workitem.empty': 'Keine passenden Workitems.',
  'atc.bridge.chat.workitem.loading': 'Workitems werden geladen…',
  'atc.bridge.chat.workitem.error': 'Workitems konnten nicht geladen werden.',

  'atc.workitemConversation.title': 'Workitem-Gespräch',
  'atc.workitemConversation.empty': 'Noch keine Nachrichten — schreibe dem Agenten direkt auf diesem Workitem.',
  'atc.workitemConversation.loading': 'Gespräch wird geladen…',
  'atc.workitemConversation.error': 'Gespräch konnte nicht geladen werden.',
  'atc.workitemConversation.placeholder': 'Nachricht an den Agenten auf diesem Workitem…',
  'atc.workitemConversation.send': 'Senden',
  'atc.workitemConversation.sending': 'Wird gesendet…',
  'atc.workitemConversation.sendError': 'Nachricht konnte nicht gesendet werden.',
  'atc.workitemConversation.close': 'Schließen',
  'atc.highlights.title': 'Highlights',
  'atc.highlights.loading': 'Wird geladen…',
  'atc.highlights.error': 'Highlights konnten nicht geladen werden.',
  'atc.highlights.opNotFound': 'OP nicht im Manifest gefunden.',
  'atc.highlights.empty': 'Keine offenen Einträge in diesem OP.',
  'atc.highlights.open': 'offen',
  'atc.highlights.blocked': 'blockiert',
  'atc.highlights.expandRow': 'Details anzeigen',
  'atc.highlights.collapseRow': 'Details ausblenden',
  'atc.highlights.detail.id': 'ID',
  'atc.highlights.detail.entityType': 'Typ',
  'atc.highlights.detail.lifecycle': 'Lifecycle',
  'atc.highlights.detail.priority': 'Priorität',
  'atc.highlights.detail.assignee': 'Zuständig',
  'atc.highlights.detail.repo': 'Repo',
  'atc.highlights.detail.progress': 'Fortschritt',
  'atc.highlights.detail.closureReason': 'Abschlussgrund',
  'atc.highlights.detail.docStore': 'Dokument',
  'atc.highlights.detail.updated': 'Aktualisiert',
  'atc.highlights.detail.none': '—',

  // ── Scout Insights ──────────────────────────────────────────────────────
  'scout.insights.title': 'Insights Dashboard',
  'scout.insights.subtitle': 'Umsatzauswertung nach Produkt und Branche',
  'scout.insights.error': 'Insights konnten nicht geladen werden',
  'scout.insights.emptyTitle': 'Noch keine Daten',
  'scout.insights.emptyDescription': 'Sobald Verkaufsdaten vorliegen, erscheinen hier die Auswertungen.',
  'scout.insights.byProduct': 'Umsatz nach Produkt',
  'scout.insights.byIndustry': 'Umsatz nach Branche',

  // ── Scout Wochenplanung Tasks ───────────────────────────────────────────
  'scout.wochenplanung.tasks.title': 'Aufgaben',
  'scout.wochenplanung.tasks.openReports': 'Offene Berichte',
  'scout.wochenplanung.tasks.openReportsDescription': 'Besuchsberichte, die noch eingereicht werden müssen',
  'scout.wochenplanung.tasks.pendingReview': 'Ausstehende Reviews',
  'scout.wochenplanung.tasks.pendingReviewDescription': 'Missionen, die auf Prüfung warten',
  'scout.wochenplanung.tasks.overdueReports': 'Überfällige Berichte',
  'scout.wochenplanung.tasks.overdueReportsDescription': 'Berichte, deren Frist abgelaufen ist',

  // ── Scout PreQual Section ───────────────────────────────────────────────
  'scout.prequal.section.branche': 'Branche',
  'scout.prequal.sessionPaused': 'Session pausiert',
  'scout.prequal.noActivity': 'Keine Aktivität erkannt',
  'scout.prequal.resume': 'Fortsetzen',
  'scout.prequal.builtInTelephony': 'Eingebaute Telefonie',
  'scout.prequal.telephonySwitched': 'Wir haben auf eingebaute Telefonie umgestellt. Teams wird nicht mehr benötigt.',
  'scout.prequal.telephonyTestPhase': 'Wir haben auf eingebaute Telefonie umgestellt. Es gibt in der Testphase 2 Optionen:',
  'scout.prequal.telephonyAuto': 'System wählt automatisch nach jeder Bearbeitung.',
  'scout.prequal.telephonyManualLabel': 'Manuell',
  'scout.prequal.telephonyManual': 'Hörer-Button oben links.',
  'scout.prequal.skip': 'Überspringen',
  'scout.prequal.dialNow': 'Jetzt anrufen',

  // ── Scout PreQual Outcome Dialog ────────────────────────────────────────
  'scout.prequal.outcome.notReachedTitle': 'Nicht erreicht — Grund angeben',
  'scout.prequal.outcome.mailbox': 'Anrufbeantworter / Mailbox',
  'scout.prequal.outcome.noAnswer': 'Keiner abgenommen',
  'scout.prequal.outcome.wrongNumber': 'Falsche Nummer',
  'scout.prequal.outcome.notesOptional': 'Notizen (optional)',
  'scout.prequal.outcome.moreDetails': 'Weitere Details...',
  'scout.prequal.outcome.saveAndNext': 'Speichern & Weiter',
  'scout.prequal.dtmf.trigger': 'DTMF-Tastenfeld',
  'scout.prequal.manualDial.trigger': 'Manuell wählen',
  'scout.prequal.manualDial.placeholder': 'Nummer eingeben',
  'scout.prequal.manualDial.call': 'Anrufen',
  'scout.prequal.manualDial.backspace': 'Löschen',
  'scout.prequal.dtmf.keyboardHint': 'Tastatur 0-9, *, # für IVR-Eingaben.',
  'scout.prequal.outcome.connectionFailedTitle': 'Verbindung fehlgeschlagen',
  'scout.prequal.outcome.noConnection': 'Kein Anschluss unter dieser Nummer',
  'scout.prequal.outcome.fax': 'Fax',
  'scout.prequal.outcome.endCall': 'Gespräch beenden',
  'scout.prequal.outcome.whoReached': 'Wen haben Sie erreicht?*',
  'scout.prequal.outcome.nobodyRelevant': 'Niemand relevant',
  'scout.prequal.outcome.reception': 'Empfang / Zentrale',
  'scout.prequal.outcome.decisionMaker': 'Entscheider / Fachperson',
  'scout.prequal.outcome.receptionNameLabel': 'Name am Empfang (optional)',
  'scout.prequal.outcome.receptionNamePlaceholder': 'z.B. Frau Schmidt',
  'scout.prequal.outcome.decisionMakerNameLabel': 'Name des Entscheiders (optional)',
  'scout.prequal.outcome.decisionMakerNamePlaceholder': 'z.B. Herr Müller',
  'scout.prequal.outcome.whatNext': 'Was nun?*',
  'scout.prequal.outcome.processingDone': 'Bearbeitung abgeschlossen',
  'scout.prequal.outcome.callLater': 'Später anrufen',
  'scout.prequal.outcome.toSummary': 'Weiter zur Zusammenfassung',
  'scout.prequal.outcome.callbackWho': 'Wen rufen wir zurück?*',
  'scout.prequal.outcome.callbackAnsprechpartner': 'Ansprechpartner',
  'scout.prequal.outcome.callbackZentrale': 'Zentrale',
  'scout.prequal.outcome.callbackWhen': 'Wann?*',
  'scout.prequal.outcome.callbackCustom': 'Genauer Zeitpunkt …',
  'scout.prequal.outcome.callbackDate': 'Datum',
  'scout.prequal.outcome.callbackTime': 'Uhrzeit',

  // ── Scout PreQual Summary ───────────────────────────────────────────────
  'scout.prequal.summary.interestReason': 'Interesse-Begründung',
  'scout.prequal.summary.interestReasonPlaceholder': 'Warum dieses Interesse-Level?',
  'scout.prequal.summary.competitor': 'Wettbewerber',
  'scout.prequal.summary.competitorPlaceholder': 'z.B. Würth, Dr. Schnell',

  // ── PreQual Campaign Cockpit ─────────────────────────────────────────────
  'scout.prequal.campaign.noAssignment': 'Keine Kampagne zugewiesen',
  'scout.prequal.campaign.noAssignmentDesc': 'Es wurde keine aktive Kampagne für diesen Benutzer gefunden. Bitte wenden Sie sich an Ihren Vorgesetzten.',
  'scout.prequal.campaign.moreCampaignsSuffix': 'weitere',
  'scout.prequal.campaign.allCampaigns': 'Alle Kampagnen',
  'scout.prequal.campaign.switcherLabel': 'Kampagne auswählen',
  'scout.prequal.campaign.startSession': 'Session starten',
  'scout.prequal.campaign.resumeSession': 'Session fortsetzen',
  'scout.prequal.campaign.continueSession': 'Weiter telefonieren',
  'scout.prequal.campaign.todayCalls': 'Anrufe heute',
  'scout.prequal.campaign.todayReached': 'Erreicht heute',
  'scout.prequal.campaign.todayQualified': 'Qualifiziert heute',
  'scout.prequal.campaign.conversionRate': 'Conversion Rate',
  'scout.prequal.campaign.queueProgress': 'Queue-Fortschritt',
  'scout.prequal.campaign.leadsAssigned': 'Leads zugewiesen',
  'scout.prequal.campaign.currentSession': 'Aktuelle Session',
  'scout.prequal.campaign.completed': 'Abgeschlossen',
  'scout.prequal.campaign.inProgress': 'In Bearbeitung',
  'scout.prequal.campaign.exhausted': 'Erschöpft',
  'scout.prequal.campaign.completedCount': '{{count}} abgeschlossen',
  'scout.prequal.campaign.openCount': '{{count}} offen',

  // ── Lobby (pre-calling landing) ──────────────────────────────────────────
  'scout.prequal.lobby.title': 'Lobby',
  'scout.prequal.lobby.pickerHeading': 'Kampagne wählen',
  'scout.prequal.lobby.pickerHint': 'Wähle eine Kampagne, um die Session zu starten.',
  'scout.prequal.lobby.selected': 'Ausgewählt',
  'scout.prequal.lobby.selectCampaignLabel': 'Kampagne {{title}} auswählen',
  'scout.prequal.lobby.pendingLeads': '{{count}} offene Leads',
  'scout.prequal.lobby.typePrequal': 'Neukunden',
  'scout.prequal.lobby.typeReorder': 'Nachbestellung',

  // ── PreQual Reorder Campaign (FR-FE-CALLING-REORDER-CAMPAIGN-COCKPIT) ─────
  'scout.prequal.reorder.standing': 'Umsatz & Zahlung',
  'scout.prequal.reorder.purchaseHistory': 'Bestellhistorie',
  'scout.prequal.reorder.orders': 'Bestellungen',
  'scout.prequal.reorder.product': 'Produkt',
  'scout.prequal.reorder.qty': 'Menge',
  'scout.prequal.reorder.amount': 'Betrag',
  'scout.prequal.reorder.date': 'Datum',
  'scout.prequal.reorder.paymentOnTime': 'Zahlung pünktlich',
  'scout.prequal.reorder.paymentOnTimeYes': 'Pünktlich',
  'scout.prequal.reorder.paymentOnTimeNo': 'Verzug',
  'scout.prequal.reorder.openInvoices': 'Offene Rechnungen',
  'scout.prequal.reorder.reorderDue': 'Nachbestellung fällig',
  'scout.prequal.reorder.decisionMaker': 'Ansprechpartner',
  'scout.prequal.reorder.bestandskunde': 'Bestandskunde',
  'scout.prequal.reorder.totalRevenue': 'Umsatz gesamt',
  'scout.prequal.reorder.payment': 'Zahlung',
  'scout.prequal.reorder.rep': 'Betreuer',
  'scout.prequal.reorder.note': 'Notiz',
  'scout.prequal.reorder.scriptTitle': 'Nachbestell-Skript',
  'scout.prequal.reorder.scriptEmpty': 'Kein Skript verfügbar.',

  // ── Scout Call Test ─────────────────────────────────────────────────────
  'scout.callTest.title': 'Voice Call Test',
  'scout.callTest.runAll': 'Alle Tests starten',
  'scout.callTest.noPhoneOnProfile': 'Keine Telefonnummer im Benutzerprofil hinterlegt.',
  'scout.callTest.phoneMissingTitle': 'Testnummer nicht gefunden',
  'scout.callTest.phoneFallback': 'Fallback: {{number}}',
  'scout.callTest.copyTwilioLog': 'Twilio-Log kopieren',
  'scout.callTest.copied': 'Kopiert',
  'scout.callTest.copyError': 'Kopieren fehlgeschlagen',

  // ── Scout Dialer Config ─────────────────────────────────────────────────
  'scout.dialerConfig.title': 'Dialer Konfiguration',
  'scout.dialerConfig.featureFlags': 'Feature Flags (pro Benutzer)',
  'scout.dialerConfig.user': 'Benutzer',

  // ── Scout Timesheet ────────────────────────────────────────────────────
  'scout.timesheet.title': 'Zeiterfassung',
  'scout.timesheet.print': 'Drucken',
  'scout.timesheet.thisWeek': 'Diese Woche',
  'scout.timesheet.thisMonth': 'Dieser Monat',
  'scout.timesheet.callsThisWeek': 'Anrufe diese Woche',
  'scout.timesheet.callsThisMonth': 'Anrufe diesen Monat',
  'scout.timesheet.workLog': 'Arbeitszeitnachweis',
  'scout.timesheet.date': 'Datum',
  'scout.timesheet.start': 'Beginn',
  'scout.timesheet.end': 'Ende',
  'scout.timesheet.duration': 'Dauer',
  'scout.timesheet.calls': 'Anrufe',
  'scout.timesheet.reached': 'Erreicht',
  'scout.timesheet.reachedRate': 'Erreichbarkeit',
  'scout.timesheet.qualified': 'Qualifiziert',
  'scout.timesheet.noEntries': 'Noch keine Einträge vorhanden.',

  // ── ATC Calling Dashboard ──────────────────────────────────────────────
  'atc.callingDashboard.title': 'Calling Dashboard',
  'atc.callingDashboard.activeSessions': 'Aktive Sessions',
  'atc.callingDashboard.callsToday': 'Anrufe heute',
  'atc.callingDashboard.reachedToday': 'Erreicht heute',
  'atc.callingDashboard.qualifiedToday': 'Qualifiziert heute',
  'atc.callingDashboard.liveSessions': 'Live Sessions',
  'atc.callingDashboard.noActiveSessions': 'Keine aktiven Sessions.',
  'atc.callingDashboard.todaySummary': 'Heute pro Caller',
  'atc.callingDashboard.noDataToday': 'Keine Daten für heute.',
  'atc.callingDashboard.caller': 'Caller',

  // ── ATC Timesheet Review ───────────────────────────────────────────────
  'atc.timesheetReview.title': 'Zeiterfassung prüfen',
  'atc.timesheetReview.callerSummary': 'Zusammenfassung pro Caller',
  'atc.timesheetReview.days': 'Tage',

  // ── Scout Sessions ─────────────────────────────────────────────────────
  'scout.sessions.title': 'Meine Sessions',
  'scout.sessions.totalSessions': 'Sessions gesamt',
  'scout.sessions.totalTime': 'Gesamtzeit',
  'scout.sessions.totalCalls': 'Anrufe gesamt',
  'scout.sessions.totalReached': 'Erreicht gesamt',
  'scout.sessions.pastSessions': 'Vergangene Sessions',
  'scout.sessions.noSessions': 'Noch keine Sessions vorhanden.',
  'scout.sessions.status': 'Status',

  // ── Warehouse: Unified Bills Workspace (W1) ─────────────────────────────
  'warehouse.bills.title': 'Rechnungen',
  'warehouse.bills.subtitle': 'Alle Wackler-Rechnungen mit Lifecycle, Alter und Zeilenstatus.',
  'warehouse.bills.stats.total': 'Rechnungen',
  'warehouse.bills.stats.closureReady': 'Abschluss bereit',
  'warehouse.bills.stats.netOutstanding': 'Offener Netto-Saldo',
  'warehouse.bills.stats.d90plus': '90+ Tage überfällig',
  'warehouse.bills.filter.track': 'Bereich',
  'warehouse.bills.filter.aging': 'Alter',
  'warehouse.bills.filter.node': 'Lifecycle',
  'warehouse.bills.filter.all': 'Alle',
  'warehouse.bills.filter.logistics': 'Logistik',
  'warehouse.bills.filter.freight': 'Fracht',
  'warehouse.bills.filter.closureReady': 'Nur abschlussbereit',
  'warehouse.bills.node.intake': 'Eingang',
  'warehouse.bills.node.orient': 'Analyse',
  'warehouse.bills.node.execute': 'Bearbeitung',
  'warehouse.bills.node.verify': 'Prüfung',
  'warehouse.bills.node.review': 'Wackler-Review',
  'warehouse.bills.node.closed': 'Abgeschlossen',
  'warehouse.bills.node.none': 'Ohne Lifecycle',
  'warehouse.bills.col.period': 'Monat',
  'warehouse.bills.col.invoiceNumber': 'Rechnungs-Nr.',
  'warehouse.bills.col.invoiceDate': 'Datum',
  'warehouse.bills.col.track': 'Bereich',
  'warehouse.bills.col.node': 'Lifecycle',
  'warehouse.bills.col.gross': 'Brutto',
  'warehouse.bills.col.net': 'Netto offen',
  'warehouse.bills.col.age': 'Alter',
  'warehouse.bills.col.lines': 'Zeilen (akz/disp/offen)',
  'warehouse.bills.col.flags': 'Flags',
  'warehouse.bills.col.action': 'Aktion',
  'warehouse.bills.close.button': 'Abschluss erklären',
  'warehouse.bills.close.dialogTitle': 'Rechnung abschließen',
  'warehouse.bills.close.dialogDescription': 'Rechnung {{invoice}} ({{period}}) wird auf abgeschlossen gesetzt. Alle Zeilen sind akzeptiert oder freigegeben, und der Saldo ist ausgeglichen. Diese Aktion ist nicht umkehrbar.',
  'warehouse.bills.close.confirm': 'Abschluss bestätigen',
  'warehouse.bills.close.cancel': 'Abbrechen',
  'warehouse.bills.close.blockedNotReview': 'Rechnung kann nur aus dem Status "Wackler-Review" abgeschlossen werden.',
  'warehouse.bills.close.blockedNotReady': 'Rechnung ist noch nicht abschlussbereit — es gibt offene oder nicht zugewiesene Posten.',
  'warehouse.bills.close.blockedAlreadyClosed': 'Rechnung ist bereits abgeschlossen.',
  'warehouse.bills.close.blockedNoEntity': 'Rechnung ist nicht mit einem Lifecycle-Entity verknüpft. SL kontaktieren.',
  'warehouse.bills.flag.closureReady': 'Abschluss bereit',
  'warehouse.bills.flag.locked': 'Gesperrt',
  'warehouse.bills.empty.title': 'Keine Rechnungen gefunden',
  'warehouse.bills.empty.description': 'Mit den aktuellen Filtern sind keine Rechnungen sichtbar. Filter entfernen oder anderen Bereich wählen.',
  'warehouse.bills.error': 'Rechnungen konnten nicht geladen werden: {{message}}',
  'warehouse.bills.pdf.drawerAriaLabel': 'PDF-Ansicht — {{invoice}}',
  'warehouse.bills.pdf.documentFallbackTitle': 'Rechnungsdokument',
  'warehouse.bills.pdf.openTab': 'In Tab öffnen',
  'warehouse.bills.pdf.download': 'Herunterladen',
  'warehouse.bills.pdf.noStoragePath': 'Für diese Rechnung ist kein PDF hinterlegt.',
  'warehouse.bills.pdf.signFailed': 'Signierte URL konnte nicht abgerufen werden: {{message}}',
  'warehouse.bills.pdf.renderFailed': 'PDF konnte nicht angezeigt werden: {{message}}',
  'warehouse.bills.pdf.prevPage': 'Vorherige Seite',
  'warehouse.bills.pdf.nextPage': 'Nächste Seite',
  'warehouse.bills.pdf.viewPdf': 'PDF anzeigen',

  // ── Warehouse: Wackler Payments ─────────────────────────────────────────
  'warehouse.payments.title': 'Rechnungsabgleich',
  'warehouse.payments.noData': 'Keine Zahlungsdaten vorhanden.',
  'warehouse.payments.allTracks': 'Alle Bereiche',
  'warehouse.payments.logistics': 'Logistik',
  'warehouse.payments.freight': 'Fracht',
  'warehouse.payments.totalInvoiced': 'Rechnungen gesamt',
  'warehouse.payments.totalCredited': 'Gutschriften gesamt',
  'warehouse.payments.totalPaid': 'Bezahlt gesamt',
  'warehouse.payments.openBalance': 'Offener Saldo',
  'warehouse.payments.track': 'Bereich',
  'warehouse.payments.invoice': 'Rechnung',
  'warehouse.payments.invoiced': 'Rechnungsbetrag',
  'warehouse.payments.credited': 'Gutschrift',
  'warehouse.payments.net': 'Netto',
  'warehouse.payments.paid': 'Bezahlt',
  'warehouse.payments.openAmount': 'Offen',
  'warehouse.payments.invoiceDate': 'Datum',
  'warehouse.payments.age': 'Alter',
  'warehouse.payments.invoicesCount': 'Rechnungen',
  'warehouse.payments.allStatuses': 'Alle Status',
  'warehouse.payments.statusPaid': 'Bezahlt',
  'warehouse.payments.statusOpen': 'Offen',
  'warehouse.payments.statusPending': 'Ausstehend',

  // ── Warehouse: AP Aging Buckets ─────────────────────────────────────────
  'warehouse.aging.current': 'Aktuell (0–30 Tage)',
  'warehouse.aging.d30': '31–60 Tage',
  'warehouse.aging.d60': '61–90 Tage',
  'warehouse.aging.d90plus': 'Über 90 Tage',

  // ── Warehouse: Rates & Reference Cases ──────────────────────────────────
  'warehouse.rates.title': 'Tarife & Referenzfälle',
  'warehouse.rates.tabRates': 'Tarife',
  'warehouse.rates.tabCases': 'Referenzfälle',
  'warehouse.rates.billingRates': 'Abrechnungstarife',
  'warehouse.rates.referenceCases': 'Referenzfälle',
  'warehouse.rates.code': 'Code',
  'warehouse.rates.labelDe': 'Bezeichnung (DE)',
  'warehouse.rates.labelEn': 'Bezeichnung (EN)',
  'warehouse.rates.rate': 'Satz',
  'warehouse.rates.floater': 'Floater',
  'warehouse.rates.noCases': 'Keine Referenzfälle geladen.',

  // ── Warehouse: KDP Registry ─────────────────────────────────────────────
  'warehouse.kdp.active': 'Aktiv',
  'warehouse.kdp.pending': 'In Prüfung',
  'warehouse.kdp.retired': 'Zurückgezogen',
  'warehouse.kdp.directionOver': 'Überzahlt',
  'warehouse.kdp.directionUnder': 'Unterzahlt',
  'warehouse.kdp.directionVaries': 'Variabel',
  'warehouse.kdp.catalog': 'KDP-Katalog',
  'warehouse.kdp.detail': 'Detail',
  'warehouse.kdp.name': 'Name',
  'warehouse.kdp.direction': 'Richtung',
  'warehouse.kdp.phases': 'Phasen',
  'warehouse.kdp.description': 'Beschreibung',
  'warehouse.kdp.impactPerUnit': 'Auswirkung / Einheit',
  'warehouse.kdp.selectPrompt': 'KDP auswählen, um Details zu sehen.',
  'warehouse.kdp.crosstabTitle': 'Kreuztabellen-Analyse (nur lesend)',
  'warehouse.kdp.crosstabPending': 'Die Kreuztabelle Monat × KDP wartet auf die v_kdp_monthly_crosstab-View vom Service Layer.',

  // ── Warehouse: Pre-Send Review Modal (W4) ───────────────────────────────
  'warehouse.preSend.title': 'Prüfung vor Versand — {{month}}',
  'warehouse.preSend.drawerAriaLabel': 'Prüfung vor Versand für {{month}}',
  'warehouse.preSend.aggregateTotals': 'Summen',
  'warehouse.preSend.invoiceTotal': 'Rechnungssumme',
  'warehouse.preSend.accepted': 'Akzeptiert',
  'warehouse.preSend.disputed': 'Strittig ({{count}})',
  'warehouse.preSend.netWePay': 'Zahlbetrag netto',
  'warehouse.preSend.disputedLines': 'Strittige Zeilen ({{count}})',
  'warehouse.preSend.extraLines': 'Zusatzzeilen ({{count}})',
  'warehouse.preSend.undercharges': 'Unterberechnungen — nur intern ({{count}})',
  'warehouse.preSend.classify': 'Einordnen',
  'warehouse.preSend.action.pursue': 'Verfolgen',
  'warehouse.preSend.action.accept': 'Akzeptieren',
  'warehouse.preSend.action.drop': 'Verwerfen',
  'warehouse.preSend.gates': 'Freigabekriterien',
  'warehouse.preSend.pendingResolved': 'Offene Zeilen geklärt',
  'warehouse.preSend.extrasClassified': 'Zusatzzeilen eingeordnet',
  'warehouse.preSend.noEntityId': 'Keine Entität für diesen Monat hinterlegt — Freigabe blockiert.',
  'warehouse.preSend.cancel': 'Abbrechen',
  'warehouse.preSend.approveAndSend': 'Freigeben & senden',
  'warehouse.preSend.open': 'Prüfung vor Versand',
  'warehouse.preSend.col.operation': 'Vorgang',
  'warehouse.preSend.col.verdict': 'Verdikt',
  'warehouse.preSend.col.diff': 'Diff',
  'warehouse.preSend.col.externalComment': 'Externer Kommentar',
  'warehouse.preSend.col.billed': 'Berechnet',
  'warehouse.preSend.col.expected': 'Erwartet',
  'warehouse.preSend.col.action': 'Aktion',

  // ── Warehouse: Reconciliation Detail ────────────────────────────────────
  'warehouse.reconciliation.title': 'Monatsabgleich',
  'warehouse.reconciliation.orders': 'Aufträge',
  'warehouse.reconciliation.matched': 'Übereinstimmend',
  'warehouse.reconciliation.overcharged': 'Überzahlt',
  'warehouse.reconciliation.undercharged': 'Unterzahlt',
  'warehouse.reconciliation.overchargeTotal': 'ÜBERZAHLT',
  'warehouse.reconciliation.underchargeTotal': 'UNTERZAHLT',
  'warehouse.reconciliation.netImpact': 'NETTO',
  'warehouse.reconciliation.verdict': 'Verdict',
  'warehouse.reconciliation.verdictFilter': 'Verdict',
  'warehouse.reconciliation.allVerdicts': 'Alle Verdicts',
  'warehouse.reconciliation.searchAria': 'Nach Auftrags-ID suchen',
  'warehouse.reconciliation.expectedTotal': 'Erwartete Summe',
  'warehouse.config.kdpRegistry': 'KDP-Register',
  'warehouse.config.rates': 'Tarife & Referenzfälle',
  'warehouse.reconciliation.wacklerTotal': 'Wackler Betrag',
  'warehouse.reconciliation.diff': 'Differenz',
  'warehouse.drawer.details': 'Details',
  'warehouse.drawer.timeline': 'Timeline',
  'warehouse.drawer.billing': 'Abrechnung',
  'warehouse.drawer.metadata': 'Stammdaten',
  'warehouse.drawer.operationId': 'Auftrags-ID',
  'warehouse.drawer.carrier': 'Carrier',
  'warehouse.drawer.period': 'Leistungszeitraum',
  'warehouse.drawer.phase': 'Phase',
  'warehouse.drawer.reviewedBy': 'Geprüft von',
  'warehouse.drawer.internalNote': 'Interner Vermerk',
  'warehouse.drawer.billingSummary': 'Abrechnungsübersicht',
  'warehouse.drawer.communication': 'Kommunikation',
  'warehouse.drawer.commentPlaceholder': 'Nachricht schreiben...',
  'warehouse.drawer.send': 'Senden',
  'warehouse.drawer.accept': 'Akzeptieren',
  'warehouse.drawer.dispute': 'Bestreiten',
  'warehouse.drawer.noEvents': 'Keine Einträge vorhanden.',
  'warehouse.drawer.timelinePending': 'Kommunikationsverlauf wird geladen...',
  'warehouse.drawer.externalWarning': 'Dieser Kommentar wird für Wackler sichtbar sein.',
  'warehouse.drawer.commsPending': 'Kommunikation in Vorbereitung — verfügbar sobald CNS Comms-Bus live ist.',
  'warehouse.buckets.wacklerMissing': 'Wackler hat nicht berechnet',
  'warehouse.buckets.wacklerMissingDesc': 'Operationen, die bei uns im System sind, aber von Wackler nicht berechnet wurden.',
  'warehouse.buckets.match': 'Korrekt berechnet',
  'warehouse.buckets.matchDesc': 'Operationen mit übereinstimmendem Betrag.',
  'warehouse.buckets.overcharge': 'Zu viel berechnet',
  'warehouse.buckets.overchargeDesc': 'Operationen, bei denen Wackler zu viel berechnet hat (gegen uns).',
  'warehouse.buckets.oursMissing': 'Bei uns unbekannt',
  'warehouse.buckets.oursMissingDesc': 'Operationen, die Wackler abgerechnet hat, zu denen wir aber keine Vergleichsdaten haben.',
  'warehouse.buckets.undercharge': 'Zu wenig berechnet',
  'warehouse.buckets.underchargeDesc': 'Operationen, bei denen Wackler zu wenig berechnet hat (zu unseren Gunsten).',
  'warehouse.buckets.other': 'Sonstige',
  'warehouse.buckets.otherDesc': 'Operationen mit nicht eindeutigem Abgleichsstatus.',
  'warehouse.drawer.accepted': 'Akzeptiert',
  'warehouse.drawer.disputed': 'Bestritten',
  'warehouse.drawer.warehouseComponents': 'Lager-Einzelposten',
  'warehouse.drawer.freightCharges': 'Frachtkosten',
  'warehouse.drawer.noFreightData': 'Keine Frachtdaten für diesen Auftrag.',
  'warehouse.drawer.freightBase': 'Fracht (Basis)',
  'warehouse.drawer.diesel': 'Dieselzuschlag',
  'warehouse.drawer.hazmat': 'Gefahrgutzuschlag',
  'warehouse.drawer.security': 'Sicherheitsgebühr',
  'warehouse.drawer.palletSwap': 'FP-Tauschgebühr',
  'warehouse.drawer.dpdParcel': 'DPD Paket',
  'warehouse.drawer.delivery2': 'Zustellung 2',
  'warehouse.drawer.freightTotal': 'Fracht gesamt',
  'warehouse.drawer.componentsSubtotal': 'Komponenten',
  'warehouse.drawer.kdpAdjustment': 'KDP-Anpassung',
  'warehouse.drawer.unexplained': 'Unerklärt',
  'warehouse.drawer.bottomUpTotal': 'Gesamt',
  'warehouse.drawer.bottomUpDriftWarning': 'Bottom-up-Summe ≠ Zeilen-Differenz (Δ {delta})',
  'nav.wacklerBilling': 'Abrechnung',

  // ── Scan Order Review (WhatsApp pipeline) ───────────────────────────────

  // Wackler lens (View-as-Vendor toggle)
  'wacklerLens.off.label': 'Ansicht: CLANDA',
  'wacklerLens.on.label': 'Ansicht: Wackler',
  'wacklerLens.tooltip.off': 'Umschalten auf Wackler-Ansicht (externe Sicht)',
  'wacklerLens.tooltip.on': 'Zurück zur CLANDA-Ansicht (interne Sicht)',

  // ── MO-CLANDA-ONBOARDING-V1 P1 (public self-serve onboarding portal) ──
  // Source: MO doc 2aa7d735 Appendix A, verbatim from the inside.clanda.de
  // Knowledge PDFs (CLANDA-Microsoft-Login + Anmeldung in Odoo).
  'onboarding.landing.title': 'Willkommen bei CLANDA',
  'onboarding.landing.subtitle': 'Wir richten dein Microsoft-Konto und Odoo-Zugang ein. Bitte gib deine Mobilnummer ein — du erhältst einen Code per SMS.',
  'onboarding.landing.phoneLabel': 'Mobilnummer',
  'onboarding.landing.phonePlaceholder': '+49 …',
  'onboarding.landing.submit': 'Code anfordern',
  'onboarding.landing.submitting': 'Wird gesendet …',
  'onboarding.landing.error': 'Code konnte nicht gesendet werden. Bitte Nummer prüfen und erneut versuchen.',
  'onboarding.verify.title': 'Code eingeben',
  'onboarding.verify.subtitle': 'Bitte den 6-stelligen Code aus der SMS eingeben.',
  'onboarding.verify.codeLabel': 'Code',
  'onboarding.verify.codePlaceholder': '6-stelliger Code',
  'onboarding.verify.submit': 'Anmelden',
  'onboarding.verify.submitting': 'Wird geprüft …',
  'onboarding.verify.error': 'Code ungültig oder abgelaufen. Bitte erneut anfordern.',
  'onboarding.verify.back': 'Zurück',
  'onboarding.flow.selectTitle': 'Was möchtest du einrichten?',
  'onboarding.flow.microsoftLabel': 'Microsoft-Konto + MFA',
  'onboarding.flow.microsoftSub': 'Outlook installieren, anmelden, Authenticator einrichten (Schritte 1–18).',
  'onboarding.flow.odooLabel': 'Odoo (CLANDA-Portal)',
  'onboarding.flow.odooSub': 'Einladung annehmen, Microsoft-SSO, App auf Startbildschirm (Schritte 1–7).',
  'onboarding.flow.requiresMicrosoftFirst': 'Voraussetzung: Microsoft-Einrichtung abgeschlossen.',
  'onboarding.step.markCompleteLabel': 'Erledigt',
  'onboarding.step.markIncompleteLabel': 'Doch nicht erledigt — erneuter Versuch',
  'onboarding.step.next': 'Weiter',
  'onboarding.step.prev': 'Zurück',
  'onboarding.step.helpButton': 'Hilfe — Foto vom Bildschirm',
  'onboarding.step.helpPlaceholder': 'Hilfe-Funktion folgt in Kürze. Bei dringendem Bedarf bitte Sprachnachricht an dein Onboarding-Team.',
  'onboarding.step.assetAlt': 'Beispiel-Bildschirm zu Schritt {index}',
  'onboarding.step.androidBranchNote': 'Wichtig: Für Android-Geräte endet diese Anleitung hier. Bitte folge ab jetzt der Microsoft-Online-Anleitung.',
  'onboarding.progress.counter': 'Schritt {index} von {total}',
  'onboarding.done.title': 'Geschafft — herzlichen Glückwunsch!',
  'onboarding.done.subtitle': 'Du hast die Einrichtung abgeschlossen. Du kannst diese Seite jetzt schließen oder zurück zur Übersicht.',
  'onboarding.done.toFlowsButton': 'Zur Übersicht',

  // Microsoft flow steps (18 + Vorbereitung)
  'onboarding.microsoft.steps.m-vorbereitung.title': 'Vorbereitung',
  'onboarding.microsoft.steps.m-vorbereitung.body': 'Bevor wir starten: Telefon auf neueste Software aktualisiert? Stabiles WLAN? Outlook-App installiert? Diese Anleitung am besten auf einem 2. Gerät offen. Einrichtung bevorzugt auf dem Handy (Apple bevorzugt; auf Android ist der MFA-Teil eingeschränkt).',
  'onboarding.microsoft.steps.m-1.title': 'Outlook öffnen',
  'onboarding.microsoft.steps.m-1.body': 'Falls in Outlook bereits Konten angelegt sind: das Symbol neben "Posteingang" antippen, um das Seitenmenü zu öffnen. Das Symbol kann ein Haus, dein Profilbild oder ein Buchstabe im Kreis sein. Falls noch keine Konten angelegt sind: direkt zu Schritt 3.',
  'onboarding.microsoft.steps.m-2.title': 'Konto-Symbol antippen',
  'onboarding.microsoft.steps.m-2.body': 'Auf das untere Symbol klicken, um ein neues Konto hinzuzufügen. Der Rest des Bildschirms kann anders aussehen — wichtig ist das Symbol mit dem Brief auf grauem Hintergrund.',
  'onboarding.microsoft.steps.m-3.title': 'E-Mail-Konto hinzufügen',
  'onboarding.microsoft.steps.m-3.body': 'Auch für Nutzer ohne Konto immer die Option "E-Mail-Konto hinzufügen" wählen. Die beiden anderen Optionen sind falsch und führen zu Fehlern.',
  'onboarding.microsoft.steps.m-3a.title': 'Eventueller Zwischenschritt',
  'onboarding.microsoft.steps.m-3a.body': 'Nicht jeder hat diesen Bildschirm. Falls er erscheint ("1 Konto gefunden"), bitte auf "Überspringen" klicken.',
  'onboarding.microsoft.steps.m-4.title': 'E-Mail eintragen',
  'onboarding.microsoft.steps.m-4.body': 'Gib die von CLANDA mitgeteilte E-Mail-Adresse ein und klicke auf "Konto hinzufügen". In der Regel ist das vorname.nachname@clanda.de für Mitarbeiter und vorname.nachname@extern.clanda.de für Externe.',
  'onboarding.microsoft.steps.m-5a.title': 'Kennwort eingeben',
  'onboarding.microsoft.steps.m-5a.body': 'Hier wird das von CLANDA mitgeteilte Kennwort eingegeben. Falls das Kennwort gewechselt werden muss, folgt ein Zwischenschritt. Andernfalls bitte mit dem nächsten Schritt weiter.',
  'onboarding.microsoft.steps.m-5b.title': 'Kennwort ändern (falls verlangt)',
  'onboarding.microsoft.steps.m-5b.body': 'Das Kennwort ist abgelaufen oder war nur einmalig verwendbar. Jetzt ein sicheres Kennwort ausdenken und merken. Apple-Nutzer speichern es später in der Passwörter-App.',
  'onboarding.microsoft.steps.m-6.title': 'Konto schützen — Weiter',
  'onboarding.microsoft.steps.m-6.body': '"Lassen Sie uns Ihr Konto schützen" → auf "Weiter" klicken. Wichtig: Die Anleitung teilt sich ab hier. Apple-Nutzer folgen dieser Anleitung weiter. Android-Nutzer folgen der Microsoft-Online-Anleitung — die Anleitung endet hier für Android-Nutzer.',
  'onboarding.microsoft.steps.m-7-pre.title': 'Andere Authentifikator-App',
  'onboarding.microsoft.steps.m-7-pre.body': 'Auf "Ich möchte eine andere Authentifikator-App verwenden" tippen, dann auf "Weiter".',
  'onboarding.microsoft.steps.m-7.title': 'Geheimen Schlüssel kopieren',
  'onboarding.microsoft.steps.m-7.body': 'Den Wert vom "geheimen Schlüssel" in die Zwischenablage kopieren — dafür auf das Icon mit den zwei Papierseiten klicken.',
  'onboarding.microsoft.steps.m-8.title': 'Passwörter-App öffnen',
  'onboarding.microsoft.steps.m-8.body': 'In die Passwörter-App wechseln, indem man kurz von unten nach oben swipet und die App sucht und öffnet.',
  'onboarding.microsoft.steps.m-9.title': 'Codes öffnen',
  'onboarding.microsoft.steps.m-9.body': 'In der Passwörter-App den Bereich "Codes" durch Anklicken öffnen.',
  'onboarding.microsoft.steps.m-10.title': 'Plus-Symbol antippen',
  'onboarding.microsoft.steps.m-10.body': 'Unten rechts auf das "+" klicken, um einen neuen Bestätigungscode anzulegen.',
  'onboarding.microsoft.steps.m-11.title': 'Schlüssel einfügen',
  'onboarding.microsoft.steps.m-11.body': 'Den kopierten Wert aus Schritt 7 eintragen oder durch doppeltes Klicken in das Textfeld einsetzen. Falls das Einsetzen nicht klappt, den Code aus Schritt 7 abschreiben und eintippen.',
  'onboarding.microsoft.steps.m-12.title': 'Handschlag 1 — Konfigurationsschlüssel',
  'onboarding.microsoft.steps.m-12.body': 'Einsetzen, danach mit "Konfigurationsschlüssel verwenden" bestätigen. Wichtig: Wenn die Handschlag-Schritte 12 bis 16 nicht erfolgreich sind und du von vorne startest, muss vorher der gerade angelegte CODE gelöscht werden.',
  'onboarding.microsoft.steps.m-13.title': 'Handschlag 2 — Neues Passwort',
  'onboarding.microsoft.steps.m-13.body': 'Es erscheint ein Menü, mit dem der Code einem bereits bestehenden Passwort hinzugefügt werden kann. Wir gehen davon aus, dass das Passwort noch nicht existiert — daher hier auf das "+" tippen.',
  'onboarding.microsoft.steps.m-14.title': 'Handschlag 3 — Konto benennen',
  'onboarding.microsoft.steps.m-14.body': 'Das Konto am besten "CLANDA Microsoft" nennen. Als Benutzername die eigene CLANDA-E-Mail-Adresse eintragen (siehe Schritt 4). Als Passwort dasselbe Passwort wie unter Schritt 5 angeben. Mit "Sichern" beenden.',
  'onboarding.microsoft.steps.m-15.title': 'Handschlag 4 — Code kopieren',
  'onboarding.microsoft.steps.m-15.body': 'Danach öffnet sich das nebenstehende Fenster und der Bestätigungscode wird angezeigt. Auf den Code klicken, um ihn zu kopieren.',
  'onboarding.microsoft.steps.m-16.title': 'Handschlag 5 — Code in Outlook',
  'onboarding.microsoft.steps.m-16.body': 'Zurück in die Outlook-App wechseln und den 6-stelligen Code einfügen und mit "Weiter" bestätigen. Wenn das nicht klappt: den erstellten Code in der Passwörter-App löschen und neu starten.',
  'onboarding.microsoft.steps.m-17.title': 'Handschlag Erfolg',
  'onboarding.microsoft.steps.m-17.body': 'Erfolgsmeldung mit "Fertig" bestätigen.',
  'onboarding.microsoft.steps.m-18.title': 'Fertig',
  'onboarding.microsoft.steps.m-18.body': 'Herzlichen Glückwunsch — die Microsoft-Einrichtung ist erfolgreich abgeschlossen. Jetzt kannst du mit dem Odoo-Flow fortfahren.',

  // Odoo flow steps (7)
  'onboarding.odoo.steps.o-1.title': 'Einladungs-Mail öffnen',
  'onboarding.odoo.steps.o-1.body': 'Die E-Mail mit der Einladung von CLANDA GmbH öffnen. Voraussetzung: Microsoft-Einrichtung abgeschlossen. Wir empfehlen Chrome — Kompatibilität mit anderen Browsern wird nicht getestet.',
  'onboarding.odoo.steps.o-2.title': 'Einladung annehmen',
  'onboarding.odoo.steps.o-2.body': 'Auf "Einladung annehmen" tippen.',
  'onboarding.odoo.steps.o-3.title': 'Standardbrowser wählen',
  'onboarding.odoo.steps.o-3.body': 'Nur falls dieser Dialog erscheint: hier "Standardbrowser" wählen (nicht "Microsoft Edge").',
  'onboarding.odoo.steps.o-4.title': 'WICHTIG: Microsoft Azure',
  'onboarding.odoo.steps.o-4.body': 'Auf keinen Fall ein eigenes Passwort setzen. Die einzige Option zur Nutzung von Odoo ist immer und ausschließlich "Microsoft Azure".',
  'onboarding.odoo.steps.o-5.title': 'Teilen-Symbol',
  'onboarding.odoo.steps.o-5.body': 'Nun sollte sich die App direkt einloggen. Falls nicht, der Abfrage der Nutzerdaten von Microsoft folgen. Wir klicken hier oben auf das Teilen-Icon.',
  'onboarding.odoo.steps.o-6.title': 'Zum Home-Bildschirm',
  'onboarding.odoo.steps.o-6.body': 'Im Teilen-Menü "Zum Home-Bildschirm" suchen und auswählen.',
  'onboarding.odoo.steps.o-7.title': 'App-Symbol hinzufügen',
  'onboarding.odoo.steps.o-7.body': 'Wir ersetzen "Odoo" mit "CLANDA", lassen die URL unverändert und beenden mit "Hinzufügen". Auf dem Handy oder Tablet findet sich nun ein App-Symbol — die Einrichtung ist beendet.',

  // ── 24/7 Ops Panel (MO-CB-V15 v2 §3, SL ticket §2.G5, mock-backed) ──────
  'atc.bridge.ops247.title': '24/7 Ops Panel',
  'atc.bridge.ops247.subtitle': 'Beobachtungsfläche für den MO-247 Mechanical Loop — Polling alle 5–15s.',
  'atc.bridge.ops247.section.activeLoop': 'Active Loop',
  'atc.bridge.ops247.section.dispatchLog': 'Dispatch Event Log',
  'atc.bridge.ops247.section.pendingDispatches': 'Hängende Dispatches',
  'atc.bridge.ops247.section.idleRepos': 'Idle Repos',
  'atc.bridge.ops247.activeLoop.col.repo': 'Repo',
  'atc.bridge.ops247.activeLoop.col.mo': 'Pinned MO',
  'atc.bridge.ops247.activeLoop.col.lifecycle': 'Lifecycle',
  'atc.bridge.ops247.activeLoop.col.persona': 'Persona',
  'atc.bridge.ops247.activeLoop.col.callSign': 'Call-Sign',
  'atc.bridge.ops247.activeLoop.col.mismatch': 'Mismatch',
  'atc.bridge.ops247.activeLoop.col.pinnedSince': 'Pinned seit',
  'atc.bridge.ops247.activeLoop.col.lastSignal': 'Letztes Signal',
  'atc.bridge.ops247.activeLoop.col.lastOutcome': 'Letztes Outcome',
  'atc.bridge.ops247.eventLog.col.when': 'Wann',
  'atc.bridge.ops247.eventLog.col.type': 'Typ',
  'atc.bridge.ops247.eventLog.col.repo': 'Repo',
  'atc.bridge.ops247.eventLog.col.persona': 'Persona',
  'atc.bridge.ops247.eventLog.col.outcome': 'Outcome',
  // SfHeartbeat dashboard (BUG-FE-HEARTBEAT-STATUS-I18N-KEYS-RAW-2026-06-11):
  // the atc.bridge.heartbeat.* namespace was absent → the dashboard rendered
  // raw keys (a dark surface). German-primary.
  'atc.bridge.heartbeat.subtitle': 'Wer ist aktiv, inaktiv, hängt oder offline — Heartbeat- und Embodiment-Status.',
  'atc.bridge.heartbeat.status.alive': 'Aktiv',
  'atc.bridge.heartbeat.status.idle': 'Inaktiv',
  'atc.bridge.heartbeat.status.stuck': 'Hängt',
  'atc.bridge.heartbeat.status.unknown': 'Unbekannt',
  'atc.bridge.heartbeat.status.offline': 'Offline',
  'atc.bridge.heartbeat.location.cloud': 'Cloud',
  'atc.bridge.heartbeat.location.local': 'Lokal',
  'atc.bridge.heartbeat.col.agent': 'Agent',
  'atc.bridge.heartbeat.col.status': 'Status',
  'atc.bridge.heartbeat.col.lastSeen': 'Zuletzt gesehen',
  'atc.bridge.heartbeat.col.location': 'Standort',
  'atc.bridge.heartbeat.col.repo': 'Repo',
  'atc.bridge.heartbeat.col.embodiments': 'Embodiments',
  'atc.bridge.heartbeat.errorTitle': 'Heartbeat konnte nicht geladen werden',
  'atc.bridge.heartbeat.emptyTitle': 'Keine Agenten',
  'atc.bridge.heartbeat.emptyDesc': 'Aktuell sind keine Agenten-Heartbeats vorhanden.',
  'atc.bridge.ops247.eventLog.col.dispatchId': 'Dispatch-ID',
  'atc.bridge.ops247.eventLog.filterAll': 'Alle',
  'atc.bridge.ops247.age.justNow': 'gerade eben',
  'atc.bridge.ops247.age.minutes': 'vor {count} min',
  'atc.bridge.ops247.age.hours': 'vor {count} h',
  'atc.bridge.ops247.age.days': 'vor {count} d',
  'atc.bridge.ops247.empty.activeLoop': 'Keine aktiven Loop-Einträge.',
  'atc.bridge.ops247.empty.dispatchLog': 'Keine Dispatch-Ereignisse für diesen Filter.',
  'atc.bridge.ops247.empty.pendingDispatches': 'Keine hängenden Dispatches.',
  'atc.bridge.ops247.empty.idleRepos': 'Keine ruhenden Repos.',

  // Migration Approval Queue (SL PR #1335 / FR aadda454 §2.G3, Wave 6b)
  'atc.bridge.migrations.title': 'Migration-Freigabe-Queue',
  'atc.bridge.migrations.subtitle': 'Anstehende Datenbankmigrationen, die auf die Commander-Freigabe warten.',
  'atc.bridge.migrations.section.queue': 'Anstehende Migrationen',
  'atc.bridge.migrations.empty': 'Keine Migrationen in der Queue.',
  'atc.bridge.migrations.col.file': 'Datei',
  'atc.bridge.migrations.col.status': 'Status',
  'atc.bridge.migrations.col.requestedBy': 'Angefordert von',
  'atc.bridge.migrations.col.requestedAt': 'Angefordert am',
  'atc.bridge.migrations.col.actions': 'Aktionen',
  'atc.bridge.migrations.status.pending': 'Anstehend',
  'atc.bridge.migrations.status.approved': 'Freigegeben',
  'atc.bridge.migrations.status.applied': 'Angewendet',
  'atc.bridge.migrations.status.rejected': 'Abgelehnt',
  'atc.bridge.migrations.action.approve': 'Freigeben',
  'atc.bridge.migrations.action.reject': 'Ablehnen',
  'atc.bridge.migrations.reject.defaultReason': 'Vom Commander abgelehnt.',
  'atc.bridge.migrations.error.MIGRATION_NOT_FOUND': 'Migration nicht gefunden.',
  'atc.bridge.migrations.error.MIGRATION_ALREADY_APPROVED': 'Migration ist nicht mehr im Status „anstehend“.',
  'atc.bridge.migrations.error.MIGRATION_REJECTED': 'Migration wurde bereits abgelehnt.',
  'atc.bridge.migrations.error.MIGRATION_DRY_RUN_FAILED': 'Dry-Run fehlgeschlagen — SL meldete einen SQL-Fehler.',
  'atc.bridge.migrations.error.MIGRATION_APPLY_FAILED': 'Anwenden fehlgeschlagen, obwohl Dry-Run erfolgreich war.',
  'atc.bridge.migrations.error.WORKRIGHT_REQUIRED': 'Workright „migration-approval“ erforderlich.',
  'atc.bridge.migrations.error.FORBIDDEN': 'Verboten — Identität abgelehnt.',
  'atc.bridge.migrations.error.INTERNAL': 'Interner Fehler — SL-Logs prüfen.',

  // Agent Work Bundle view (FR-SL-COMMANDER-BRIDGE-FULL-SURFACE-V1 §2.G4)
  // Mounted at /atc/bridge/work-bundle. Wave 6c.
  'atc.bridge.workBundle.title': 'Agent Work Bundle',
  'atc.bridge.workBundle.subtitle': 'Pro Call-sign vereinte Tabelle: Personas, Embodiments, Manifest-Einträge und PRs.',
  'atc.bridge.workBundle.loading': 'Work Bundle wird geladen...',
  'atc.bridge.workBundle.error': 'Work Bundle konnte nicht geladen werden.',
  'atc.bridge.workBundle.empty': 'Keine Work-Bundle-Zeilen.',
  'atc.bridge.workBundle.col.callSign': 'Call-sign',
  'atc.bridge.workBundle.col.persona': 'Persona',
  'atc.bridge.workBundle.col.embodiment': 'Embodiment',
  'atc.bridge.workBundle.col.manifest': 'Manifest',
  'atc.bridge.workBundle.col.pr': 'PR',
  'atc.bridge.workBundle.embodiment.none': 'Kein aktives Embodiment',
  'atc.bridge.workBundle.embodiment.started': 'Gestartet',
  'atc.bridge.workBundle.embodiment.ended': 'Beendet',
  'atc.bridge.workBundle.embodiment.machine': 'Maschine',
  'atc.bridge.workBundle.manifest.closeoutProfile': 'Closeout',
  'atc.bridge.workBundle.pr.none': 'Kein PR',
  'atc.bridge.workBundle.pr.mergedAt': 'Gemerged',
  'atc.bridge.workBundle.pr.state.open': 'Offen',
  'atc.bridge.workBundle.pr.state.merged': 'Gemerged',
  'atc.bridge.workBundle.pr.state.closed': 'Geschlossen',

  // Commander PAT-Mutationen (FR-SL-COMMANDER-BRIDGE-FULL-SURFACE-V1 §2.G6)
  // ManifestRowActions nutzt diese Keys + jeden error_code. Wave 6c.
  'atc.bridge.pat.action.forceClose': 'Erzwungen schließen',
  'atc.bridge.pat.action.hold': 'Anhalten',
  'atc.bridge.pat.action.reDispatch': 'Erneut dispatchen',
  'atc.bridge.pat.action.spawn': 'Session starten',
  'atc.bridge.pat.action.cancel': 'Abbrechen',
  'atc.bridge.pat.confirm.forceCloseTitle': 'Manifest-Eintrag erzwungen schließen?',
  'atc.bridge.pat.confirm.forceCloseBody': 'Setzt den Lifecycle auf closed und überspringt ggf. Gates. Fortfahren?',
  'atc.bridge.pat.confirm.holdTitle': 'Manifest-Eintrag anhalten?',
  'atc.bridge.pat.confirm.holdBody': 'Bitte einen Grund angeben. Der Agent wird bis zur Freigabe pausiert.',
  'atc.bridge.pat.confirm.reDispatchTitle': 'Manifest-Eintrag erneut dispatchen?',
  'atc.bridge.pat.confirm.reDispatchBody': 'Der Dispatcher wird gegen diesen Eintrag erneut ausgeführt.',
  'atc.bridge.pat.confirm.spawnTitle': 'Neue Session starten?',
  'atc.bridge.pat.confirm.spawnBody': 'Die Persona wird gegen diesen Manifest-Eintrag verkörpert.',
  'atc.bridge.pat.hold.reasonLabel': 'Hold-Grund',
  'atc.bridge.pat.spawn.existingEmbodiment': 'Bestehendes Embodiment',
  // Manifest-Lifecycle PATCH error codes (force-close + hold).
  'atc.bridge.pat.error.MANIFEST_NOT_FOUND': 'Manifest-Eintrag nicht gefunden.',
  'atc.bridge.pat.error.INVALID_LIFECYCLE_TRANSITION': 'Ungültiger Lifecycle-Übergang für diesen Eintrag.',
  'atc.bridge.pat.error.LIFECYCLE_BLOCKED_BY_GATE': 'Lifecycle-Wechsel durch offenes Gate blockiert.',
  'atc.bridge.pat.error.FORBIDDEN': 'Diese Aktion ist nicht erlaubt.',
  'atc.bridge.pat.error.VERIFY_AFTER_WRITE_MISMATCH': 'Verify-After-Write-Mismatch — die Änderung wurde nicht sauber angewendet.',
  // Re-dispatch error codes.
  'atc.bridge.pat.error.NO_LIVE_TARGET': 'Keine aktive Ziel-Persona zum Dispatchen.',
  'atc.bridge.pat.error.RE_DISPATCH_RATE_LIMITED': 'Re-dispatch rate-limited; später erneut versuchen.',
  // Spawn error codes (AP-4a0ba405 — EMBODIMENT_ALREADY_ACTIVE NIE stillschweigend wiederholt).
  'atc.bridge.pat.error.PERSONA_NOT_FOUND': 'Persona nicht gefunden.',
  'atc.bridge.pat.error.SPAWN_FAILED': 'Spawn fehlgeschlagen.',
  'atc.bridge.pat.error.WORKRIGHT_REQUIRED': 'Workright erforderlich für diese Persona/Manifest-Kombination.',
  'atc.bridge.pat.error.EMBODIMENT_ALREADY_ACTIVE': 'Für diese Persona existiert bereits ein aktives Embodiment — bitte zuerst schließen.',
  'atc.bridge.pat.error.INTERNAL': 'Interner Fehler.',

  // ── Comms Hub + INBOX-SEND IACP (SL PR #1335 / Wave 6e1) ────────────────
  'atc.bridge.comms.title': 'Comms Hub',
  'atc.bridge.comms.subtitle': 'INBOX-SEND IACP 4-Mode-Signal-Writer neben dem klassischen Agent-Inbox-Composer.',
  'atc.bridge.comms.section.iacp': 'IACP 4-Mode (neu)',
  'atc.bridge.comms.section.iacp.subtitle': 'Signale über die INBOX-SEND IACP-Fläche senden — stream, reply, decision, escalation.',
  'atc.bridge.comms.section.legacy': 'Agent-Inbox (klassisch)',
  'atc.bridge.comms.section.legacy.subtitle': 'Bestehender 1:1-Chat-Composer. Während des Cutover-Fensters verfügbar.',
  'atc.bridge.iacp.send.title': 'Neues IACP-Signal',
  'atc.bridge.iacp.send.field.kind': 'Art',
  'atc.bridge.iacp.send.field.targetMode': 'Ziel-Typ',
  'atc.bridge.iacp.send.field.target_persona': 'Ziel-Persona',
  'atc.bridge.iacp.send.field.target_embodiment_id': 'Ziel-Embodiment-ID',
  'atc.bridge.iacp.send.field.in_reply_to': 'Antwort auf Signal-ID',
  'atc.bridge.iacp.send.field.dedup_key': 'Dedup-Key',
  'atc.bridge.iacp.send.field.body_text': 'Nachricht',
  'atc.bridge.iacp.send.field.requires_ack': 'Operator-Ack erforderlich',
  'atc.bridge.iacp.send.kind.stream': 'Stream',
  'atc.bridge.iacp.send.kind.reply': 'Antwort',
  'atc.bridge.iacp.send.kind.decision': 'Entscheidung',
  'atc.bridge.iacp.send.kind.escalation': 'Eskalation',
  'atc.bridge.iacp.send.targetMode.persona': 'Persona-Kürzel',
  'atc.bridge.iacp.send.targetMode.embodiment': 'Embodiment-UUID',
  'atc.bridge.iacp.send.placeholder.target_persona': 'z. B. fe-lcl2',
  'atc.bridge.iacp.send.placeholder.target_embodiment_id': 'UUID',
  'atc.bridge.iacp.send.placeholder.in_reply_to': 'UUID des Parent-Signals',
  'atc.bridge.iacp.send.placeholder.dedup_key': 'Eindeutiger Idempotenz-Key (Pflicht bei Eskalation)',
  'atc.bridge.iacp.send.placeholder.body_text': 'Markdown oder Klartext…',
  'atc.bridge.iacp.send.submit': 'Signal senden',
  'atc.bridge.iacp.send.submit.pending': 'Wird gesendet…',
  'atc.bridge.iacp.send.error.REPLY_REQUIRES_IN_REPLY_TO': 'Antwort-Modus erfordert eine Parent-Signal-ID.',
  'atc.bridge.iacp.send.error.INVALID_IN_REPLY_TO': 'Parent-Signal nicht gefunden oder ungültig.',
  'atc.bridge.iacp.send.error.TARGET_NOT_FOUND': 'Ziel-Persona oder Embodiment nicht gefunden.',
  'atc.bridge.iacp.send.error.MISSING_TARGET': 'Bitte Ziel-Persona oder Embodiment wählen.',
  'atc.bridge.iacp.send.error.INVALID_SEVERITY': 'Ungültiger Severity-Wert.',
  'atc.bridge.iacp.send.error.INVALID_KIND': 'Ungültiger Signal-Typ.',
  'atc.bridge.iacp.send.error.INBOX_SEND_FAILED': 'Senden fehlgeschlagen — der Server konnte das Signal nicht schreiben.',
  'atc.bridge.iacp.send.error.DEDUP_KEY_REQUIRES_ESCALATION': 'Dedup-Keys sind nur bei kind=escalation erlaubt.',
  'atc.bridge.iacp.send.error.FORBIDDEN': 'Sie sind nicht berechtigt, dieses Signal zu senden.',
  'atc.bridge.iacp.send.error.ATC_UNAVAILABLE': 'ATC ist vorübergehend nicht erreichbar — bitte erneut versuchen.',
  'atc.bridge.iacp.send.error.WA_DISPATCH_FAILED': 'WhatsApp-Dispatch fehlgeschlagen — der Operator wurde nicht benachrichtigt.',
  'atc.bridge.iacp.send.error.VERIFY_AFTER_WRITE_MISMATCH': 'Verify-after-write Mismatch — das Signal wurde möglicherweise nicht persistiert.',
  'atc.bridge.iacp.send.error.INBOX_SEND_UNEXPECTED_ERROR': 'Unerwarteter Server-Fehler — bitte erneut versuchen.',
  'atc.bridge.iacp.ack.title': 'Signal bestätigen',
  'atc.bridge.iacp.ack.field.ack_note': 'Ack-Notiz (optional)',
  'atc.bridge.iacp.ack.submit': 'Bestätigen',
  'atc.bridge.iacp.ack.error.INBOX_ACK_FAILED': 'Bestätigen fehlgeschlagen — Schreibfehler.',
  'atc.bridge.iacp.ack.error.FORBIDDEN': 'Sie sind nicht berechtigt, dieses Signal zu bestätigen.',
  'atc.bridge.iacp.ack.error.SIGNAL_NOT_FOUND': 'Signal nicht gefunden.',
  'atc.bridge.iacp.ack.error.ACK_NOT_REQUIRED': 'Dieses Signal erfordert keine Bestätigung.',
  'atc.bridge.iacp.ack.error.ALREADY_ACKED': 'Dieses Signal wurde bereits bestätigt.',
  'atc.bridge.iacp.ack.error.INBOX_ACK_UNEXPECTED_ERROR': 'Unerwarteter Server-Fehler — bitte erneut versuchen.',

  // Health — Flow-Heatmap (Owner × Lifecycle-Node), gespeist aus manifest-tree.
  'atc.bridge.health.title': 'Health',
  'atc.bridge.health.subtitle': 'Flow-Heatmap: offene Manifest-Einträge je Owner und Lifecycle-Node — live aus der manifest-tree View.',
  'atc.bridge.health.error': 'Health-Daten konnten nicht geladen werden.',
  'atc.bridge.health.empty.title': 'Keine Manifest-Einträge',
  'atc.bridge.health.empty.desc': 'Die manifest-tree View liefert aktuell keine Zeilen für die Heatmap.',
  'atc.bridge.health.heatmap.title': 'Flow-Heatmap (Owner × Node)',
  'atc.bridge.health.heatmap.owner': 'Owner',
  'atc.bridge.health.heatmap.open': 'offen',
  'atc.bridge.health.heatmap.total': 'gesamt',
  'atc.bridge.health.heatmap.ownersSum': 'Σ {count} Owner',
  'atc.bridge.health.filters.title': 'Filter',
  'atc.bridge.health.filters.lane': 'Lane (Owner)',
  'atc.bridge.health.filters.allLanes': 'Alle Lanes',
  'atc.bridge.health.filters.state': 'Triage-Status',
  'atc.bridge.health.filters.allStates': 'Alle Status',
  'atc.bridge.health.triage.title': 'Triage-Liste',
  'atc.bridge.health.triage.error': 'Triage-Liste konnte nicht geladen werden.',
  'atc.bridge.health.triage.empty.title': 'Keine Triage-Einträge',
  'atc.bridge.health.triage.empty.desc': 'Für die aktuelle Filterauswahl liefert die manifest-triage View keine Zeilen.',
  'atc.bridge.health.triage.col.title': 'Eintrag',
  'atc.bridge.health.triage.open': 'Workitem öffnen',
  'atc.bridge.health.triage.col.entityType': 'Typ',
  'atc.bridge.health.triage.col.owner': 'Owner',
  'atc.bridge.health.triage.col.node': 'Node',
  'atc.bridge.health.triage.col.priority': 'Prio',
  'atc.bridge.health.triage.col.state': 'Status',
  'atc.bridge.health.triage.col.blocked': 'Blockiert',
  'atc.bridge.health.triage.blocked.yes': 'Ja',
  'atc.bridge.health.triage.blocked.no': '—',
  'atc.bridge.health.scoreboard.title': 'Scoreboard',
  'atc.bridge.health.scoreboard.error': 'Scoreboard konnte nicht geladen werden.',
  'atc.bridge.health.scoreboard.empty.title': 'Kein Scoreboard',
  'atc.bridge.health.scoreboard.empty.desc': 'Für die aktuelle Lane-Auswahl liefert die manifest-health View keine Scoreboard-Zeilen.',
  'atc.bridge.health.scoreboard.col.lane': 'Lane (Owner)',
  'atc.bridge.health.scoreboard.col.node': 'Node',
  'atc.bridge.health.scoreboard.col.count': 'Anzahl',
  'atc.bridge.health.scoreboard.totalLabel': 'Σ {count} Zeilen',
  // Persona-Identitäts-Stack-Viewer — W6e2 (2026-05-23). Route /atc/bridge/personas.
  'atc.bridge.personas.title': 'Personas',
  'atc.bridge.personas.subtitle': 'Identitäts-Stack, aktive Workrights und Live-Embodiments je Agent-Persona.',
  'atc.bridge.personas.search.placeholder': 'Suche nach agent_id oder Shorthandle…',
  'atc.bridge.personas.empty': 'Keine passende Persona.',
  'atc.bridge.personas.block.identity': 'Identitäts-Stack',
  'atc.bridge.personas.block.workrights': 'Aktive Workrights',
  'atc.bridge.personas.block.embodiments': 'Aktive Embodiments',
  'atc.bridge.personas.stack.blockA': 'Block A — Universell',
  'atc.bridge.personas.stack.blockB': 'Block B — Pro Persona',
  'atc.bridge.personas.stack.emptyUniversal': 'Keine universellen Dokumente.',
  'atc.bridge.personas.stack.emptyPerPersona': 'Keine Persona-Dokumente.',
  'atc.bridge.personas.category.universal': 'universell',
  'atc.bridge.personas.category.perPersona': 'pro Persona',
  'atc.bridge.personas.status.active': 'aktiv',
  'atc.bridge.personas.status.draft': 'Entwurf',
  'atc.bridge.personas.status.superseded': 'abgelöst',
  'atc.bridge.personas.status.missing': 'fehlt',
  'atc.bridge.personas.inject': 'Inject',
  'atc.bridge.personas.header.live': '{count} live',
  'atc.bridge.personas.header.noEmbodiment': 'keine aktiven Embodiments',
  'atc.bridge.personas.header.noShorthandle': 'kein Shorthandle',
  'atc.bridge.personas.header.summary': '{docs} Doc(s) · {workrights} Workright(s) · {embodiments} live',
  'atc.bridge.personas.workrights.empty': 'Keine aktiven Workrights.',
  'atc.bridge.personas.workrights.tone.bounded': 'befristet',
  'atc.bridge.personas.workrights.tone.permanentAutoRenew': 'permanent · Auto-Renew',
  'atc.bridge.personas.workrights.tone.forbidden': 'VERBOTEN',
  'atc.bridge.personas.workrights.tone.expired': 'abgelaufen',
  'atc.bridge.personas.workrights.autoRenew': 'Auto-Renew',
  'atc.bridge.personas.workrights.more': '+{count} weitere',
  'atc.bridge.personas.workrights.expires': 'läuft ab',
  'atc.bridge.personas.embodiments.empty': 'Keine aktiven Embodiments.',
  'atc.bridge.personas.embodiments.started': 'gestartet',
  'atc.bridge.personas.lastSignal': 'letztes Signal',
  'atc.bridge.personas.age.justNow': 'gerade eben',
  'atc.bridge.personas.age.minutes': 'vor {count} min',
  'atc.bridge.personas.age.hours': 'vor {count} h',
  'atc.bridge.personas.age.days': 'vor {count} d',
  'atc.bridge.embodiments.title': 'Embodiments',
  'atc.bridge.embodiments.subtitle': 'Aktive und stillgelegte Embodiments aus agent_embodiments_unified (kanonische View).',
  'atc.bridge.embodiments.section.list': 'Embodiments',
  'atc.bridge.embodiments.filter.active': 'nur aktive',
  'atc.bridge.embodiments.filter.all': 'alle',
  'atc.bridge.embodiments.filter.host.label': 'Host',
  'atc.bridge.embodiments.filter.host.allHosts': 'alle Hosts',
  'atc.bridge.embodiments.col.agentId': 'Agent-ID',
  'atc.bridge.embodiments.col.shorthandle': 'Kürzel',
  'atc.bridge.embodiments.col.machine': 'Maschine',
  'atc.bridge.embodiments.col.vendor': 'Vendor',
  'atc.bridge.embodiments.col.status': 'Status',
  'atc.bridge.embodiments.col.startedAt': 'Gestartet am',
  'atc.bridge.embodiments.col.retiredAt': 'Stillgelegt am',
  'atc.bridge.embodiments.col.sessionLocation': 'Session / Ort',
  'atc.bridge.embodiments.col.source': 'Quelle',
  'atc.bridge.embodiments.activeBadge': 'aktiv',
  'atc.bridge.embodiments.empty': 'Keine Embodiments entsprechen dem aktuellen Filter.',
  'atc.bridge.embodiments.loading': 'Embodiments werden geladen …',
  'atc.bridge.embodiments.error': 'Embodiments konnten nicht geladen werden.',
  'atc.bridge.embodiments.diagnostics.summary': '{active} aktiv / {total} gesamt / {hosts} Hosts',
  'atc.bridge.embodiments.slGapNote': 'Hinweis: Session-Turn, CTX %, Work-Item, Workright und Phantom-Sessions werden von der View agent_embodiments_unified noch nicht geliefert (benötigt eine SL-Join-Slug).',
  // Rich parity surface (View embodiments-tracking) — Session + Workright +
  // CTX % + Phantom-Erkennung, vollständige Parität mit dem god-mode-Tab.
  'atc.bridge.embodiments.tracking.title': 'Live-Embodiments (Tracking)',
  'atc.bridge.embodiments.tracking.subtitle': 'Nur LIVE-Sessions (retired_at IS NULL): Identität (agent_id + Embodiment-UUID), Maschine, CTX %, letzter Turn, Node, Work-Item und Workright pro Embodiment aus der View embodiments-tracking.',
  'atc.bridge.embodiments.tracking.liveCount': '{count} Live-Session(s)',
  'atc.bridge.embodiments.tracking.phantomFlag': 'Phantom ({count})',
  'atc.bridge.embodiments.tracking.lastTurn': 'letzter Turn: {when}',
  'atc.bridge.embodiments.col.agent': 'Agent',
  'atc.bridge.embodiments.col.embodiment': 'Embodiment',
  'atc.bridge.embodiments.col.session': 'Session',
  'atc.bridge.embodiments.col.ctx': 'CTX %',
  'atc.bridge.embodiments.col.lastTurnAge': 'Letzter Turn',
  'atc.bridge.embodiments.col.workItem': 'Work-Item',
  'atc.bridge.embodiments.col.workright': 'Workright',
  'atc.bridge.embodiments.col.lcout': 'LCOUT / LCIN',
  'atc.bridge.embodiments.col.boot': 'Boot',
  'atc.bridge.embodiments.col.phantom': 'Phantom',
  // SL-Dep-Hinweis: Spalten, die die Admin-Surface des Operators zeigt, die
  // der typisierte embodiments-tracking-Vertrag aber noch NICHT liefert
  // (Rolle, ORIENT-Brick-B-Gate held/cleared, Session≡Embodiment-Link).
  'atc.bridge.embodiments.slDepColumns': 'Noch nicht im typisierten Vertrag (SL-Dep): Rolle, ORIENT-Brick-B-Gate (held/cleared), Session≡Embodiment-Link. Weggelassen statt gefälscht.',
}
